"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Mandolin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1.343-dev.d889c8c
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultApi = exports.DefaultApiFactory = exports.DefaultApiFp = exports.DefaultApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const base_1 = require("../base");
/**
 * DefaultApi - axios parameter creator
 * @export
 */
exports.DefaultApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {AcceptConsentRequestDTO} acceptConsentRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptConsent: (acceptConsentRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'acceptConsentRequestDTO' is not null or undefined
            if (acceptConsentRequestDTO === null || acceptConsentRequestDTO === undefined) {
                throw new base_1.RequiredError('acceptConsentRequestDTO', 'Required parameter acceptConsentRequestDTO was null or undefined when calling acceptConsent.');
            }
            const localVarPath = `/v1/consent/accept`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", ["authenticated"])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof acceptConsentRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(acceptConsentRequestDTO !== undefined ? acceptConsentRequestDTO : {}) : (acceptConsentRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptTOS: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/accept-tos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", ["authenticated"])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CreateCsatSurveyEntryRequestDTO} createCsatSurveyEntryRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSurveyToEvent: (createCsatSurveyEntryRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createCsatSurveyEntryRequestDTO' is not null or undefined
            if (createCsatSurveyEntryRequestDTO === null || createCsatSurveyEntryRequestDTO === undefined) {
                throw new base_1.RequiredError('createCsatSurveyEntryRequestDTO', 'Required parameter createCsatSurveyEntryRequestDTO was null or undefined when calling addSurveyToEvent.');
            }
            const localVarPath = `/admin/v1/surveys/addSurveyToEvent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof createCsatSurveyEntryRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(createCsatSurveyEntryRequestDTO !== undefined ? createCsatSurveyEntryRequestDTO : {}) : (createCsatSurveyEntryRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<UpdateIAPPriceMapDTOItem>} updateIAPPriceMapDTOItem
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAddIAPPriceMapItem: (updateIAPPriceMapDTOItem, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'updateIAPPriceMapDTOItem' is not null or undefined
            if (updateIAPPriceMapDTOItem === null || updateIAPPriceMapDTOItem === undefined) {
                throw new base_1.RequiredError('updateIAPPriceMapDTOItem', 'Required parameter updateIAPPriceMapDTOItem was null or undefined when calling adminAddIAPPriceMapItem.');
            }
            const localVarPath = `/admin/v1/eventIAPPriceMap/add`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof updateIAPPriceMapDTOItem !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(updateIAPPriceMapDTOItem !== undefined ? updateIAPPriceMapDTOItem : {}) : (updateIAPPriceMapDTOItem || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminApprovePreRecord: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling adminApprovePreRecord.');
            }
            const localVarPath = `/admin/v1/show/approvePreRecord/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {InlineObject1} inlineObject1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminChangeShowState: (id, inlineObject1, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling adminChangeShowState.');
            }
            // verify required parameter 'inlineObject1' is not null or undefined
            if (inlineObject1 === null || inlineObject1 === undefined) {
                throw new base_1.RequiredError('inlineObject1', 'Required parameter inlineObject1 was null or undefined when calling adminChangeShowState.');
            }
            const localVarPath = `/admin/v1/show/changeState/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof inlineObject1 !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(inlineObject1 !== undefined ? inlineObject1 : {}) : (inlineObject1 || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {AdminCreateArtistRequestDTO} adminCreateArtistRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateArtist: (adminCreateArtistRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'adminCreateArtistRequestDTO' is not null or undefined
            if (adminCreateArtistRequestDTO === null || adminCreateArtistRequestDTO === undefined) {
                throw new base_1.RequiredError('adminCreateArtistRequestDTO', 'Required parameter adminCreateArtistRequestDTO was null or undefined when calling adminCreateArtist.');
            }
            const localVarPath = `/admin/v1/artist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof adminCreateArtistRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(adminCreateArtistRequestDTO !== undefined ? adminCreateArtistRequestDTO : {}) : (adminCreateArtistRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {AdminCreateCobrandRequestDTO} adminCreateCobrandRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateCobrand: (adminCreateCobrandRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'adminCreateCobrandRequestDTO' is not null or undefined
            if (adminCreateCobrandRequestDTO === null || adminCreateCobrandRequestDTO === undefined) {
                throw new base_1.RequiredError('adminCreateCobrandRequestDTO', 'Required parameter adminCreateCobrandRequestDTO was null or undefined when calling adminCreateCobrand.');
            }
            const localVarPath = `/admin/v1/cobrand`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof adminCreateCobrandRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(adminCreateCobrandRequestDTO !== undefined ? adminCreateCobrandRequestDTO : {}) : (adminCreateCobrandRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ICreateEventSetBody} iCreateEventSetBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateEventSet: (iCreateEventSetBody, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'iCreateEventSetBody' is not null or undefined
            if (iCreateEventSetBody === null || iCreateEventSetBody === undefined) {
                throw new base_1.RequiredError('iCreateEventSetBody', 'Required parameter iCreateEventSetBody was null or undefined when calling adminCreateEventSet.');
            }
            const localVarPath = `/admin/v1/eventSet`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof iCreateEventSetBody !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(iCreateEventSetBody !== undefined ? iCreateEventSetBody : {}) : (iCreateEventSetBody || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {AdminCreateEventStreamDetailsRequestDTO} adminCreateEventStreamDetailsRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateEventStreamDetails: (adminCreateEventStreamDetailsRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'adminCreateEventStreamDetailsRequestDTO' is not null or undefined
            if (adminCreateEventStreamDetailsRequestDTO === null || adminCreateEventStreamDetailsRequestDTO === undefined) {
                throw new base_1.RequiredError('adminCreateEventStreamDetailsRequestDTO', 'Required parameter adminCreateEventStreamDetailsRequestDTO was null or undefined when calling adminCreateEventStreamDetails.');
            }
            const localVarPath = `/admin/v1/event/streamDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof adminCreateEventStreamDetailsRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(adminCreateEventStreamDetailsRequestDTO !== undefined ? adminCreateEventStreamDetailsRequestDTO : {}) : (adminCreateEventStreamDetailsRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CreateIAPConfigRequestDTO} createIAPConfigRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateIAPConfig: (createIAPConfigRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createIAPConfigRequestDTO' is not null or undefined
            if (createIAPConfigRequestDTO === null || createIAPConfigRequestDTO === undefined) {
                throw new base_1.RequiredError('createIAPConfigRequestDTO', 'Required parameter createIAPConfigRequestDTO was null or undefined when calling adminCreateIAPConfig.');
            }
            const localVarPath = `/admin/v1/eventIAPConfig`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof createIAPConfigRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(createIAPConfigRequestDTO !== undefined ? createIAPConfigRequestDTO : {}) : (createIAPConfigRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {AdminCreateNftTokenRequestDTO} adminCreateNftTokenRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateNftToken: (adminCreateNftTokenRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'adminCreateNftTokenRequestDTO' is not null or undefined
            if (adminCreateNftTokenRequestDTO === null || adminCreateNftTokenRequestDTO === undefined) {
                throw new base_1.RequiredError('adminCreateNftTokenRequestDTO', 'Required parameter adminCreateNftTokenRequestDTO was null or undefined when calling adminCreateNftToken.');
            }
            const localVarPath = `/admin/v1/nft`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof adminCreateNftTokenRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(adminCreateNftTokenRequestDTO !== undefined ? adminCreateNftTokenRequestDTO : {}) : (adminCreateNftTokenRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {AdminCreateOrganizationRequestDTO} adminCreateOrganizationRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateOrganization: (adminCreateOrganizationRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'adminCreateOrganizationRequestDTO' is not null or undefined
            if (adminCreateOrganizationRequestDTO === null || adminCreateOrganizationRequestDTO === undefined) {
                throw new base_1.RequiredError('adminCreateOrganizationRequestDTO', 'Required parameter adminCreateOrganizationRequestDTO was null or undefined when calling adminCreateOrganization.');
            }
            const localVarPath = `/admin/v1/organization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof adminCreateOrganizationRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(adminCreateOrganizationRequestDTO !== undefined ? adminCreateOrganizationRequestDTO : {}) : (adminCreateOrganizationRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {AdminCreateShowRequestDTO} adminCreateShowRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateShow: (adminCreateShowRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'adminCreateShowRequestDTO' is not null or undefined
            if (adminCreateShowRequestDTO === null || adminCreateShowRequestDTO === undefined) {
                throw new base_1.RequiredError('adminCreateShowRequestDTO', 'Required parameter adminCreateShowRequestDTO was null or undefined when calling adminCreateShow.');
            }
            const localVarPath = `/admin/v1/show`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof adminCreateShowRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(adminCreateShowRequestDTO !== undefined ? adminCreateShowRequestDTO : {}) : (adminCreateShowRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {AdminCreateVenueRequestDTO} adminCreateVenueRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateVenue: (adminCreateVenueRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'adminCreateVenueRequestDTO' is not null or undefined
            if (adminCreateVenueRequestDTO === null || adminCreateVenueRequestDTO === undefined) {
                throw new base_1.RequiredError('adminCreateVenueRequestDTO', 'Required parameter adminCreateVenueRequestDTO was null or undefined when calling adminCreateVenue.');
            }
            const localVarPath = `/admin/v1/venue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof adminCreateVenueRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(adminCreateVenueRequestDTO !== undefined ? adminCreateVenueRequestDTO : {}) : (adminCreateVenueRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CreateVideoAssetDTO} createVideoAssetDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateVideoAsset: (createVideoAssetDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createVideoAssetDTO' is not null or undefined
            if (createVideoAssetDTO === null || createVideoAssetDTO === undefined) {
                throw new base_1.RequiredError('createVideoAssetDTO', 'Required parameter createVideoAssetDTO was null or undefined when calling adminCreateVideoAsset.');
            }
            const localVarPath = `/admin/v1/videoAsset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof createVideoAssetDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(createVideoAssetDTO !== undefined ? createVideoAssetDTO : {}) : (createVideoAssetDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateVideoAssetUploadUrl: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/v1/videoAsset/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteArtist: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling adminDeleteArtist.');
            }
            const localVarPath = `/admin/v1/artist/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteCobrand: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling adminDeleteCobrand.');
            }
            const localVarPath = `/admin/v1/cobrand/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteEventStreamDetails: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling adminDeleteEventStreamDetails.');
            }
            const localVarPath = `/admin/v1/event/streamDetails/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteIAPConfig: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling adminDeleteIAPConfig.');
            }
            const localVarPath = `/admin/v1/eventIAPConfig/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteNftToken: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling adminDeleteNftToken.');
            }
            const localVarPath = `/admin/v1/nft/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteOrganization: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling adminDeleteOrganization.');
            }
            const localVarPath = `/admin/v1/organization/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {AdminDeleteShopifyStoreRequestDTO} adminDeleteShopifyStoreRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteShopifyStore: (adminDeleteShopifyStoreRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'adminDeleteShopifyStoreRequestDTO' is not null or undefined
            if (adminDeleteShopifyStoreRequestDTO === null || adminDeleteShopifyStoreRequestDTO === undefined) {
                throw new base_1.RequiredError('adminDeleteShopifyStoreRequestDTO', 'Required parameter adminDeleteShopifyStoreRequestDTO was null or undefined when calling adminDeleteShopifyStore.');
            }
            const localVarPath = `/admin/v1/shopifyStore`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof adminDeleteShopifyStoreRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(adminDeleteShopifyStoreRequestDTO !== undefined ? adminDeleteShopifyStoreRequestDTO : {}) : (adminDeleteShopifyStoreRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteShow: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling adminDeleteShow.');
            }
            const localVarPath = `/admin/v1/show/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} venueId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteVenue: (venueId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'venueId' is not null or undefined
            if (venueId === null || venueId === undefined) {
                throw new base_1.RequiredError('venueId', 'Required parameter venueId was null or undefined when calling adminDeleteVenue.');
            }
            const localVarPath = `/admin/v1/venue/{venueId}`
                .replace(`{${"venueId"}}`, encodeURIComponent(String(venueId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteVideoAsset: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling adminDeleteVideoAsset.');
            }
            const localVarPath = `/admin/v1/videoAsset/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {AdminEditShowRequestDTO} adminEditShowRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEditShow: (id, adminEditShowRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling adminEditShow.');
            }
            // verify required parameter 'adminEditShowRequestDTO' is not null or undefined
            if (adminEditShowRequestDTO === null || adminEditShowRequestDTO === undefined) {
                throw new base_1.RequiredError('adminEditShowRequestDTO', 'Required parameter adminEditShowRequestDTO was null or undefined when calling adminEditShow.');
            }
            const localVarPath = `/admin/v1/show/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof adminEditShowRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(adminEditShowRequestDTO !== undefined ? adminEditShowRequestDTO : {}) : (adminEditShowRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {IAddEventsBody} iAddEventsBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventSetAddEvents: (id, iAddEventsBody, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling adminEventSetAddEvents.');
            }
            // verify required parameter 'iAddEventsBody' is not null or undefined
            if (iAddEventsBody === null || iAddEventsBody === undefined) {
                throw new base_1.RequiredError('iAddEventsBody', 'Required parameter iAddEventsBody was null or undefined when calling adminEventSetAddEvents.');
            }
            const localVarPath = `/admin/v1/eventSet/{id}/addEvents`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof iAddEventsBody !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(iAddEventsBody !== undefined ? iAddEventsBody : {}) : (iAddEventsBody || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {IRemoveEventsBody} iRemoveEventsBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventSetRemoveEvents: (id, iRemoveEventsBody, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling adminEventSetRemoveEvents.');
            }
            // verify required parameter 'iRemoveEventsBody' is not null or undefined
            if (iRemoveEventsBody === null || iRemoveEventsBody === undefined) {
                throw new base_1.RequiredError('iRemoveEventsBody', 'Required parameter iRemoveEventsBody was null or undefined when calling adminEventSetRemoveEvents.');
            }
            const localVarPath = `/admin/v1/eventSet/{id}/removeEvents`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof iRemoveEventsBody !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(iRemoveEventsBody !== undefined ? iRemoveEventsBody : {}) : (iRemoveEventsBody || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetEventSet: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling adminGetEventSet.');
            }
            const localVarPath = `/admin/v1/eventSet/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetEventStreamDetails: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling adminGetEventStreamDetails.');
            }
            const localVarPath = `/admin/v1/event/streamDetails/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetIAPConfig: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling adminGetIAPConfig.');
            }
            const localVarPath = `/admin/v1/eventIAPConfig/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetIAPPriceMap: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/v1/eventIAPPriceMap`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetOrganization: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling adminGetOrganization.');
            }
            const localVarPath = `/admin/v1/organization/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetShow: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling adminGetShow.');
            }
            const localVarPath = `/admin/v1/show/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns the stream details to the passed show for the currently authenticated user.  - includes ephemeral signed URLs for the both the public and admin replay tool endpoints    (the admin one simply allows viewing a replay with any trim values)
         * @param {string} showId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetShowStreamDetails: (showId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'showId' is not null or undefined
            if (showId === null || showId === undefined) {
                throw new base_1.RequiredError('showId', 'Required parameter showId was null or undefined when calling adminGetShowStreamDetails.');
            }
            const localVarPath = `/admin/v1/show/streamDetails/{showId}`
                .replace(`{${"showId"}}`, encodeURIComponent(String(showId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListAppleInAppPurchaseProduct: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/v1/appleInAppPurchaseProduct`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {EventSetSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListEventSets: (sortBy, sortOrder, startAfter, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/v1/eventSet`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }
            if (startAfter !== undefined) {
                localVarQueryParameter['startAfter'] = startAfter;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [id]
         * @param {string} [eventId]
         * @param {EventIAPSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListIAPConfig: (id, eventId, sortBy, sortOrder, startAfter, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/v1/eventIAPConfig`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (eventId !== undefined) {
                localVarQueryParameter['eventId'] = eventId;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }
            if (startAfter !== undefined) {
                localVarQueryParameter['startAfter'] = startAfter;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {OrganizationSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {string} [name]
         * @param {string} [displayName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListOrganizations: (sortBy, sortOrder, startAfter, limit, name, displayName, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/v1/organization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }
            if (startAfter !== undefined) {
                localVarQueryParameter['startAfter'] = startAfter;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (displayName !== undefined) {
                localVarQueryParameter['displayName'] = displayName;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [cobrand]
         * @param {string} [venueId]
         * @param {string} [artistId]
         * @param {string} [organizationId]
         * @param {Array<ShowType>} [type]
         * @param {string} [shopifyProductTag]
         * @param {string} [shopifyMerchTag]
         * @param {string} [muxId]
         * @param {boolean} [autoSchedule]
         * @param {Array<ShowState>} [state]
         * @param {string} [beforeDate]
         * @param {ShowSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 10000
         * @param {boolean} [excludePast] whether past shows should be included in the response. This parameter is incompatible with passing &#x60;sortBy&#x60; unless specific Firestore indices are created to support compound queries
         * @param {Array<AdminShowIncludes>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListShows: (cobrand, venueId, artistId, organizationId, type, shopifyProductTag, shopifyMerchTag, muxId, autoSchedule, state, beforeDate, sortBy, sortOrder, startAfter, limit, excludePast, include, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/v1/show`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (cobrand !== undefined) {
                localVarQueryParameter['cobrand'] = cobrand;
            }
            if (venueId !== undefined) {
                localVarQueryParameter['venueId'] = venueId;
            }
            if (artistId !== undefined) {
                localVarQueryParameter['artistId'] = artistId;
            }
            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }
            if (type) {
                localVarQueryParameter['type'] = type;
            }
            if (shopifyProductTag !== undefined) {
                localVarQueryParameter['shopifyProductTag'] = shopifyProductTag;
            }
            if (shopifyMerchTag !== undefined) {
                localVarQueryParameter['shopifyMerchTag'] = shopifyMerchTag;
            }
            if (muxId !== undefined) {
                localVarQueryParameter['muxId'] = muxId;
            }
            if (autoSchedule !== undefined) {
                localVarQueryParameter['autoSchedule'] = autoSchedule;
            }
            if (state) {
                localVarQueryParameter['state'] = state;
            }
            if (beforeDate !== undefined) {
                localVarQueryParameter['beforeDate'] = (beforeDate instanceof Date) ?
                    beforeDate.toISOString() :
                    beforeDate;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }
            if (startAfter !== undefined) {
                localVarQueryParameter['startAfter'] = startAfter;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (excludePast !== undefined) {
                localVarQueryParameter['excludePast'] = excludePast;
            }
            if (include) {
                localVarQueryParameter['include'] = include;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [managerId]
         * @param {string} [email]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 10000
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListShowsByManager: (managerId, email, startAfter, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/v1/show/manager`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (managerId !== undefined) {
                localVarQueryParameter['managerId'] = managerId;
            }
            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }
            if (startAfter !== undefined) {
                localVarQueryParameter['startAfter'] = startAfter;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {string} [eventId]
         * @param {string} [artistId]
         * @param {string} [venueId]
         * @param {string} [organizationId]
         * @param {string} [search]
         * @param {string} [tags]
         * @param {boolean} [videoAssetIsPublic]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListVideoAssets: (startAfter, limit, eventId, artistId, venueId, organizationId, search, tags, videoAssetIsPublic, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/v1/videoAsset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (startAfter !== undefined) {
                localVarQueryParameter['startAfter'] = startAfter;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (eventId !== undefined) {
                localVarQueryParameter['eventId'] = eventId;
            }
            if (artistId !== undefined) {
                localVarQueryParameter['artistId'] = artistId;
            }
            if (venueId !== undefined) {
                localVarQueryParameter['venueId'] = venueId;
            }
            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            if (tags !== undefined) {
                localVarQueryParameter['tags'] = tags;
            }
            if (videoAssetIsPublic !== undefined) {
                localVarQueryParameter['videoAssetIsPublic'] = videoAssetIsPublic;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {InlineObject} inlineObject
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRemoveIAPPriceMapItem: (inlineObject, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'inlineObject' is not null or undefined
            if (inlineObject === null || inlineObject === undefined) {
                throw new base_1.RequiredError('inlineObject', 'Required parameter inlineObject was null or undefined when calling adminRemoveIAPPriceMapItem.');
            }
            const localVarPath = `/admin/v1/eventIAPPriceMap/remove`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof inlineObject !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(inlineObject !== undefined ? inlineObject : {}) : (inlineObject || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {number} [minDays]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSpotifyRefresh: (id, minDays, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling adminSpotifyRefresh.');
            }
            const localVarPath = `/admin/v1/artist/{id}/spotifyRefresh`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (minDays !== undefined) {
                localVarQueryParameter['minDays'] = minDays;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {AdminUpdateArtistRequestDTO} adminUpdateArtistRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateArtist: (id, adminUpdateArtistRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling adminUpdateArtist.');
            }
            // verify required parameter 'adminUpdateArtistRequestDTO' is not null or undefined
            if (adminUpdateArtistRequestDTO === null || adminUpdateArtistRequestDTO === undefined) {
                throw new base_1.RequiredError('adminUpdateArtistRequestDTO', 'Required parameter adminUpdateArtistRequestDTO was null or undefined when calling adminUpdateArtist.');
            }
            const localVarPath = `/admin/v1/artist/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof adminUpdateArtistRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(adminUpdateArtistRequestDTO !== undefined ? adminUpdateArtistRequestDTO : {}) : (adminUpdateArtistRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {AdminUpdateCobrandRequestDTO} adminUpdateCobrandRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateCobrand: (id, adminUpdateCobrandRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling adminUpdateCobrand.');
            }
            // verify required parameter 'adminUpdateCobrandRequestDTO' is not null or undefined
            if (adminUpdateCobrandRequestDTO === null || adminUpdateCobrandRequestDTO === undefined) {
                throw new base_1.RequiredError('adminUpdateCobrandRequestDTO', 'Required parameter adminUpdateCobrandRequestDTO was null or undefined when calling adminUpdateCobrand.');
            }
            const localVarPath = `/admin/v1/cobrand/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof adminUpdateCobrandRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(adminUpdateCobrandRequestDTO !== undefined ? adminUpdateCobrandRequestDTO : {}) : (adminUpdateCobrandRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {IUpdateEventStreamDetailsUseCase} iUpdateEventStreamDetailsUseCase
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateEventStreamDetails: (id, iUpdateEventStreamDetailsUseCase, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling adminUpdateEventStreamDetails.');
            }
            // verify required parameter 'iUpdateEventStreamDetailsUseCase' is not null or undefined
            if (iUpdateEventStreamDetailsUseCase === null || iUpdateEventStreamDetailsUseCase === undefined) {
                throw new base_1.RequiredError('iUpdateEventStreamDetailsUseCase', 'Required parameter iUpdateEventStreamDetailsUseCase was null or undefined when calling adminUpdateEventStreamDetails.');
            }
            const localVarPath = `/admin/v1/event/streamDetails/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof iUpdateEventStreamDetailsUseCase !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(iUpdateEventStreamDetailsUseCase !== undefined ? iUpdateEventStreamDetailsUseCase : {}) : (iUpdateEventStreamDetailsUseCase || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {UpdateIAPConfigRequestDTO} updateIAPConfigRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateIAPConfig: (id, updateIAPConfigRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling adminUpdateIAPConfig.');
            }
            // verify required parameter 'updateIAPConfigRequestDTO' is not null or undefined
            if (updateIAPConfigRequestDTO === null || updateIAPConfigRequestDTO === undefined) {
                throw new base_1.RequiredError('updateIAPConfigRequestDTO', 'Required parameter updateIAPConfigRequestDTO was null or undefined when calling adminUpdateIAPConfig.');
            }
            const localVarPath = `/admin/v1/eventIAPConfig/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof updateIAPConfigRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(updateIAPConfigRequestDTO !== undefined ? updateIAPConfigRequestDTO : {}) : (updateIAPConfigRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {AdminUpdateNftTokenRequestDTO} adminUpdateNftTokenRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateNftToken: (id, adminUpdateNftTokenRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling adminUpdateNftToken.');
            }
            // verify required parameter 'adminUpdateNftTokenRequestDTO' is not null or undefined
            if (adminUpdateNftTokenRequestDTO === null || adminUpdateNftTokenRequestDTO === undefined) {
                throw new base_1.RequiredError('adminUpdateNftTokenRequestDTO', 'Required parameter adminUpdateNftTokenRequestDTO was null or undefined when calling adminUpdateNftToken.');
            }
            const localVarPath = `/admin/v1/nft/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof adminUpdateNftTokenRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(adminUpdateNftTokenRequestDTO !== undefined ? adminUpdateNftTokenRequestDTO : {}) : (adminUpdateNftTokenRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {AdminUpdateOrganizationRequestDTO} adminUpdateOrganizationRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateOrganization: (id, adminUpdateOrganizationRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling adminUpdateOrganization.');
            }
            // verify required parameter 'adminUpdateOrganizationRequestDTO' is not null or undefined
            if (adminUpdateOrganizationRequestDTO === null || adminUpdateOrganizationRequestDTO === undefined) {
                throw new base_1.RequiredError('adminUpdateOrganizationRequestDTO', 'Required parameter adminUpdateOrganizationRequestDTO was null or undefined when calling adminUpdateOrganization.');
            }
            const localVarPath = `/admin/v1/organization/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof adminUpdateOrganizationRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(adminUpdateOrganizationRequestDTO !== undefined ? adminUpdateOrganizationRequestDTO : {}) : (adminUpdateOrganizationRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {AdminUpdateShopifyStoreRequestDTO} adminUpdateShopifyStoreRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateShopifyStore: (adminUpdateShopifyStoreRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'adminUpdateShopifyStoreRequestDTO' is not null or undefined
            if (adminUpdateShopifyStoreRequestDTO === null || adminUpdateShopifyStoreRequestDTO === undefined) {
                throw new base_1.RequiredError('adminUpdateShopifyStoreRequestDTO', 'Required parameter adminUpdateShopifyStoreRequestDTO was null or undefined when calling adminUpdateShopifyStore.');
            }
            const localVarPath = `/admin/v1/shopifyStore`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof adminUpdateShopifyStoreRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(adminUpdateShopifyStoreRequestDTO !== undefined ? adminUpdateShopifyStoreRequestDTO : {}) : (adminUpdateShopifyStoreRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} venueId
         * @param {AdminUpdateVenueRequestDTO} adminUpdateVenueRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateVenue: (venueId, adminUpdateVenueRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'venueId' is not null or undefined
            if (venueId === null || venueId === undefined) {
                throw new base_1.RequiredError('venueId', 'Required parameter venueId was null or undefined when calling adminUpdateVenue.');
            }
            // verify required parameter 'adminUpdateVenueRequestDTO' is not null or undefined
            if (adminUpdateVenueRequestDTO === null || adminUpdateVenueRequestDTO === undefined) {
                throw new base_1.RequiredError('adminUpdateVenueRequestDTO', 'Required parameter adminUpdateVenueRequestDTO was null or undefined when calling adminUpdateVenue.');
            }
            const localVarPath = `/admin/v1/venue/{venueId}`
                .replace(`{${"venueId"}}`, encodeURIComponent(String(venueId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof adminUpdateVenueRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(adminUpdateVenueRequestDTO !== undefined ? adminUpdateVenueRequestDTO : {}) : (adminUpdateVenueRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {UpdateVideoAssetRequest} updateVideoAssetRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateVideoAsset: (updateVideoAssetRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'updateVideoAssetRequest' is not null or undefined
            if (updateVideoAssetRequest === null || updateVideoAssetRequest === undefined) {
                throw new base_1.RequiredError('updateVideoAssetRequest', 'Required parameter updateVideoAssetRequest was null or undefined when calling adminUpdateVideoAsset.');
            }
            const localVarPath = `/admin/v1/videoAsset/updateVideoAsset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof updateVideoAssetRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(updateVideoAssetRequest !== undefined ? updateVideoAssetRequest : {}) : (updateVideoAssetRequest || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} userId
         * @param {PresenterOrganizationRoleDTO} presenterOrganizationRoleDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignMemberRoles: (userId, presenterOrganizationRoleDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new base_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling assignMemberRoles.');
            }
            // verify required parameter 'presenterOrganizationRoleDTO' is not null or undefined
            if (presenterOrganizationRoleDTO === null || presenterOrganizationRoleDTO === undefined) {
                throw new base_1.RequiredError('presenterOrganizationRoleDTO', 'Required parameter presenterOrganizationRoleDTO was null or undefined when calling assignMemberRoles.');
            }
            const localVarPath = `/v1/organization/members/{userId}/roles/assign`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof presenterOrganizationRoleDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(presenterOrganizationRoleDTO !== undefined ? presenterOrganizationRoleDTO : {}) : (presenterOrganizationRoleDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {AssociateFileDefinitionRequestDTO} associateFileDefinitionRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        associateFileDefinition: (associateFileDefinitionRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'associateFileDefinitionRequestDTO' is not null or undefined
            if (associateFileDefinitionRequestDTO === null || associateFileDefinitionRequestDTO === undefined) {
                throw new base_1.RequiredError('associateFileDefinitionRequestDTO', 'Required parameter associateFileDefinitionRequestDTO was null or undefined when calling associateFileDefinition.');
            }
            const localVarPath = `/fanData/v1/csvUpload/associateFileDefinition`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", ["fanDataConfigure"])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof associateFileDefinitionRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(associateFileDefinitionRequestDTO !== undefined ? associateFileDefinitionRequestDTO : {}) : (associateFileDefinitionRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} paymentMethodId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachPaymentMethodToCustomer: (paymentMethodId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'paymentMethodId' is not null or undefined
            if (paymentMethodId === null || paymentMethodId === undefined) {
                throw new base_1.RequiredError('paymentMethodId', 'Required parameter paymentMethodId was null or undefined when calling attachPaymentMethodToCustomer.');
            }
            const localVarPath = `/v1/customers/attachPaymentMethod/{paymentMethodId}`
                .replace(`{${"paymentMethodId"}}`, encodeURIComponent(String(paymentMethodId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", ["accessBilling"])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [venueId]
         * @param {string} [artistId]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bandsintownListShows: (venueId, artistId, startAfter, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/external-integration/v1/bandsintown/show`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication partnerApiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? yield configuration.apiKey("X-Api-Key")
                    : yield configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            if (venueId !== undefined) {
                localVarQueryParameter['venueId'] = venueId;
            }
            if (artistId !== undefined) {
                localVarQueryParameter['artistId'] = artistId;
            }
            if (startAfter !== undefined) {
                localVarQueryParameter['startAfter'] = startAfter;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} topic
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkForUserSubscriptionByTopic: (topic, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'topic' is not null or undefined
            if (topic === null || topic === undefined) {
                throw new base_1.RequiredError('topic', 'Required parameter topic was null or undefined when calling checkForUserSubscriptionByTopic.');
            }
            const localVarPath = `/v1/pushSubscriptions/checkMySubscription/{topic}`
                .replace(`{${"topic"}}`, encodeURIComponent(String(topic)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkForUserSurveyResponseByEventId: (eventId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'eventId' is not null or undefined
            if (eventId === null || eventId === undefined) {
                throw new base_1.RequiredError('eventId', 'Required parameter eventId was null or undefined when calling checkForUserSurveyResponseByEventId.');
            }
            const localVarPath = `/v1/surveys/surveysByUser/{eventId}`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} eventId
         * @param {VIPExperienceCheckInRequest} vIPExperienceCheckInRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkInToVIPExperience: (eventId, vIPExperienceCheckInRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'eventId' is not null or undefined
            if (eventId === null || eventId === undefined) {
                throw new base_1.RequiredError('eventId', 'Required parameter eventId was null or undefined when calling checkInToVIPExperience.');
            }
            // verify required parameter 'vIPExperienceCheckInRequest' is not null or undefined
            if (vIPExperienceCheckInRequest === null || vIPExperienceCheckInRequest === undefined) {
                throw new base_1.RequiredError('vIPExperienceCheckInRequest', 'Required parameter vIPExperienceCheckInRequest was null or undefined when calling checkInToVIPExperience.');
            }
            const localVarPath = `/v1/experience/vip/participant/checkIn/{eventId}`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof vIPExperienceCheckInRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(vIPExperienceCheckInRequest !== undefined ? vIPExperienceCheckInRequest : {}) : (vIPExperienceCheckInRequest || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ClaimByCodeRequestDTO} claimByCodeRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claimByCode: (claimByCodeRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'claimByCodeRequestDTO' is not null or undefined
            if (claimByCodeRequestDTO === null || claimByCodeRequestDTO === undefined) {
                throw new base_1.RequiredError('claimByCodeRequestDTO', 'Required parameter claimByCodeRequestDTO was null or undefined when calling claimByCode.');
            }
            const localVarPath = `/v1/myTickets/claimByCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof claimByCodeRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(claimByCodeRequestDTO !== undefined ? claimByCodeRequestDTO : {}) : (claimByCodeRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} externalShowId
         * @param {string} externalCredential
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claimExternalTicket: (externalShowId, externalCredential, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'externalShowId' is not null or undefined
            if (externalShowId === null || externalShowId === undefined) {
                throw new base_1.RequiredError('externalShowId', 'Required parameter externalShowId was null or undefined when calling claimExternalTicket.');
            }
            // verify required parameter 'externalCredential' is not null or undefined
            if (externalCredential === null || externalCredential === undefined) {
                throw new base_1.RequiredError('externalCredential', 'Required parameter externalCredential was null or undefined when calling claimExternalTicket.');
            }
            const localVarPath = `/v1/myTickets/claim-external`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (externalShowId !== undefined) {
                localVarQueryParameter['externalShowId'] = externalShowId;
            }
            if (externalCredential !== undefined) {
                localVarQueryParameter['externalCredential'] = externalCredential;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claimMyTickets: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/myTickets/claim`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {CompleteAppleIAPOrderRequestDTO} completeAppleIAPOrderRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeAppleIAPOrder: (id, completeAppleIAPOrderRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling completeAppleIAPOrder.');
            }
            // verify required parameter 'completeAppleIAPOrderRequestDTO' is not null or undefined
            if (completeAppleIAPOrderRequestDTO === null || completeAppleIAPOrderRequestDTO === undefined) {
                throw new base_1.RequiredError('completeAppleIAPOrderRequestDTO', 'Required parameter completeAppleIAPOrderRequestDTO was null or undefined when calling completeAppleIAPOrder.');
            }
            const localVarPath = `/fan/v1/appleIAPOrder/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof completeAppleIAPOrderRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(completeAppleIAPOrderRequestDTO !== undefined ? completeAppleIAPOrderRequestDTO : {}) : (completeAppleIAPOrderRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CompleteMultipartUploadRequestDTO} completeMultipartUploadRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completePreRecordUpload: (completeMultipartUploadRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'completeMultipartUploadRequestDTO' is not null or undefined
            if (completeMultipartUploadRequestDTO === null || completeMultipartUploadRequestDTO === undefined) {
                throw new base_1.RequiredError('completeMultipartUploadRequestDTO', 'Required parameter completeMultipartUploadRequestDTO was null or undefined when calling completePreRecordUpload.');
            }
            const localVarPath = `/admin/v1/preRecordUpload/complete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof completeMultipartUploadRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(completeMultipartUploadRequestDTO !== undefined ? completeMultipartUploadRequestDTO : {}) : (completeMultipartUploadRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CreateAppleIAPOrderRequestDTO} createAppleIAPOrderRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAppleIAPOrder: (createAppleIAPOrderRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createAppleIAPOrderRequestDTO' is not null or undefined
            if (createAppleIAPOrderRequestDTO === null || createAppleIAPOrderRequestDTO === undefined) {
                throw new base_1.RequiredError('createAppleIAPOrderRequestDTO', 'Required parameter createAppleIAPOrderRequestDTO was null or undefined when calling createAppleIAPOrder.');
            }
            const localVarPath = `/fan/v1/appleIAPOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof createAppleIAPOrderRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(createAppleIAPOrderRequestDTO !== undefined ? createAppleIAPOrderRequestDTO : {}) : (createAppleIAPOrderRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {GeneralSurveyResponseDTO} generalSurveyResponseDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGeneralSurveyResponse: (generalSurveyResponseDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'generalSurveyResponseDTO' is not null or undefined
            if (generalSurveyResponseDTO === null || generalSurveyResponseDTO === undefined) {
                throw new base_1.RequiredError('generalSurveyResponseDTO', 'Required parameter generalSurveyResponseDTO was null or undefined when calling createGeneralSurveyResponse.');
            }
            const localVarPath = `/v1/generalSurveys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof generalSurveyResponseDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(generalSurveyResponseDTO !== undefined ? generalSurveyResponseDTO : {}) : (generalSurveyResponseDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {AdminCreateNftTokenTransactionRequestDTO} adminCreateNftTokenTransactionRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNftTokenTransaction: (adminCreateNftTokenTransactionRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'adminCreateNftTokenTransactionRequestDTO' is not null or undefined
            if (adminCreateNftTokenTransactionRequestDTO === null || adminCreateNftTokenTransactionRequestDTO === undefined) {
                throw new base_1.RequiredError('adminCreateNftTokenTransactionRequestDTO', 'Required parameter adminCreateNftTokenTransactionRequestDTO was null or undefined when calling createNftTokenTransaction.');
            }
            const localVarPath = `/admin/v1/nftTokenTransaction`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof adminCreateNftTokenTransactionRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(adminCreateNftTokenTransactionRequestDTO !== undefined ? adminCreateNftTokenTransactionRequestDTO : {}) : (adminCreateNftTokenTransactionRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CreateMultipartUploadRequestDTO} createMultipartUploadRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPreRecordUpload: (createMultipartUploadRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createMultipartUploadRequestDTO' is not null or undefined
            if (createMultipartUploadRequestDTO === null || createMultipartUploadRequestDTO === undefined) {
                throw new base_1.RequiredError('createMultipartUploadRequestDTO', 'Required parameter createMultipartUploadRequestDTO was null or undefined when calling createPreRecordUpload.');
            }
            const localVarPath = `/admin/v1/preRecordUpload/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof createMultipartUploadRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(createMultipartUploadRequestDTO !== undefined ? createMultipartUploadRequestDTO : {}) : (createMultipartUploadRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {AdminUpdateProductRequestDTO} adminUpdateProductRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProductForShow: (adminUpdateProductRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'adminUpdateProductRequestDTO' is not null or undefined
            if (adminUpdateProductRequestDTO === null || adminUpdateProductRequestDTO === undefined) {
                throw new base_1.RequiredError('adminUpdateProductRequestDTO', 'Required parameter adminUpdateProductRequestDTO was null or undefined when calling createProductForShow.');
            }
            const localVarPath = `/v1/product`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof adminUpdateProductRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(adminUpdateProductRequestDTO !== undefined ? adminUpdateProductRequestDTO : {}) : (adminUpdateProductRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CreateSubscriptionRequestDTO} createSubscriptionRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubscription: (createSubscriptionRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createSubscriptionRequestDTO' is not null or undefined
            if (createSubscriptionRequestDTO === null || createSubscriptionRequestDTO === undefined) {
                throw new base_1.RequiredError('createSubscriptionRequestDTO', 'Required parameter createSubscriptionRequestDTO was null or undefined when calling createSubscription.');
            }
            const localVarPath = `/v1/subscriptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof createSubscriptionRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(createSubscriptionRequestDTO !== undefined ? createSubscriptionRequestDTO : {}) : (createSubscriptionRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CreateCsatSurveyRequestDTO} createCsatSurveyRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSurvey: (createCsatSurveyRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createCsatSurveyRequestDTO' is not null or undefined
            if (createCsatSurveyRequestDTO === null || createCsatSurveyRequestDTO === undefined) {
                throw new base_1.RequiredError('createCsatSurveyRequestDTO', 'Required parameter createCsatSurveyRequestDTO was null or undefined when calling createSurvey.');
            }
            const localVarPath = `/admin/v1/surveys/createSurvey`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof createCsatSurveyRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(createCsatSurveyRequestDTO !== undefined ? createCsatSurveyRequestDTO : {}) : (createCsatSurveyRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CsatSurveyResponseDTO} csatSurveyResponseDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSurveyResponse: (csatSurveyResponseDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'csatSurveyResponseDTO' is not null or undefined
            if (csatSurveyResponseDTO === null || csatSurveyResponseDTO === undefined) {
                throw new base_1.RequiredError('csatSurveyResponseDTO', 'Required parameter csatSurveyResponseDTO was null or undefined when calling createSurveyResponse.');
            }
            const localVarPath = `/v1/surveys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof csatSurveyResponseDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(csatSurveyResponseDTO !== undefined ? csatSurveyResponseDTO : {}) : (csatSurveyResponseDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} showId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVIPExperience: (showId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'showId' is not null or undefined
            if (showId === null || showId === undefined) {
                throw new base_1.RequiredError('showId', 'Required parameter showId was null or undefined when calling createVIPExperience.');
            }
            const localVarPath = `/presenter/v1/experience/vip/create/experience/{showId}`
                .replace(`{${"showId"}}`, encodeURIComponent(String(showId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {DeleteApiKeyRequestDTO} deleteApiKeyRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteApiKey: (deleteApiKeyRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'deleteApiKeyRequestDTO' is not null or undefined
            if (deleteApiKeyRequestDTO === null || deleteApiKeyRequestDTO === undefined) {
                throw new base_1.RequiredError('deleteApiKeyRequestDTO', 'Required parameter deleteApiKeyRequestDTO was null or undefined when calling deleteApiKey.');
            }
            const localVarPath = `/v1/api-key`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof deleteApiKeyRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(deleteApiKeyRequestDTO !== undefined ? deleteApiKeyRequestDTO : {}) : (deleteApiKeyRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} paymentMethodId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePaymentMethod: (paymentMethodId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'paymentMethodId' is not null or undefined
            if (paymentMethodId === null || paymentMethodId === undefined) {
                throw new base_1.RequiredError('paymentMethodId', 'Required parameter paymentMethodId was null or undefined when calling deletePaymentMethod.');
            }
            const localVarPath = `/v1/customers/paymentMethod/{paymentMethodId}`
                .replace(`{${"paymentMethodId"}}`, encodeURIComponent(String(paymentMethodId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", ["accessBilling"])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} assetId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableMasterAccessForAsset: (assetId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'assetId' is not null or undefined
            if (assetId === null || assetId === undefined) {
                throw new base_1.RequiredError('assetId', 'Required parameter assetId was null or undefined when calling enableMasterAccessForAsset.');
            }
            const localVarPath = `/admin/v1/mux/assets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (assetId !== undefined) {
                localVarQueryParameter['assetId'] = assetId;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ExternalAuthRequestDTO} externalAuthRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalLogin: (externalAuthRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'externalAuthRequestDTO' is not null or undefined
            if (externalAuthRequestDTO === null || externalAuthRequestDTO === undefined) {
                throw new base_1.RequiredError('externalAuthRequestDTO', 'Required parameter externalAuthRequestDTO was null or undefined when calling externalLogin.');
            }
            const localVarPath = `/v1/external-login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof externalAuthRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(externalAuthRequestDTO !== undefined ? externalAuthRequestDTO : {}) : (externalAuthRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} surveyIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalSurveyResponsesBySurveyId: (surveyIdentifier, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'surveyIdentifier' is not null or undefined
            if (surveyIdentifier === null || surveyIdentifier === undefined) {
                throw new base_1.RequiredError('surveyIdentifier', 'Required parameter surveyIdentifier was null or undefined when calling generalSurveyResponsesBySurveyId.');
            }
            const localVarPath = `/admin/v1/generalSurveys/{surveyIdentifier}`
                .replace(`{${"surveyIdentifier"}}`, encodeURIComponent(String(surveyIdentifier)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {GenerateApiKeyRequestDTO} generateApiKeyRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateApiKey: (generateApiKeyRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'generateApiKeyRequestDTO' is not null or undefined
            if (generateApiKeyRequestDTO === null || generateApiKeyRequestDTO === undefined) {
                throw new base_1.RequiredError('generateApiKeyRequestDTO', 'Required parameter generateApiKeyRequestDTO was null or undefined when calling generateApiKey.');
            }
            const localVarPath = `/v1/api-key`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof generateApiKeyRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(generateApiKeyRequestDTO !== undefined ? generateApiKeyRequestDTO : {}) : (generateApiKeyRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {GenerateCustomTokenRequestDTO} generateCustomTokenRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCustomToken: (generateCustomTokenRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'generateCustomTokenRequestDTO' is not null or undefined
            if (generateCustomTokenRequestDTO === null || generateCustomTokenRequestDTO === undefined) {
                throw new base_1.RequiredError('generateCustomTokenRequestDTO', 'Required parameter generateCustomTokenRequestDTO was null or undefined when calling generateCustomToken.');
            }
            const localVarPath = `/admin/v1/customToken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof generateCustomTokenRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(generateCustomTokenRequestDTO !== undefined ? generateCustomTokenRequestDTO : {}) : (generateCustomTokenRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {VIPExperienceCallTokenRequestParams} vIPExperienceCallTokenRequestParams
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateVIPExperienceCallToken: (vIPExperienceCallTokenRequestParams, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'vIPExperienceCallTokenRequestParams' is not null or undefined
            if (vIPExperienceCallTokenRequestParams === null || vIPExperienceCallTokenRequestParams === undefined) {
                throw new base_1.RequiredError('vIPExperienceCallTokenRequestParams', 'Required parameter vIPExperienceCallTokenRequestParams was null or undefined when calling generateVIPExperienceCallToken.');
            }
            const localVarPath = `/admin/v1/experience/vip/generateJoinUrl`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof vIPExperienceCallTokenRequestParams !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(vIPExperienceCallTokenRequestParams !== undefined ? vIPExperienceCallTokenRequestParams : {}) : (vIPExperienceCallTokenRequestParams || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} topic
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSubscriptionsByTopic: (topic, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'topic' is not null or undefined
            if (topic === null || topic === undefined) {
                throw new base_1.RequiredError('topic', 'Required parameter topic was null or undefined when calling getAllSubscriptionsByTopic.');
            }
            const localVarPath = `/admin/v1/pushSubscriptions/checkForSubscriptionsForTopic/{topic}`
                .replace(`{${"topic"}}`, encodeURIComponent(String(topic)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsersSubscriptions: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/pushSubscriptions/getAllSubscriptionsForUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppleIAPOrder: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling getAppleIAPOrder.');
            }
            const localVarPath = `/fan/v1/appleIAPOrder/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} artistId
         * @param {boolean} [includeUpcomingEventsCount]
         * @param {boolean} [includePastEventsCount]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArtist: (artistId, includeUpcomingEventsCount, includePastEventsCount, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'artistId' is not null or undefined
            if (artistId === null || artistId === undefined) {
                throw new base_1.RequiredError('artistId', 'Required parameter artistId was null or undefined when calling getArtist.');
            }
            const localVarPath = `/v1/artist/{artistId}`
                .replace(`{${"artistId"}}`, encodeURIComponent(String(artistId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (includeUpcomingEventsCount !== undefined) {
                localVarQueryParameter['includeUpcomingEventsCount'] = includeUpcomingEventsCount;
            }
            if (includePastEventsCount !== undefined) {
                localVarQueryParameter['includePastEventsCount'] = includePastEventsCount;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {NftAssetContentTypeRequest} nftAssetContentTypeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetContentType: (nftAssetContentTypeRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'nftAssetContentTypeRequest' is not null or undefined
            if (nftAssetContentTypeRequest === null || nftAssetContentTypeRequest === undefined) {
                throw new base_1.RequiredError('nftAssetContentTypeRequest', 'Required parameter nftAssetContentTypeRequest was null or undefined when calling getAssetContentType.');
            }
            const localVarPath = `/v1/nftMinting/assetContentType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof nftAssetContentTypeRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(nftAssetContentTypeRequest !== undefined ? nftAssetContentTypeRequest : {}) : (nftAssetContentTypeRequest || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} showId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatRoom: (showId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'showId' is not null or undefined
            if (showId === null || showId === undefined) {
                throw new base_1.RequiredError('showId', 'Required parameter showId was null or undefined when calling getChatRoom.');
            }
            const localVarPath = `/v1/chatRoom/public/{showId}`
                .replace(`{${"showId"}}`, encodeURIComponent(String(showId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} chatRoomId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatRoomById: (chatRoomId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'chatRoomId' is not null or undefined
            if (chatRoomId === null || chatRoomId === undefined) {
                throw new base_1.RequiredError('chatRoomId', 'Required parameter chatRoomId was null or undefined when calling getChatRoomById.');
            }
            const localVarPath = `/v1/chatRoom/{chatRoomId}`
                .replace(`{${"chatRoomId"}}`, encodeURIComponent(String(chatRoomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatToken: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/streamChat/token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} showId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatTranscriptsLink: (showId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'showId' is not null or undefined
            if (showId === null || showId === undefined) {
                throw new base_1.RequiredError('showId', 'Required parameter showId was null or undefined when calling getChatTranscriptsLink.');
            }
            const localVarPath = `/v1/chatRoom/admin/chatTranscriptsLink/{showId}`
                .replace(`{${"showId"}}`, encodeURIComponent(String(showId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} subdomain
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCobrand: (subdomain, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'subdomain' is not null or undefined
            if (subdomain === null || subdomain === undefined) {
                throw new base_1.RequiredError('subdomain', 'Required parameter subdomain was null or undefined when calling getCobrand.');
            }
            const localVarPath = `/v1/cobrand/{subdomain}`
                .replace(`{${"subdomain"}}`, encodeURIComponent(String(subdomain)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentOrganization: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/presenter/v1/organization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", ["authenticated"])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomer: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/customers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", ["accessBilling"])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns the stream details to the passed show for the currently authenticated user, given one of the following 1. The show is ticketed and the user has a ticket for the show (@todo check entitlement type) 2. The show is unticketed 3. The user is an admin 4. The user is a show manager  Includes an ephemeral signed URL for the public replay tool endpoint   (only the trimmed version of the replay is accessible)
         * @param {string} showId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventStreamDetails: (showId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'showId' is not null or undefined
            if (showId === null || showId === undefined) {
                throw new base_1.RequiredError('showId', 'Required parameter showId was null or undefined when calling getEventStreamDetails.');
            }
            const localVarPath = `/v1/event/streamDetails/{showId}`
                .replace(`{${"showId"}}`, encodeURIComponent(String(showId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} searchQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFanNavigatorPrices: (searchQuery, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'searchQuery' is not null or undefined
            if (searchQuery === null || searchQuery === undefined) {
                throw new base_1.RequiredError('searchQuery', 'Required parameter searchQuery was null or undefined when calling getFanNavigatorPrices.');
            }
            const localVarPath = `/v1/fanNavigatorPrices/{searchQuery}`
                .replace(`{${"searchQuery"}}`, encodeURIComponent(String(searchQuery)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", ["accessBilling"])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntegrations: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/presenter/v1/integration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", ["fanDataConfigure"])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} channelId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestPinnedStreamChatMessages: (channelId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'channelId' is not null or undefined
            if (channelId === null || channelId === undefined) {
                throw new base_1.RequiredError('channelId', 'Required parameter channelId was null or undefined when calling getLatestPinnedStreamChatMessages.');
            }
            const localVarPath = `/v1/streamChat/channel/{channelId}/pinnedMessages`
                .replace(`{${"channelId"}}`, encodeURIComponent(String(channelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMailchimpAudiences: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/presenter/v1/integration/mailchimp/audiences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", ["fanDataConfigure"])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} livestreamId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMuxAssetsForLivestream: (livestreamId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'livestreamId' is not null or undefined
            if (livestreamId === null || livestreamId === undefined) {
                throw new base_1.RequiredError('livestreamId', 'Required parameter livestreamId was null or undefined when calling getMuxAssetsForLivestream.');
            }
            const localVarPath = `/admin/v1/mux/assets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (livestreamId !== undefined) {
                localVarQueryParameter['livestreamId'] = livestreamId;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNftToken: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling getNftToken.');
            }
            const localVarPath = `/v1/nft/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentInformation: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/customers/payments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", ["accessBilling"])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentMethods: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/customers/paymentMethods`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", ["accessBilling"])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} uploadDate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreSignedUrl: (uploadDate, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uploadDate' is not null or undefined
            if (uploadDate === null || uploadDate === undefined) {
                throw new base_1.RequiredError('uploadDate', 'Required parameter uploadDate was null or undefined when calling getPreSignedUrl.');
            }
            const localVarPath = `/fanData/v1/csvUpload/getPreSignedUrl`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", ["fanDataConfigure"])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (uploadDate !== undefined) {
                localVarQueryParameter['uploadDate'] = (uploadDate instanceof Date) ?
                    uploadDate.toISOString() :
                    uploadDate;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} productId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductPriceInformation: (productId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'productId' is not null or undefined
            if (productId === null || productId === undefined) {
                throw new base_1.RequiredError('productId', 'Required parameter productId was null or undefined when calling getProductPriceInformation.');
            }
            const localVarPath = `/v1/productPriceInfo/{productId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} surveyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResponsesBySurveyId: (surveyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'surveyId' is not null or undefined
            if (surveyId === null || surveyId === undefined) {
                throw new base_1.RequiredError('surveyId', 'Required parameter surveyId was null or undefined when calling getResponsesBySurveyId.');
            }
            const localVarPath = `/admin/v1/surveys/{surveyId}`
                .replace(`{${"surveyId"}}`, encodeURIComponent(String(surveyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} storeUrl
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShopifyStore: (storeUrl, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'storeUrl' is not null or undefined
            if (storeUrl === null || storeUrl === undefined) {
                throw new base_1.RequiredError('storeUrl', 'Required parameter storeUrl was null or undefined when calling getShopifyStore.');
            }
            const localVarPath = `/admin/v1/shopifyStore/{storeUrl}`
                .replace(`{${"storeUrl"}}`, encodeURIComponent(String(storeUrl)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} showId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShow: (showId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'showId' is not null or undefined
            if (showId === null || showId === undefined) {
                throw new base_1.RequiredError('showId', 'Required parameter showId was null or undefined when calling getShow.');
            }
            const localVarPath = `/v1/show/{showId}`
                .replace(`{${"showId"}}`, encodeURIComponent(String(showId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns the stream details to the passed show for the currently authenticated user, given one of the following 1. The show is ticketed and the user has a ticket for the show (@todo check entitlement type) 2. The show is unticketed 3. The user is an admin 4. The user is a show manager  Includes an ephemeral signed URL for the public replay tool endpoint   (only the trimmed version of the replay is accessible)
         * @param {string} showId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShowStreamDetails: (showId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'showId' is not null or undefined
            if (showId === null || showId === undefined) {
                throw new base_1.RequiredError('showId', 'Required parameter showId was null or undefined when calling getShowStreamDetails.');
            }
            const localVarPath = `/v1/show/streamDetails/{showId}`
                .replace(`{${"showId"}}`, encodeURIComponent(String(showId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} channelId
         * @param {number} [limit] Maximum value: 100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStreamChatMessages: (channelId, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'channelId' is not null or undefined
            if (channelId === null || channelId === undefined) {
                throw new base_1.RequiredError('channelId', 'Required parameter channelId was null or undefined when calling getStreamChatMessages.');
            }
            const localVarPath = `/v1/streamChat/channel/{channelId}/messages`
                .replace(`{${"channelId"}}`, encodeURIComponent(String(channelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} showId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscribedUserChatrooms: (showId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'showId' is not null or undefined
            if (showId === null || showId === undefined) {
                throw new base_1.RequiredError('showId', 'Required parameter showId was null or undefined when calling getSubscribedUserChatrooms.');
            }
            const localVarPath = `/v1/chatRoom/mine/{showId}`
                .replace(`{${"showId"}}`, encodeURIComponent(String(showId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionInformation: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/subscriptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", ["accessBilling"])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} surveyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurvey: (surveyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'surveyId' is not null or undefined
            if (surveyId === null || surveyId === undefined) {
                throw new base_1.RequiredError('surveyId', 'Required parameter surveyId was null or undefined when calling getSurvey.');
            }
            const localVarPath = `/v1/surveys/{surveyId}`
                .replace(`{${"surveyId"}}`, encodeURIComponent(String(surveyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTOSAcceptance: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/accept-tos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", ["authenticated"])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVIPExperience: (eventId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'eventId' is not null or undefined
            if (eventId === null || eventId === undefined) {
                throw new base_1.RequiredError('eventId', 'Required parameter eventId was null or undefined when calling getVIPExperience.');
            }
            const localVarPath = `/v1/experience/vip/{eventId}`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVIPExperienceAllowJoiningInfo: (eventId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'eventId' is not null or undefined
            if (eventId === null || eventId === undefined) {
                throw new base_1.RequiredError('eventId', 'Required parameter eventId was null or undefined when calling getVIPExperienceAllowJoiningInfo.');
            }
            const localVarPath = `/v1/experience/vip/participant/allowJoining/{eventId}`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVIPExperienceParticipants: (eventId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'eventId' is not null or undefined
            if (eventId === null || eventId === undefined) {
                throw new base_1.RequiredError('eventId', 'Required parameter eventId was null or undefined when calling getVIPExperienceParticipants.');
            }
            const localVarPath = `/v1/experience/vip/participant/participants/{eventId}`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} venueId
         * @param {boolean} [includeUpcomingEventsCount]
         * @param {boolean} [includePastEventsCount]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVenue: (venueId, includeUpcomingEventsCount, includePastEventsCount, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'venueId' is not null or undefined
            if (venueId === null || venueId === undefined) {
                throw new base_1.RequiredError('venueId', 'Required parameter venueId was null or undefined when calling getVenue.');
            }
            const localVarPath = `/v1/venue/{venueId}`
                .replace(`{${"venueId"}}`, encodeURIComponent(String(venueId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (includeUpcomingEventsCount !== undefined) {
                localVarQueryParameter['includeUpcomingEventsCount'] = includeUpcomingEventsCount;
            }
            if (includePastEventsCount !== undefined) {
                localVarQueryParameter['includePastEventsCount'] = includePastEventsCount;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        health: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {IVotedAuthRequestDTO} iVotedAuthRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        iVotedLogin: (iVotedAuthRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'iVotedAuthRequestDTO' is not null or undefined
            if (iVotedAuthRequestDTO === null || iVotedAuthRequestDTO === undefined) {
                throw new base_1.RequiredError('iVotedAuthRequestDTO', 'Required parameter iVotedAuthRequestDTO was null or undefined when calling iVotedLogin.');
            }
            const localVarPath = `/ivoted/v1/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof iVotedAuthRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(iVotedAuthRequestDTO !== undefined ? iVotedAuthRequestDTO : {}) : (iVotedAuthRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         * Creates Mandolin users and associates the provided ivoted externalID with that user for the purposes of allowing authentication. The returned response echoes the input, and will either include a jwt in the `token` field, or an `error` object with details on why that particular operation failed. The order of users in the response is not guaranteed to match the input order.  Authentication is handled via the `X-Api-Key` header. Its value should be set to `apiKey:secret`, where \"apiKey\" is the API key and \"secret\" is the secret value associated with that key.
         * @param {IVotedCreateUserRequestDTO} iVotedCreateUserRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        iVotedUsersCreate: (iVotedCreateUserRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'iVotedCreateUserRequestDTO' is not null or undefined
            if (iVotedCreateUserRequestDTO === null || iVotedCreateUserRequestDTO === undefined) {
                throw new base_1.RequiredError('iVotedCreateUserRequestDTO', 'Required parameter iVotedCreateUserRequestDTO was null or undefined when calling iVotedUsersCreate.');
            }
            const localVarPath = `/ivoted/v1/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication partnerApiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? yield configuration.apiKey("X-Api-Key")
                    : yield configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof iVotedCreateUserRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(iVotedCreateUserRequestDTO !== undefined ? iVotedCreateUserRequestDTO : {}) : (iVotedCreateUserRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {PresenterOrganizationInviteMemberDTO} presenterOrganizationInviteMemberDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteOrgMember: (presenterOrganizationInviteMemberDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'presenterOrganizationInviteMemberDTO' is not null or undefined
            if (presenterOrganizationInviteMemberDTO === null || presenterOrganizationInviteMemberDTO === undefined) {
                throw new base_1.RequiredError('presenterOrganizationInviteMemberDTO', 'Required parameter presenterOrganizationInviteMemberDTO was null or undefined when calling inviteOrgMember.');
            }
            const localVarPath = `/v1/organization/members/invite`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof presenterOrganizationInviteMemberDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(presenterOrganizationInviteMemberDTO !== undefined ? presenterOrganizationInviteMemberDTO : {}) : (presenterOrganizationInviteMemberDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [venueId]
         * @param {string} [artistId]
         * @param {ShowSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jamBaseListShows: (venueId, artistId, sortBy, sortOrder, startAfter, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/external-integration/v1/jamBase/show`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication partnerApiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? yield configuration.apiKey("X-Api-Key")
                    : yield configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            if (venueId !== undefined) {
                localVarQueryParameter['venueId'] = venueId;
            }
            if (artistId !== undefined) {
                localVarQueryParameter['artistId'] = artistId;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }
            if (startAfter !== undefined) {
                localVarQueryParameter['startAfter'] = startAfter;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {JoinChannelRequestDTO} joinChannelRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinChannel: (joinChannelRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'joinChannelRequestDTO' is not null or undefined
            if (joinChannelRequestDTO === null || joinChannelRequestDTO === undefined) {
                throw new base_1.RequiredError('joinChannelRequestDTO', 'Required parameter joinChannelRequestDTO was null or undefined when calling joinChannel.');
            }
            const localVarPath = `/v1/streamChat/channel/join`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof joinChannelRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(joinChannelRequestDTO !== undefined ? joinChannelRequestDTO : {}) : (joinChannelRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} t
         * @param {string} name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinVIPExperienceAsArtist: (t, name, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 't' is not null or undefined
            if (t === null || t === undefined) {
                throw new base_1.RequiredError('t', 'Required parameter t was null or undefined when calling joinVIPExperienceAsArtist.');
            }
            // verify required parameter 'name' is not null or undefined
            if (name === null || name === undefined) {
                throw new base_1.RequiredError('name', 'Required parameter name was null or undefined when calling joinVIPExperienceAsArtist.');
            }
            const localVarPath = `/v1/experience/vip/artist/join`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (t !== undefined) {
                localVarQueryParameter['t'] = t;
            }
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ArtistSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {boolean} [isFeatured]
         * @param {string} [cobrand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listArtists: (sortBy, sortOrder, startAfter, limit, isFeatured, cobrand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/artist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }
            if (startAfter !== undefined) {
                localVarQueryParameter['startAfter'] = startAfter;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (isFeatured !== undefined) {
                localVarQueryParameter['isFeatured'] = isFeatured;
            }
            if (cobrand !== undefined) {
                localVarQueryParameter['cobrand'] = cobrand;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} showId
         * @param {TicketSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {number} [limit] Maximum value: 5000
         * @param {Array<TicketIncludes>} [include]
         * @param {TicketStatus} [status]
         * @param {string} [startAfter]
         * @param {Array<string>} [ticketIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAudience: (showId, sortBy, sortOrder, limit, include, status, startAfter, ticketIds, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'showId' is not null or undefined
            if (showId === null || showId === undefined) {
                throw new base_1.RequiredError('showId', 'Required parameter showId was null or undefined when calling listAudience.');
            }
            const localVarPath = `/v1/audience/{showId}`
                .replace(`{${"showId"}}`, encodeURIComponent(String(showId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (include) {
                localVarQueryParameter['include'] = include;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (startAfter !== undefined) {
                localVarQueryParameter['startAfter'] = startAfter;
            }
            if (ticketIds) {
                localVarQueryParameter['ticketIds'] = ticketIds;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CobrandSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCobrands: (sortBy, sortOrder, startAfter, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/v1/cobrand`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }
            if (startAfter !== undefined) {
                localVarQueryParameter['startAfter'] = startAfter;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMemberRoles: (userId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new base_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling listMemberRoles.');
            }
            const localVarPath = `/v1/organization/members/{userId}/roles/list`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMembers: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/organization/members/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMyApiKeys: (startAfter, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/api-key`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (startAfter !== undefined) {
                localVarQueryParameter['startAfter'] = startAfter;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [cobrand]
         * @param {string} [venueId]
         * @param {string} [artistId]
         * @param {ShowSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 200
         * @param {boolean} [excludePast]
         * @param {Array<ShowIncludes>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMyShows: (cobrand, venueId, artistId, sortBy, sortOrder, startAfter, limit, excludePast, include, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/myShows`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (cobrand !== undefined) {
                localVarQueryParameter['cobrand'] = cobrand;
            }
            if (venueId !== undefined) {
                localVarQueryParameter['venueId'] = venueId;
            }
            if (artistId !== undefined) {
                localVarQueryParameter['artistId'] = artistId;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }
            if (startAfter !== undefined) {
                localVarQueryParameter['startAfter'] = startAfter;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (excludePast !== undefined) {
                localVarQueryParameter['excludePast'] = excludePast;
            }
            if (include) {
                localVarQueryParameter['include'] = include;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {NftTokenSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNftToken: (sortBy, sortOrder, startAfter, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/nft`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }
            if (startAfter !== undefined) {
                localVarQueryParameter['startAfter'] = startAfter;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {NftTokenTransactionSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {boolean} [includeMinted]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNftTokenTransaction: (sortBy, sortOrder, startAfter, limit, includeMinted, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/nftTokenTransaction`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }
            if (startAfter !== undefined) {
                localVarQueryParameter['startAfter'] = startAfter;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (includeMinted !== undefined) {
                localVarQueryParameter['includeMinted'] = includeMinted;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} tag
         * @param {ProductSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProductsByTag: (tag, sortBy, sortOrder, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tag' is not null or undefined
            if (tag === null || tag === undefined) {
                throw new base_1.RequiredError('tag', 'Required parameter tag was null or undefined when calling listProductsByTag.');
            }
            const localVarPath = `/v1/product/{tag}`
                .replace(`{${"tag"}}`, encodeURIComponent(String(tag)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [limit] Maximum value: 100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listShopifyStores: (limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/v1/shopifyStore`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [cobrand]
         * @param {string} [venueId]
         * @param {string} [artistId]
         * @param {ShowSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 10000
         * @param {boolean} [excludePast] whether past shows should be included in the response. This parameter is incompatible with passing &#x60;sortBy&#x60; unless specific Firestore indices are created to support compound queries
         * @param {boolean} [iosOnlyShows] whether to only include shows with an associated eventIapConfig value
         * @param {Array<ShowIncludes>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listShows: (cobrand, venueId, artistId, sortBy, sortOrder, startAfter, limit, excludePast, iosOnlyShows, include, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/show`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (cobrand !== undefined) {
                localVarQueryParameter['cobrand'] = cobrand;
            }
            if (venueId !== undefined) {
                localVarQueryParameter['venueId'] = venueId;
            }
            if (artistId !== undefined) {
                localVarQueryParameter['artistId'] = artistId;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }
            if (startAfter !== undefined) {
                localVarQueryParameter['startAfter'] = startAfter;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (excludePast !== undefined) {
                localVarQueryParameter['excludePast'] = excludePast;
            }
            if (iosOnlyShows !== undefined) {
                localVarQueryParameter['iosOnlyShows'] = iosOnlyShows;
            }
            if (include) {
                localVarQueryParameter['include'] = include;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [siteId]
         * @param {string} [slug]
         * @param {string} [surveyIdentifier]
         * @param {SortOrder} [sortOrder]
         * @param {number} [limit] Maximum value: 5000
         * @param {string} [startAfter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSurveyReponses: (siteId, slug, surveyIdentifier, sortOrder, limit, startAfter, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/v1/generalSurveys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (siteId !== undefined) {
                localVarQueryParameter['siteId'] = siteId;
            }
            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }
            if (surveyIdentifier !== undefined) {
                localVarQueryParameter['surveyIdentifier'] = surveyIdentifier;
            }
            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (startAfter !== undefined) {
                localVarQueryParameter['startAfter'] = startAfter;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CsatSurveySortBy} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSurveys: (sortBy, sortOrder, startAfter, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/v1/surveys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }
            if (startAfter !== undefined) {
                localVarQueryParameter['startAfter'] = startAfter;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {VenueSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {boolean} [isFeatured]
         * @param {string} [cobrand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listVenues: (sortBy, sortOrder, startAfter, limit, isFeatured, cobrand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/venue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }
            if (startAfter !== undefined) {
                localVarQueryParameter['startAfter'] = startAfter;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (isFeatured !== undefined) {
                localVarQueryParameter['isFeatured'] = isFeatured;
            }
            if (cobrand !== undefined) {
                localVarQueryParameter['cobrand'] = cobrand;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {ManagerChangeShowChatStateRequestDTO} managerChangeShowChatStateRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managerChangeShowChatState: (id, managerChangeShowChatStateRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling managerChangeShowChatState.');
            }
            // verify required parameter 'managerChangeShowChatStateRequestDTO' is not null or undefined
            if (managerChangeShowChatStateRequestDTO === null || managerChangeShowChatStateRequestDTO === undefined) {
                throw new base_1.RequiredError('managerChangeShowChatStateRequestDTO', 'Required parameter managerChangeShowChatStateRequestDTO was null or undefined when calling managerChangeShowChatState.');
            }
            const localVarPath = `/manager/v1/show/changeChatState/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof managerChangeShowChatStateRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(managerChangeShowChatStateRequestDTO !== undefined ? managerChangeShowChatStateRequestDTO : {}) : (managerChangeShowChatStateRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {ManagerChangeShowStateRequestDTO} managerChangeShowStateRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managerChangeShowState: (id, managerChangeShowStateRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling managerChangeShowState.');
            }
            // verify required parameter 'managerChangeShowStateRequestDTO' is not null or undefined
            if (managerChangeShowStateRequestDTO === null || managerChangeShowStateRequestDTO === undefined) {
                throw new base_1.RequiredError('managerChangeShowStateRequestDTO', 'Required parameter managerChangeShowStateRequestDTO was null or undefined when calling managerChangeShowState.');
            }
            const localVarPath = `/manager/v1/show/changeState/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof managerChangeShowStateRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(managerChangeShowStateRequestDTO !== undefined ? managerChangeShowStateRequestDTO : {}) : (managerChangeShowStateRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} showId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managerGetShow: (showId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'showId' is not null or undefined
            if (showId === null || showId === undefined) {
                throw new base_1.RequiredError('showId', 'Required parameter showId was null or undefined when calling managerGetShow.');
            }
            const localVarPath = `/manager/v1/show/{showId}`
                .replace(`{${"showId"}}`, encodeURIComponent(String(showId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [artistId]
         * @param {string} [cobrand]
         * @param {Array<ShowState>} [state]
         * @param {Array<ShowType>} [type]
         * @param {string} [venueId]
         * @param {string} [beforeDate]
         * @param {string} [afterDate]
         * @param {ShowSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 1000
         * @param {Array<ShowIncludes>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managerListManagedShows: (artistId, cobrand, state, type, venueId, beforeDate, afterDate, sortBy, sortOrder, startAfter, limit, include, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/manager/v1/show`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (artistId !== undefined) {
                localVarQueryParameter['artistId'] = artistId;
            }
            if (cobrand !== undefined) {
                localVarQueryParameter['cobrand'] = cobrand;
            }
            if (state) {
                localVarQueryParameter['state'] = state;
            }
            if (type) {
                localVarQueryParameter['type'] = type;
            }
            if (venueId !== undefined) {
                localVarQueryParameter['venueId'] = venueId;
            }
            if (beforeDate !== undefined) {
                localVarQueryParameter['beforeDate'] = (beforeDate instanceof Date) ?
                    beforeDate.toISOString() :
                    beforeDate;
            }
            if (afterDate !== undefined) {
                localVarQueryParameter['afterDate'] = (afterDate instanceof Date) ?
                    afterDate.toISOString() :
                    afterDate;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }
            if (startAfter !== undefined) {
                localVarQueryParameter['startAfter'] = startAfter;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (include) {
                localVarQueryParameter['include'] = include;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ShowSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {string} [shopifyProductTag]
         * @param {string} [shopifyMerchTag]
         * @param {number} [limit] Maximum value: 1000
         * @param {boolean} [excludePast] whether past shows should be included in the response. This parameter is incompatible with passing &#x60;sortBy&#x60; unless specific Firestore indices are created to support compound queries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managerListShows: (sortBy, sortOrder, startAfter, shopifyProductTag, shopifyMerchTag, limit, excludePast, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/partner/v1/show`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication partnerApiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? yield configuration.apiKey("X-Api-Key")
                    : yield configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }
            if (startAfter !== undefined) {
                localVarQueryParameter['startAfter'] = startAfter;
            }
            if (shopifyProductTag !== undefined) {
                localVarQueryParameter['shopifyProductTag'] = shopifyProductTag;
            }
            if (shopifyMerchTag !== undefined) {
                localVarQueryParameter['shopifyMerchTag'] = shopifyMerchTag;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (excludePast !== undefined) {
                localVarQueryParameter['excludePast'] = excludePast;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {MigrateApiKeyRequestDTO} migrateApiKeyRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrateApiKey: (migrateApiKeyRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'migrateApiKeyRequestDTO' is not null or undefined
            if (migrateApiKeyRequestDTO === null || migrateApiKeyRequestDTO === undefined) {
                throw new base_1.RequiredError('migrateApiKeyRequestDTO', 'Required parameter migrateApiKeyRequestDTO was null or undefined when calling migrateApiKey.');
            }
            const localVarPath = `/admin/v1/api-key`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof migrateApiKeyRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(migrateApiKeyRequestDTO !== undefined ? migrateApiKeyRequestDTO : {}) : (migrateApiKeyRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ProcessMintingUseCaseRequestDTO} processMintingUseCaseRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mintNft: (processMintingUseCaseRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'processMintingUseCaseRequestDTO' is not null or undefined
            if (processMintingUseCaseRequestDTO === null || processMintingUseCaseRequestDTO === undefined) {
                throw new base_1.RequiredError('processMintingUseCaseRequestDTO', 'Required parameter processMintingUseCaseRequestDTO was null or undefined when calling mintNft.');
            }
            const localVarPath = `/v1/nftMinting/mint`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof processMintingUseCaseRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(processMintingUseCaseRequestDTO !== undefined ? processMintingUseCaseRequestDTO : {}) : (processMintingUseCaseRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        myProfile: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {UpdateCustomerRequestDTO} updateCustomerRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgUpdateCustomer: (updateCustomerRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'updateCustomerRequestDTO' is not null or undefined
            if (updateCustomerRequestDTO === null || updateCustomerRequestDTO === undefined) {
                throw new base_1.RequiredError('updateCustomerRequestDTO', 'Required parameter updateCustomerRequestDTO was null or undefined when calling orgUpdateCustomer.');
            }
            const localVarPath = `/v1/customers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", ["accessBilling"])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof updateCustomerRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(updateCustomerRequestDTO !== undefined ? updateCustomerRequestDTO : {}) : (updateCustomerRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {PartnerCreateSingleTicketRequestDTO} partnerCreateSingleTicketRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerCreateSingleTicket: (partnerCreateSingleTicketRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partnerCreateSingleTicketRequestDTO' is not null or undefined
            if (partnerCreateSingleTicketRequestDTO === null || partnerCreateSingleTicketRequestDTO === undefined) {
                throw new base_1.RequiredError('partnerCreateSingleTicketRequestDTO', 'Required parameter partnerCreateSingleTicketRequestDTO was null or undefined when calling partnerCreateSingleTicket.');
            }
            const localVarPath = `/partner/v1/tickets/createSingle`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication partnerApiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? yield configuration.apiKey("X-Api-Key")
                    : yield configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof partnerCreateSingleTicketRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(partnerCreateSingleTicketRequestDTO !== undefined ? partnerCreateSingleTicketRequestDTO : {}) : (partnerCreateSingleTicketRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {PartnerCreateTicketRequestDTO} partnerCreateTicketRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerCreateTickets: (partnerCreateTicketRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partnerCreateTicketRequestDTO' is not null or undefined
            if (partnerCreateTicketRequestDTO === null || partnerCreateTicketRequestDTO === undefined) {
                throw new base_1.RequiredError('partnerCreateTicketRequestDTO', 'Required parameter partnerCreateTicketRequestDTO was null or undefined when calling partnerCreateTickets.');
            }
            const localVarPath = `/partner/v1/tickets/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication partnerApiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? yield configuration.apiKey("X-Api-Key")
                    : yield configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof partnerCreateTicketRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(partnerCreateTicketRequestDTO !== undefined ? partnerCreateTicketRequestDTO : {}) : (partnerCreateTicketRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} showId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerGetShow: (showId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'showId' is not null or undefined
            if (showId === null || showId === undefined) {
                throw new base_1.RequiredError('showId', 'Required parameter showId was null or undefined when calling partnerGetShow.');
            }
            const localVarPath = `/partner/v1/show/{showId}`
                .replace(`{${"showId"}}`, encodeURIComponent(String(showId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication partnerApiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? yield configuration.apiKey("X-Api-Key")
                    : yield configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {PartnerRevokeTicketRequestDTO} partnerRevokeTicketRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerRevokeTickets: (partnerRevokeTicketRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partnerRevokeTicketRequestDTO' is not null or undefined
            if (partnerRevokeTicketRequestDTO === null || partnerRevokeTicketRequestDTO === undefined) {
                throw new base_1.RequiredError('partnerRevokeTicketRequestDTO', 'Required parameter partnerRevokeTicketRequestDTO was null or undefined when calling partnerRevokeTickets.');
            }
            const localVarPath = `/partner/v1/tickets/revoke`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication partnerApiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? yield configuration.apiKey("X-Api-Key")
                    : yield configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof partnerRevokeTicketRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(partnerRevokeTicketRequestDTO !== undefined ? partnerRevokeTicketRequestDTO : {}) : (partnerRevokeTicketRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} type
         * @param {PresenterAuthCallbackRequestDTO} presenterAuthCallbackRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        presenterAuthCallback: (type, presenterAuthCallbackRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'type' is not null or undefined
            if (type === null || type === undefined) {
                throw new base_1.RequiredError('type', 'Required parameter type was null or undefined when calling presenterAuthCallback.');
            }
            // verify required parameter 'presenterAuthCallbackRequestDTO' is not null or undefined
            if (presenterAuthCallbackRequestDTO === null || presenterAuthCallbackRequestDTO === undefined) {
                throw new base_1.RequiredError('presenterAuthCallbackRequestDTO', 'Required parameter presenterAuthCallbackRequestDTO was null or undefined when calling presenterAuthCallback.');
            }
            const localVarPath = `/presenter/v1/integration/{type}/oauthCallback`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", ["fanDataConfigure"])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof presenterAuthCallbackRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(presenterAuthCallbackRequestDTO !== undefined ? presenterAuthCallbackRequestDTO : {}) : (presenterAuthCallbackRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {PresenterCreateTicketRequestDTO} presenterCreateTicketRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        presenterCreateTickets: (presenterCreateTicketRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'presenterCreateTicketRequestDTO' is not null or undefined
            if (presenterCreateTicketRequestDTO === null || presenterCreateTicketRequestDTO === undefined) {
                throw new base_1.RequiredError('presenterCreateTicketRequestDTO', 'Required parameter presenterCreateTicketRequestDTO was null or undefined when calling presenterCreateTickets.');
            }
            const localVarPath = `/presenter/v1/tickets/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof presenterCreateTicketRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(presenterCreateTicketRequestDTO !== undefined ? presenterCreateTicketRequestDTO : {}) : (presenterCreateTicketRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} showId
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 10000
         * @param {boolean} [excludePast]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        presenterListShowTicketStats: (showId, startAfter, limit, excludePast, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'showId' is not null or undefined
            if (showId === null || showId === undefined) {
                throw new base_1.RequiredError('showId', 'Required parameter showId was null or undefined when calling presenterListShowTicketStats.');
            }
            const localVarPath = `/presenter/v1/show/ticketStats/{showId}`
                .replace(`{${"showId"}}`, encodeURIComponent(String(showId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (startAfter !== undefined) {
                localVarQueryParameter['startAfter'] = startAfter;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (excludePast !== undefined) {
                localVarQueryParameter['excludePast'] = excludePast;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {PresenterReassignTicketRequestDTO} presenterReassignTicketRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        presenterReassignTicket: (presenterReassignTicketRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'presenterReassignTicketRequestDTO' is not null or undefined
            if (presenterReassignTicketRequestDTO === null || presenterReassignTicketRequestDTO === undefined) {
                throw new base_1.RequiredError('presenterReassignTicketRequestDTO', 'Required parameter presenterReassignTicketRequestDTO was null or undefined when calling presenterReassignTicket.');
            }
            const localVarPath = `/presenter/v1/tickets/reassign`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof presenterReassignTicketRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(presenterReassignTicketRequestDTO !== undefined ? presenterReassignTicketRequestDTO : {}) : (presenterReassignTicketRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        presenterStitchConnection: (type, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'type' is not null or undefined
            if (type === null || type === undefined) {
                throw new base_1.RequiredError('type', 'Required parameter type was null or undefined when calling presenterStitchConnection.');
            }
            const localVarPath = `/presenter/v1/integration/{type}/stitch`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", ["fanDataConfigure"])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SNSNotificationType} xAmzSnsMessageType
         * @param {string} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receiveMintingTopicNotification: (xAmzSnsMessageType, body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'xAmzSnsMessageType' is not null or undefined
            if (xAmzSnsMessageType === null || xAmzSnsMessageType === undefined) {
                throw new base_1.RequiredError('xAmzSnsMessageType', 'Required parameter xAmzSnsMessageType was null or undefined when calling receiveMintingTopicNotification.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new base_1.RequiredError('body', 'Required parameter body was null or undefined when calling receiveMintingTopicNotification.');
            }
            const localVarPath = `/partner/v1/nftMintingTopicSubscription`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xAmzSnsMessageType !== undefined && xAmzSnsMessageType !== null) {
                localVarHeaderParameter['x-amz-sns-message-type'] = String(JSON.stringify(xAmzSnsMessageType));
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         * Invitations
         * @param {PresenterOrganizationRemoveMemberDTO} presenterOrganizationRemoveMemberDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeOrgMember: (presenterOrganizationRemoveMemberDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'presenterOrganizationRemoveMemberDTO' is not null or undefined
            if (presenterOrganizationRemoveMemberDTO === null || presenterOrganizationRemoveMemberDTO === undefined) {
                throw new base_1.RequiredError('presenterOrganizationRemoveMemberDTO', 'Required parameter presenterOrganizationRemoveMemberDTO was null or undefined when calling removeOrgMember.');
            }
            const localVarPath = `/v1/organization/members/remove`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof presenterOrganizationRemoveMemberDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(presenterOrganizationRemoveMemberDTO !== undefined ? presenterOrganizationRemoveMemberDTO : {}) : (presenterOrganizationRemoveMemberDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {AdminReplayNotificationRequestDTO} adminReplayNotificationRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replayNotifications: (id, adminReplayNotificationRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling replayNotifications.');
            }
            // verify required parameter 'adminReplayNotificationRequestDTO' is not null or undefined
            if (adminReplayNotificationRequestDTO === null || adminReplayNotificationRequestDTO === undefined) {
                throw new base_1.RequiredError('adminReplayNotificationRequestDTO', 'Required parameter adminReplayNotificationRequestDTO was null or undefined when calling replayNotifications.');
            }
            const localVarPath = `/admin/v1/notifications/replay/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof adminReplayNotificationRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(adminReplayNotificationRequestDTO !== undefined ? adminReplayNotificationRequestDTO : {}) : (adminReplayNotificationRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} eventId
         * @param {SendNotificationParams} sendNotificationParams
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEventOpenNotification: (eventId, sendNotificationParams, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'eventId' is not null or undefined
            if (eventId === null || eventId === undefined) {
                throw new base_1.RequiredError('eventId', 'Required parameter eventId was null or undefined when calling sendEventOpenNotification.');
            }
            // verify required parameter 'sendNotificationParams' is not null or undefined
            if (sendNotificationParams === null || sendNotificationParams === undefined) {
                throw new base_1.RequiredError('sendNotificationParams', 'Required parameter sendNotificationParams was null or undefined when calling sendEventOpenNotification.');
            }
            const localVarPath = `/presenter/v1/experience/vip/sendEventOpenNotification/{eventId}`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", ["toggleJoinState"])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof sendNotificationParams !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(sendNotificationParams !== undefined ? sendNotificationParams : {}) : (sendNotificationParams || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ReadyCheckNotificationParams} readyCheckNotificationParams
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendReadyCheckNotification: (readyCheckNotificationParams, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'readyCheckNotificationParams' is not null or undefined
            if (readyCheckNotificationParams === null || readyCheckNotificationParams === undefined) {
                throw new base_1.RequiredError('readyCheckNotificationParams', 'Required parameter readyCheckNotificationParams was null or undefined when calling sendReadyCheckNotification.');
            }
            const localVarPath = `/presenter/v1/experience/vip/sendReadyCheckNotification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof readyCheckNotificationParams !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(readyCheckNotificationParams !== undefined ? readyCheckNotificationParams : {}) : (readyCheckNotificationParams || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {StartPreRecordPreviewRequestDTO} startPreRecordPreviewRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startPreRecordPreview: (startPreRecordPreviewRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'startPreRecordPreviewRequestDTO' is not null or undefined
            if (startPreRecordPreviewRequestDTO === null || startPreRecordPreviewRequestDTO === undefined) {
                throw new base_1.RequiredError('startPreRecordPreviewRequestDTO', 'Required parameter startPreRecordPreviewRequestDTO was null or undefined when calling startPreRecordPreview.');
            }
            const localVarPath = `/admin/v1/generatePreRecordPreview/start`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof startPreRecordPreviewRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(startPreRecordPreviewRequestDTO !== undefined ? startPreRecordPreviewRequestDTO : {}) : (startPreRecordPreviewRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} subdomain
         * @param {CobrandSurveyRequestDTO} cobrandSurveyRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeSurveyResponse: (subdomain, cobrandSurveyRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'subdomain' is not null or undefined
            if (subdomain === null || subdomain === undefined) {
                throw new base_1.RequiredError('subdomain', 'Required parameter subdomain was null or undefined when calling storeSurveyResponse.');
            }
            // verify required parameter 'cobrandSurveyRequestDTO' is not null or undefined
            if (cobrandSurveyRequestDTO === null || cobrandSurveyRequestDTO === undefined) {
                throw new base_1.RequiredError('cobrandSurveyRequestDTO', 'Required parameter cobrandSurveyRequestDTO was null or undefined when calling storeSurveyResponse.');
            }
            const localVarPath = `/v1/cobrand/{subdomain}/survey`
                .replace(`{${"subdomain"}}`, encodeURIComponent(String(subdomain)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof cobrandSurveyRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(cobrandSurveyRequestDTO !== undefined ? cobrandSurveyRequestDTO : {}) : (cobrandSurveyRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} stripeSignature
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stripeSubscriptions: (stripeSignature, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'stripeSignature' is not null or undefined
            if (stripeSignature === null || stripeSignature === undefined) {
                throw new base_1.RequiredError('stripeSignature', 'Required parameter stripeSignature was null or undefined when calling stripeSubscriptions.');
            }
            const localVarPath = `/stripe/subscriptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (stripeSignature !== undefined && stripeSignature !== null) {
                localVarHeaderParameter['stripe-signature'] = String(stripeSignature);
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {PushSubscriptionResponseDTO} pushSubscriptionResponseDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscriptionToTopic: (pushSubscriptionResponseDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'pushSubscriptionResponseDTO' is not null or undefined
            if (pushSubscriptionResponseDTO === null || pushSubscriptionResponseDTO === undefined) {
                throw new base_1.RequiredError('pushSubscriptionResponseDTO', 'Required parameter pushSubscriptionResponseDTO was null or undefined when calling subscriptionToTopic.');
            }
            const localVarPath = `/v1/pushSubscriptions/subscribe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof pushSubscriptionResponseDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(pushSubscriptionResponseDTO !== undefined ? pushSubscriptionResponseDTO : {}) : (pushSubscriptionResponseDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} subdomain
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        surveyResponseConfirmation: (subdomain, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'subdomain' is not null or undefined
            if (subdomain === null || subdomain === undefined) {
                throw new base_1.RequiredError('subdomain', 'Required parameter subdomain was null or undefined when calling surveyResponseConfirmation.');
            }
            const localVarPath = `/v1/cobrand/{subdomain}/survey/confirmation`
                .replace(`{${"subdomain"}}`, encodeURIComponent(String(subdomain)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} subdomain
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        surveyResponseExists: (subdomain, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'subdomain' is not null or undefined
            if (subdomain === null || subdomain === undefined) {
                throw new base_1.RequiredError('subdomain', 'Required parameter subdomain was null or undefined when calling surveyResponseExists.');
            }
            const localVarPath = `/v1/cobrand/{subdomain}/survey`
                .replace(`{${"subdomain"}}`, encodeURIComponent(String(subdomain)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {EmailRequestDTO} emailRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testSendEmail: (emailRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'emailRequestDTO' is not null or undefined
            if (emailRequestDTO === null || emailRequestDTO === undefined) {
                throw new base_1.RequiredError('emailRequestDTO', 'Required parameter emailRequestDTO was null or undefined when calling testSendEmail.');
            }
            const localVarPath = `/admin/v1/tools/email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof emailRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(emailRequestDTO !== undefined ? emailRequestDTO : {}) : (emailRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} vipExperienceId
         * @param {UpdateJoinUrlRequest} updateJoinUrlRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleJoinState: (vipExperienceId, updateJoinUrlRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'vipExperienceId' is not null or undefined
            if (vipExperienceId === null || vipExperienceId === undefined) {
                throw new base_1.RequiredError('vipExperienceId', 'Required parameter vipExperienceId was null or undefined when calling toggleJoinState.');
            }
            // verify required parameter 'updateJoinUrlRequest' is not null or undefined
            if (updateJoinUrlRequest === null || updateJoinUrlRequest === undefined) {
                throw new base_1.RequiredError('updateJoinUrlRequest', 'Required parameter updateJoinUrlRequest was null or undefined when calling toggleJoinState.');
            }
            const localVarPath = `/presenter/v1/experience/vip/toggleJoinState/{vipExperienceId}`
                .replace(`{${"vipExperienceId"}}`, encodeURIComponent(String(vipExperienceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof updateJoinUrlRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(updateJoinUrlRequest !== undefined ? updateJoinUrlRequest : {}) : (updateJoinUrlRequest || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} userId
         * @param {PresenterOrganizationRoleDTO} presenterOrganizationRoleDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unassignMemberRoles: (userId, presenterOrganizationRoleDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new base_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling unassignMemberRoles.');
            }
            // verify required parameter 'presenterOrganizationRoleDTO' is not null or undefined
            if (presenterOrganizationRoleDTO === null || presenterOrganizationRoleDTO === undefined) {
                throw new base_1.RequiredError('presenterOrganizationRoleDTO', 'Required parameter presenterOrganizationRoleDTO was null or undefined when calling unassignMemberRoles.');
            }
            const localVarPath = `/v1/organization/members/{userId}/roles/unassign`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof presenterOrganizationRoleDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(presenterOrganizationRoleDTO !== undefined ? presenterOrganizationRoleDTO : {}) : (presenterOrganizationRoleDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {PushSubscriptionResponseDTO} pushSubscriptionResponseDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsubscriptionFromTopic: (pushSubscriptionResponseDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'pushSubscriptionResponseDTO' is not null or undefined
            if (pushSubscriptionResponseDTO === null || pushSubscriptionResponseDTO === undefined) {
                throw new base_1.RequiredError('pushSubscriptionResponseDTO', 'Required parameter pushSubscriptionResponseDTO was null or undefined when calling unsubscriptionFromTopic.');
            }
            const localVarPath = `/v1/pushSubscriptions/deleteSubscription`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof pushSubscriptionResponseDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(pushSubscriptionResponseDTO !== undefined ? pushSubscriptionResponseDTO : {}) : (pushSubscriptionResponseDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} vipExperienceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateArtistJoinUrl: (vipExperienceId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'vipExperienceId' is not null or undefined
            if (vipExperienceId === null || vipExperienceId === undefined) {
                throw new base_1.RequiredError('vipExperienceId', 'Required parameter vipExperienceId was null or undefined when calling updateArtistJoinUrl.');
            }
            const localVarPath = `/presenter/v1/experience/vip/updateArtistJoinUrl/{vipExperienceId}`
                .replace(`{${"vipExperienceId"}}`, encodeURIComponent(String(vipExperienceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} customerId
         * @param {UpdateCustomerRequestDTO} updateCustomerRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomer: (customerId, updateCustomerRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new base_1.RequiredError('customerId', 'Required parameter customerId was null or undefined when calling updateCustomer.');
            }
            // verify required parameter 'updateCustomerRequestDTO' is not null or undefined
            if (updateCustomerRequestDTO === null || updateCustomerRequestDTO === undefined) {
                throw new base_1.RequiredError('updateCustomerRequestDTO', 'Required parameter updateCustomerRequestDTO was null or undefined when calling updateCustomer.');
            }
            const localVarPath = `/v1/customers/{customerId}`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof updateCustomerRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(updateCustomerRequestDTO !== undefined ? updateCustomerRequestDTO : {}) : (updateCustomerRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {UpdateMyProfileRequestDTO} updateMyProfileRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyProfile: (updateMyProfileRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'updateMyProfileRequestDTO' is not null or undefined
            if (updateMyProfileRequestDTO === null || updateMyProfileRequestDTO === undefined) {
                throw new base_1.RequiredError('updateMyProfileRequestDTO', 'Required parameter updateMyProfileRequestDTO was null or undefined when calling updateMyProfile.');
            }
            const localVarPath = `/v1/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof updateMyProfileRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(updateMyProfileRequestDTO !== undefined ? updateMyProfileRequestDTO : {}) : (updateMyProfileRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {AdminUpdateNftTokenTransactionRequestDTO} adminUpdateNftTokenTransactionRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNftTokenTransaction: (id, adminUpdateNftTokenTransactionRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling updateNftTokenTransaction.');
            }
            // verify required parameter 'adminUpdateNftTokenTransactionRequestDTO' is not null or undefined
            if (adminUpdateNftTokenTransactionRequestDTO === null || adminUpdateNftTokenTransactionRequestDTO === undefined) {
                throw new base_1.RequiredError('adminUpdateNftTokenTransactionRequestDTO', 'Required parameter adminUpdateNftTokenTransactionRequestDTO was null or undefined when calling updateNftTokenTransaction.');
            }
            const localVarPath = `/admin/v1/nftTokenTransaction/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof adminUpdateNftTokenTransactionRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(adminUpdateNftTokenTransactionRequestDTO !== undefined ? adminUpdateNftTokenTransactionRequestDTO : {}) : (adminUpdateNftTokenTransactionRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} participantId
         * @param {VIPExperienceParticipantUpdate} vIPExperienceParticipantUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateParticipant: (participantId, vIPExperienceParticipantUpdate, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'participantId' is not null or undefined
            if (participantId === null || participantId === undefined) {
                throw new base_1.RequiredError('participantId', 'Required parameter participantId was null or undefined when calling updateParticipant.');
            }
            // verify required parameter 'vIPExperienceParticipantUpdate' is not null or undefined
            if (vIPExperienceParticipantUpdate === null || vIPExperienceParticipantUpdate === undefined) {
                throw new base_1.RequiredError('vIPExperienceParticipantUpdate', 'Required parameter vIPExperienceParticipantUpdate was null or undefined when calling updateParticipant.');
            }
            const localVarPath = `/presenter/v1/experience/vip/updateParticipant/{participantId}`
                .replace(`{${"participantId"}}`, encodeURIComponent(String(participantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof vIPExperienceParticipantUpdate !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(vIPExperienceParticipantUpdate !== undefined ? vIPExperienceParticipantUpdate : {}) : (vIPExperienceParticipantUpdate || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} paymentMethodId
         * @param {UpdatePaymentMethodRequestDTO} updatePaymentMethodRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePaymentMethods: (paymentMethodId, updatePaymentMethodRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'paymentMethodId' is not null or undefined
            if (paymentMethodId === null || paymentMethodId === undefined) {
                throw new base_1.RequiredError('paymentMethodId', 'Required parameter paymentMethodId was null or undefined when calling updatePaymentMethods.');
            }
            // verify required parameter 'updatePaymentMethodRequestDTO' is not null or undefined
            if (updatePaymentMethodRequestDTO === null || updatePaymentMethodRequestDTO === undefined) {
                throw new base_1.RequiredError('updatePaymentMethodRequestDTO', 'Required parameter updatePaymentMethodRequestDTO was null or undefined when calling updatePaymentMethods.');
            }
            const localVarPath = `/v1/customers/paymentMethodId/{paymentMethodId}`
                .replace(`{${"paymentMethodId"}}`, encodeURIComponent(String(paymentMethodId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", ["accessBilling"])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof updatePaymentMethodRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(updatePaymentMethodRequestDTO !== undefined ? updatePaymentMethodRequestDTO : {}) : (updatePaymentMethodRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} productId
         * @param {AdminUpdateProductRequestDTO} adminUpdateProductRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProduct: (productId, adminUpdateProductRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'productId' is not null or undefined
            if (productId === null || productId === undefined) {
                throw new base_1.RequiredError('productId', 'Required parameter productId was null or undefined when calling updateProduct.');
            }
            // verify required parameter 'adminUpdateProductRequestDTO' is not null or undefined
            if (adminUpdateProductRequestDTO === null || adminUpdateProductRequestDTO === undefined) {
                throw new base_1.RequiredError('adminUpdateProductRequestDTO', 'Required parameter adminUpdateProductRequestDTO was null or undefined when calling updateProduct.');
            }
            const localVarPath = `/v1/product/{productId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof adminUpdateProductRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(adminUpdateProductRequestDTO !== undefined ? adminUpdateProductRequestDTO : {}) : (adminUpdateProductRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} subscriptionId
         * @param {UpdateSubscriptionRequestDTO} updateSubscriptionRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscription: (subscriptionId, updateSubscriptionRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'subscriptionId' is not null or undefined
            if (subscriptionId === null || subscriptionId === undefined) {
                throw new base_1.RequiredError('subscriptionId', 'Required parameter subscriptionId was null or undefined when calling updateSubscription.');
            }
            // verify required parameter 'updateSubscriptionRequestDTO' is not null or undefined
            if (updateSubscriptionRequestDTO === null || updateSubscriptionRequestDTO === undefined) {
                throw new base_1.RequiredError('updateSubscriptionRequestDTO', 'Required parameter updateSubscriptionRequestDTO was null or undefined when calling updateSubscription.');
            }
            const localVarPath = `/v1/subscriptions/{subscriptionId}`
                .replace(`{${"subscriptionId"}}`, encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof updateSubscriptionRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(updateSubscriptionRequestDTO !== undefined ? updateSubscriptionRequestDTO : {}) : (updateSubscriptionRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {UpdateTopicSubscriptionUseCaseRequestDTO} updateTopicSubscriptionUseCaseRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscriptionToTopic: (updateTopicSubscriptionUseCaseRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'updateTopicSubscriptionUseCaseRequestDTO' is not null or undefined
            if (updateTopicSubscriptionUseCaseRequestDTO === null || updateTopicSubscriptionUseCaseRequestDTO === undefined) {
                throw new base_1.RequiredError('updateTopicSubscriptionUseCaseRequestDTO', 'Required parameter updateTopicSubscriptionUseCaseRequestDTO was null or undefined when calling updateSubscriptionToTopic.');
            }
            const localVarPath = `/v1/pushSubscriptions/updateTopicSubscriptionStatusAgain`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof updateTopicSubscriptionUseCaseRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(updateTopicSubscriptionUseCaseRequestDTO !== undefined ? updateTopicSubscriptionUseCaseRequestDTO : {}) : (updateTopicSubscriptionUseCaseRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} participantId
         * @param {VIPExperienceParticipantStatusUpdates} vIPExperienceParticipantStatusUpdates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVIPExperienceParticipantStatus: (participantId, vIPExperienceParticipantStatusUpdates, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'participantId' is not null or undefined
            if (participantId === null || participantId === undefined) {
                throw new base_1.RequiredError('participantId', 'Required parameter participantId was null or undefined when calling updateVIPExperienceParticipantStatus.');
            }
            // verify required parameter 'vIPExperienceParticipantStatusUpdates' is not null or undefined
            if (vIPExperienceParticipantStatusUpdates === null || vIPExperienceParticipantStatusUpdates === undefined) {
                throw new base_1.RequiredError('vIPExperienceParticipantStatusUpdates', 'Required parameter vIPExperienceParticipantStatusUpdates was null or undefined when calling updateVIPExperienceParticipantStatus.');
            }
            const localVarPath = `/v1/experience/vip/status/{participantId}`
                .replace(`{${"participantId"}}`, encodeURIComponent(String(participantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof vIPExperienceParticipantStatusUpdates !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(vIPExperienceParticipantStatusUpdates !== undefined ? vIPExperienceParticipantStatusUpdates : {}) : (vIPExperienceParticipantStatusUpdates || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {UpgradeSubscriptionRequestDTO} upgradeSubscriptionRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upgradeSubscription: (upgradeSubscriptionRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'upgradeSubscriptionRequestDTO' is not null or undefined
            if (upgradeSubscriptionRequestDTO === null || upgradeSubscriptionRequestDTO === undefined) {
                throw new base_1.RequiredError('upgradeSubscriptionRequestDTO', 'Required parameter upgradeSubscriptionRequestDTO was null or undefined when calling upgradeSubscription.');
            }
            const localVarPath = `/v1/subscriptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", ["accessBilling"])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof upgradeSubscriptionRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(upgradeSubscriptionRequestDTO !== undefined ? upgradeSubscriptionRequestDTO : {}) : (upgradeSubscriptionRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} productId
         * @param {AdminUploadImageRequestDTO} adminUploadImageRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadImage: (productId, adminUploadImageRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'productId' is not null or undefined
            if (productId === null || productId === undefined) {
                throw new base_1.RequiredError('productId', 'Required parameter productId was null or undefined when calling uploadImage.');
            }
            // verify required parameter 'adminUploadImageRequestDTO' is not null or undefined
            if (adminUploadImageRequestDTO === null || adminUploadImageRequestDTO === undefined) {
                throw new base_1.RequiredError('adminUploadImageRequestDTO', 'Required parameter adminUploadImageRequestDTO was null or undefined when calling uploadImage.');
            }
            const localVarPath = `/v1/product/images/{productId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof adminUploadImageRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(adminUploadImageRequestDTO !== undefined ? adminUploadImageRequestDTO : {}) : (adminUploadImageRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {AdminUploadNftAssetDTO} adminUploadNftAssetDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadNftAsset: (adminUploadNftAssetDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'adminUploadNftAssetDTO' is not null or undefined
            if (adminUploadNftAssetDTO === null || adminUploadNftAssetDTO === undefined) {
                throw new base_1.RequiredError('adminUploadNftAssetDTO', 'Required parameter adminUploadNftAssetDTO was null or undefined when calling uploadNftAsset.');
            }
            const localVarPath = `/admin/v1/nft/assetUpload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof adminUploadNftAssetDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(adminUploadNftAssetDTO !== undefined ? adminUploadNftAssetDTO : {}) : (adminUploadNftAssetDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {VIPExperiencePhotoUploadRequest} vIPExperiencePhotoUploadRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadVIPMeetPhoto: (vIPExperiencePhotoUploadRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'vIPExperiencePhotoUploadRequest' is not null or undefined
            if (vIPExperiencePhotoUploadRequest === null || vIPExperiencePhotoUploadRequest === undefined) {
                throw new base_1.RequiredError('vIPExperiencePhotoUploadRequest', 'Required parameter vIPExperiencePhotoUploadRequest was null or undefined when calling uploadVIPMeetPhoto.');
            }
            const localVarPath = `/admin/v1/experience/vip/photoUpload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof vIPExperiencePhotoUploadRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(vIPExperiencePhotoUploadRequest !== undefined ? vIPExperiencePhotoUploadRequest : {}) : (vIPExperiencePhotoUploadRequest || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {boolean} [excludePast]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewMyTickets: (startAfter, limit, excludePast, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/myTickets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (startAfter !== undefined) {
                localVarQueryParameter['startAfter'] = startAfter;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (excludePast !== undefined) {
                localVarQueryParameter['excludePast'] = excludePast;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * DefaultApi - functional programming interface
 * @export
 */
exports.DefaultApiFp = function (configuration) {
    return {
        /**
         *
         * @param {AcceptConsentRequestDTO} acceptConsentRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptConsent(acceptConsentRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).acceptConsent(acceptConsentRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptTOS(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).acceptTOS(options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {CreateCsatSurveyEntryRequestDTO} createCsatSurveyEntryRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSurveyToEvent(createCsatSurveyEntryRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).addSurveyToEvent(createCsatSurveyEntryRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {Array<UpdateIAPPriceMapDTOItem>} updateIAPPriceMapDTOItem
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAddIAPPriceMapItem(updateIAPPriceMapDTOItem, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).adminAddIAPPriceMapItem(updateIAPPriceMapDTOItem, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminApprovePreRecord(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).adminApprovePreRecord(id, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {InlineObject1} inlineObject1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminChangeShowState(id, inlineObject1, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).adminChangeShowState(id, inlineObject1, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {AdminCreateArtistRequestDTO} adminCreateArtistRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateArtist(adminCreateArtistRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).adminCreateArtist(adminCreateArtistRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {AdminCreateCobrandRequestDTO} adminCreateCobrandRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateCobrand(adminCreateCobrandRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).adminCreateCobrand(adminCreateCobrandRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {ICreateEventSetBody} iCreateEventSetBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateEventSet(iCreateEventSetBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).adminCreateEventSet(iCreateEventSetBody, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {AdminCreateEventStreamDetailsRequestDTO} adminCreateEventStreamDetailsRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateEventStreamDetails(adminCreateEventStreamDetailsRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).adminCreateEventStreamDetails(adminCreateEventStreamDetailsRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {CreateIAPConfigRequestDTO} createIAPConfigRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateIAPConfig(createIAPConfigRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).adminCreateIAPConfig(createIAPConfigRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {AdminCreateNftTokenRequestDTO} adminCreateNftTokenRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateNftToken(adminCreateNftTokenRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).adminCreateNftToken(adminCreateNftTokenRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {AdminCreateOrganizationRequestDTO} adminCreateOrganizationRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateOrganization(adminCreateOrganizationRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).adminCreateOrganization(adminCreateOrganizationRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {AdminCreateShowRequestDTO} adminCreateShowRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateShow(adminCreateShowRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).adminCreateShow(adminCreateShowRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {AdminCreateVenueRequestDTO} adminCreateVenueRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateVenue(adminCreateVenueRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).adminCreateVenue(adminCreateVenueRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {CreateVideoAssetDTO} createVideoAssetDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateVideoAsset(createVideoAssetDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).adminCreateVideoAsset(createVideoAssetDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateVideoAssetUploadUrl(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).adminCreateVideoAssetUploadUrl(options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteArtist(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).adminDeleteArtist(id, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteCobrand(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).adminDeleteCobrand(id, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteEventStreamDetails(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).adminDeleteEventStreamDetails(id, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteIAPConfig(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).adminDeleteIAPConfig(id, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteNftToken(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).adminDeleteNftToken(id, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteOrganization(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).adminDeleteOrganization(id, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {AdminDeleteShopifyStoreRequestDTO} adminDeleteShopifyStoreRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteShopifyStore(adminDeleteShopifyStoreRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).adminDeleteShopifyStore(adminDeleteShopifyStoreRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteShow(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).adminDeleteShow(id, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} venueId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteVenue(venueId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).adminDeleteVenue(venueId, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteVideoAsset(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).adminDeleteVideoAsset(id, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {AdminEditShowRequestDTO} adminEditShowRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEditShow(id, adminEditShowRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).adminEditShow(id, adminEditShowRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {IAddEventsBody} iAddEventsBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventSetAddEvents(id, iAddEventsBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).adminEventSetAddEvents(id, iAddEventsBody, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {IRemoveEventsBody} iRemoveEventsBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventSetRemoveEvents(id, iRemoveEventsBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).adminEventSetRemoveEvents(id, iRemoveEventsBody, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetEventSet(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).adminGetEventSet(id, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetEventStreamDetails(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).adminGetEventStreamDetails(id, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetIAPConfig(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).adminGetIAPConfig(id, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetIAPPriceMap(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).adminGetIAPPriceMap(options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetOrganization(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).adminGetOrganization(id, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetShow(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).adminGetShow(id, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         * Returns the stream details to the passed show for the currently authenticated user.  - includes ephemeral signed URLs for the both the public and admin replay tool endpoints    (the admin one simply allows viewing a replay with any trim values)
         * @param {string} showId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetShowStreamDetails(showId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).adminGetShowStreamDetails(showId, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListAppleInAppPurchaseProduct(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).adminListAppleInAppPurchaseProduct(options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {EventSetSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListEventSets(sortBy, sortOrder, startAfter, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).adminListEventSets(sortBy, sortOrder, startAfter, limit, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} [id]
         * @param {string} [eventId]
         * @param {EventIAPSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListIAPConfig(id, eventId, sortBy, sortOrder, startAfter, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).adminListIAPConfig(id, eventId, sortBy, sortOrder, startAfter, limit, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {OrganizationSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {string} [name]
         * @param {string} [displayName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListOrganizations(sortBy, sortOrder, startAfter, limit, name, displayName, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).adminListOrganizations(sortBy, sortOrder, startAfter, limit, name, displayName, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} [cobrand]
         * @param {string} [venueId]
         * @param {string} [artistId]
         * @param {string} [organizationId]
         * @param {Array<ShowType>} [type]
         * @param {string} [shopifyProductTag]
         * @param {string} [shopifyMerchTag]
         * @param {string} [muxId]
         * @param {boolean} [autoSchedule]
         * @param {Array<ShowState>} [state]
         * @param {string} [beforeDate]
         * @param {ShowSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 10000
         * @param {boolean} [excludePast] whether past shows should be included in the response. This parameter is incompatible with passing &#x60;sortBy&#x60; unless specific Firestore indices are created to support compound queries
         * @param {Array<AdminShowIncludes>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListShows(cobrand, venueId, artistId, organizationId, type, shopifyProductTag, shopifyMerchTag, muxId, autoSchedule, state, beforeDate, sortBy, sortOrder, startAfter, limit, excludePast, include, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).adminListShows(cobrand, venueId, artistId, organizationId, type, shopifyProductTag, shopifyMerchTag, muxId, autoSchedule, state, beforeDate, sortBy, sortOrder, startAfter, limit, excludePast, include, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} [managerId]
         * @param {string} [email]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 10000
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListShowsByManager(managerId, email, startAfter, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).adminListShowsByManager(managerId, email, startAfter, limit, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {string} [eventId]
         * @param {string} [artistId]
         * @param {string} [venueId]
         * @param {string} [organizationId]
         * @param {string} [search]
         * @param {string} [tags]
         * @param {boolean} [videoAssetIsPublic]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListVideoAssets(startAfter, limit, eventId, artistId, venueId, organizationId, search, tags, videoAssetIsPublic, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).adminListVideoAssets(startAfter, limit, eventId, artistId, venueId, organizationId, search, tags, videoAssetIsPublic, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {InlineObject} inlineObject
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRemoveIAPPriceMapItem(inlineObject, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).adminRemoveIAPPriceMapItem(inlineObject, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {number} [minDays]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSpotifyRefresh(id, minDays, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).adminSpotifyRefresh(id, minDays, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {AdminUpdateArtistRequestDTO} adminUpdateArtistRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateArtist(id, adminUpdateArtistRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).adminUpdateArtist(id, adminUpdateArtistRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {AdminUpdateCobrandRequestDTO} adminUpdateCobrandRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateCobrand(id, adminUpdateCobrandRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).adminUpdateCobrand(id, adminUpdateCobrandRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {IUpdateEventStreamDetailsUseCase} iUpdateEventStreamDetailsUseCase
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateEventStreamDetails(id, iUpdateEventStreamDetailsUseCase, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).adminUpdateEventStreamDetails(id, iUpdateEventStreamDetailsUseCase, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {UpdateIAPConfigRequestDTO} updateIAPConfigRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateIAPConfig(id, updateIAPConfigRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).adminUpdateIAPConfig(id, updateIAPConfigRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {AdminUpdateNftTokenRequestDTO} adminUpdateNftTokenRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateNftToken(id, adminUpdateNftTokenRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).adminUpdateNftToken(id, adminUpdateNftTokenRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {AdminUpdateOrganizationRequestDTO} adminUpdateOrganizationRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateOrganization(id, adminUpdateOrganizationRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).adminUpdateOrganization(id, adminUpdateOrganizationRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {AdminUpdateShopifyStoreRequestDTO} adminUpdateShopifyStoreRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateShopifyStore(adminUpdateShopifyStoreRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).adminUpdateShopifyStore(adminUpdateShopifyStoreRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} venueId
         * @param {AdminUpdateVenueRequestDTO} adminUpdateVenueRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateVenue(venueId, adminUpdateVenueRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).adminUpdateVenue(venueId, adminUpdateVenueRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {UpdateVideoAssetRequest} updateVideoAssetRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateVideoAsset(updateVideoAssetRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).adminUpdateVideoAsset(updateVideoAssetRequest, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} userId
         * @param {PresenterOrganizationRoleDTO} presenterOrganizationRoleDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignMemberRoles(userId, presenterOrganizationRoleDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).assignMemberRoles(userId, presenterOrganizationRoleDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {AssociateFileDefinitionRequestDTO} associateFileDefinitionRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        associateFileDefinition(associateFileDefinitionRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).associateFileDefinition(associateFileDefinitionRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} paymentMethodId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachPaymentMethodToCustomer(paymentMethodId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).attachPaymentMethodToCustomer(paymentMethodId, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} [venueId]
         * @param {string} [artistId]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bandsintownListShows(venueId, artistId, startAfter, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).bandsintownListShows(venueId, artistId, startAfter, limit, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} topic
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkForUserSubscriptionByTopic(topic, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).checkForUserSubscriptionByTopic(topic, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkForUserSurveyResponseByEventId(eventId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).checkForUserSurveyResponseByEventId(eventId, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} eventId
         * @param {VIPExperienceCheckInRequest} vIPExperienceCheckInRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkInToVIPExperience(eventId, vIPExperienceCheckInRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).checkInToVIPExperience(eventId, vIPExperienceCheckInRequest, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {ClaimByCodeRequestDTO} claimByCodeRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claimByCode(claimByCodeRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).claimByCode(claimByCodeRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} externalShowId
         * @param {string} externalCredential
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claimExternalTicket(externalShowId, externalCredential, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).claimExternalTicket(externalShowId, externalCredential, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claimMyTickets(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).claimMyTickets(options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {CompleteAppleIAPOrderRequestDTO} completeAppleIAPOrderRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeAppleIAPOrder(id, completeAppleIAPOrderRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).completeAppleIAPOrder(id, completeAppleIAPOrderRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {CompleteMultipartUploadRequestDTO} completeMultipartUploadRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completePreRecordUpload(completeMultipartUploadRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).completePreRecordUpload(completeMultipartUploadRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {CreateAppleIAPOrderRequestDTO} createAppleIAPOrderRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAppleIAPOrder(createAppleIAPOrderRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).createAppleIAPOrder(createAppleIAPOrderRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {GeneralSurveyResponseDTO} generalSurveyResponseDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGeneralSurveyResponse(generalSurveyResponseDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).createGeneralSurveyResponse(generalSurveyResponseDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {AdminCreateNftTokenTransactionRequestDTO} adminCreateNftTokenTransactionRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNftTokenTransaction(adminCreateNftTokenTransactionRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).createNftTokenTransaction(adminCreateNftTokenTransactionRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {CreateMultipartUploadRequestDTO} createMultipartUploadRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPreRecordUpload(createMultipartUploadRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).createPreRecordUpload(createMultipartUploadRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {AdminUpdateProductRequestDTO} adminUpdateProductRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProductForShow(adminUpdateProductRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).createProductForShow(adminUpdateProductRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {CreateSubscriptionRequestDTO} createSubscriptionRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubscription(createSubscriptionRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).createSubscription(createSubscriptionRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {CreateCsatSurveyRequestDTO} createCsatSurveyRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSurvey(createCsatSurveyRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).createSurvey(createCsatSurveyRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {CsatSurveyResponseDTO} csatSurveyResponseDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSurveyResponse(csatSurveyResponseDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).createSurveyResponse(csatSurveyResponseDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} showId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVIPExperience(showId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).createVIPExperience(showId, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {DeleteApiKeyRequestDTO} deleteApiKeyRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteApiKey(deleteApiKeyRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).deleteApiKey(deleteApiKeyRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} paymentMethodId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePaymentMethod(paymentMethodId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).deletePaymentMethod(paymentMethodId, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} assetId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableMasterAccessForAsset(assetId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).enableMasterAccessForAsset(assetId, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {ExternalAuthRequestDTO} externalAuthRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalLogin(externalAuthRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).externalLogin(externalAuthRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} surveyIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalSurveyResponsesBySurveyId(surveyIdentifier, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).generalSurveyResponsesBySurveyId(surveyIdentifier, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {GenerateApiKeyRequestDTO} generateApiKeyRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateApiKey(generateApiKeyRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).generateApiKey(generateApiKeyRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {GenerateCustomTokenRequestDTO} generateCustomTokenRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCustomToken(generateCustomTokenRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).generateCustomToken(generateCustomTokenRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {VIPExperienceCallTokenRequestParams} vIPExperienceCallTokenRequestParams
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateVIPExperienceCallToken(vIPExperienceCallTokenRequestParams, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).generateVIPExperienceCallToken(vIPExperienceCallTokenRequestParams, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} topic
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSubscriptionsByTopic(topic, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).getAllSubscriptionsByTopic(topic, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsersSubscriptions(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).getAllUsersSubscriptions(options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppleIAPOrder(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).getAppleIAPOrder(id, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} artistId
         * @param {boolean} [includeUpcomingEventsCount]
         * @param {boolean} [includePastEventsCount]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArtist(artistId, includeUpcomingEventsCount, includePastEventsCount, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).getArtist(artistId, includeUpcomingEventsCount, includePastEventsCount, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {NftAssetContentTypeRequest} nftAssetContentTypeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetContentType(nftAssetContentTypeRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).getAssetContentType(nftAssetContentTypeRequest, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} showId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatRoom(showId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).getChatRoom(showId, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} chatRoomId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatRoomById(chatRoomId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).getChatRoomById(chatRoomId, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatToken(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).getChatToken(options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} showId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatTranscriptsLink(showId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).getChatTranscriptsLink(showId, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} subdomain
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCobrand(subdomain, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).getCobrand(subdomain, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentOrganization(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).getCurrentOrganization(options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomer(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).getCustomer(options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         * Returns the stream details to the passed show for the currently authenticated user, given one of the following 1. The show is ticketed and the user has a ticket for the show (@todo check entitlement type) 2. The show is unticketed 3. The user is an admin 4. The user is a show manager  Includes an ephemeral signed URL for the public replay tool endpoint   (only the trimmed version of the replay is accessible)
         * @param {string} showId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventStreamDetails(showId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).getEventStreamDetails(showId, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} searchQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFanNavigatorPrices(searchQuery, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).getFanNavigatorPrices(searchQuery, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntegrations(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).getIntegrations(options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} channelId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestPinnedStreamChatMessages(channelId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).getLatestPinnedStreamChatMessages(channelId, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMailchimpAudiences(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).getMailchimpAudiences(options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} livestreamId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMuxAssetsForLivestream(livestreamId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).getMuxAssetsForLivestream(livestreamId, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNftToken(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).getNftToken(id, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentInformation(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).getPaymentInformation(options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentMethods(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).getPaymentMethods(options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} uploadDate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreSignedUrl(uploadDate, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).getPreSignedUrl(uploadDate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} productId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductPriceInformation(productId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).getProductPriceInformation(productId, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} surveyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResponsesBySurveyId(surveyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).getResponsesBySurveyId(surveyId, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} storeUrl
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShopifyStore(storeUrl, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).getShopifyStore(storeUrl, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} showId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShow(showId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).getShow(showId, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         * Returns the stream details to the passed show for the currently authenticated user, given one of the following 1. The show is ticketed and the user has a ticket for the show (@todo check entitlement type) 2. The show is unticketed 3. The user is an admin 4. The user is a show manager  Includes an ephemeral signed URL for the public replay tool endpoint   (only the trimmed version of the replay is accessible)
         * @param {string} showId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShowStreamDetails(showId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).getShowStreamDetails(showId, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} channelId
         * @param {number} [limit] Maximum value: 100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStreamChatMessages(channelId, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).getStreamChatMessages(channelId, limit, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} showId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscribedUserChatrooms(showId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).getSubscribedUserChatrooms(showId, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionInformation(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).getSubscriptionInformation(options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} surveyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurvey(surveyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).getSurvey(surveyId, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTOSAcceptance(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).getTOSAcceptance(options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVIPExperience(eventId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).getVIPExperience(eventId, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVIPExperienceAllowJoiningInfo(eventId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).getVIPExperienceAllowJoiningInfo(eventId, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVIPExperienceParticipants(eventId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).getVIPExperienceParticipants(eventId, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} venueId
         * @param {boolean} [includeUpcomingEventsCount]
         * @param {boolean} [includePastEventsCount]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVenue(venueId, includeUpcomingEventsCount, includePastEventsCount, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).getVenue(venueId, includeUpcomingEventsCount, includePastEventsCount, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        health(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).health(options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {IVotedAuthRequestDTO} iVotedAuthRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        iVotedLogin(iVotedAuthRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).iVotedLogin(iVotedAuthRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         * Creates Mandolin users and associates the provided ivoted externalID with that user for the purposes of allowing authentication. The returned response echoes the input, and will either include a jwt in the `token` field, or an `error` object with details on why that particular operation failed. The order of users in the response is not guaranteed to match the input order.  Authentication is handled via the `X-Api-Key` header. Its value should be set to `apiKey:secret`, where \"apiKey\" is the API key and \"secret\" is the secret value associated with that key.
         * @param {IVotedCreateUserRequestDTO} iVotedCreateUserRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        iVotedUsersCreate(iVotedCreateUserRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).iVotedUsersCreate(iVotedCreateUserRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {PresenterOrganizationInviteMemberDTO} presenterOrganizationInviteMemberDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteOrgMember(presenterOrganizationInviteMemberDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).inviteOrgMember(presenterOrganizationInviteMemberDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} [venueId]
         * @param {string} [artistId]
         * @param {ShowSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jamBaseListShows(venueId, artistId, sortBy, sortOrder, startAfter, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).jamBaseListShows(venueId, artistId, sortBy, sortOrder, startAfter, limit, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {JoinChannelRequestDTO} joinChannelRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinChannel(joinChannelRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).joinChannel(joinChannelRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} t
         * @param {string} name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinVIPExperienceAsArtist(t, name, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).joinVIPExperienceAsArtist(t, name, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {ArtistSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {boolean} [isFeatured]
         * @param {string} [cobrand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listArtists(sortBy, sortOrder, startAfter, limit, isFeatured, cobrand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).listArtists(sortBy, sortOrder, startAfter, limit, isFeatured, cobrand, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} showId
         * @param {TicketSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {number} [limit] Maximum value: 5000
         * @param {Array<TicketIncludes>} [include]
         * @param {TicketStatus} [status]
         * @param {string} [startAfter]
         * @param {Array<string>} [ticketIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAudience(showId, sortBy, sortOrder, limit, include, status, startAfter, ticketIds, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).listAudience(showId, sortBy, sortOrder, limit, include, status, startAfter, ticketIds, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {CobrandSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCobrands(sortBy, sortOrder, startAfter, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).listCobrands(sortBy, sortOrder, startAfter, limit, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMemberRoles(userId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).listMemberRoles(userId, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMembers(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).listMembers(options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMyApiKeys(startAfter, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).listMyApiKeys(startAfter, limit, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} [cobrand]
         * @param {string} [venueId]
         * @param {string} [artistId]
         * @param {ShowSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 200
         * @param {boolean} [excludePast]
         * @param {Array<ShowIncludes>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMyShows(cobrand, venueId, artistId, sortBy, sortOrder, startAfter, limit, excludePast, include, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).listMyShows(cobrand, venueId, artistId, sortBy, sortOrder, startAfter, limit, excludePast, include, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {NftTokenSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNftToken(sortBy, sortOrder, startAfter, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).listNftToken(sortBy, sortOrder, startAfter, limit, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {NftTokenTransactionSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {boolean} [includeMinted]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNftTokenTransaction(sortBy, sortOrder, startAfter, limit, includeMinted, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).listNftTokenTransaction(sortBy, sortOrder, startAfter, limit, includeMinted, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} tag
         * @param {ProductSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProductsByTag(tag, sortBy, sortOrder, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).listProductsByTag(tag, sortBy, sortOrder, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {number} [limit] Maximum value: 100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listShopifyStores(limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).listShopifyStores(limit, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} [cobrand]
         * @param {string} [venueId]
         * @param {string} [artistId]
         * @param {ShowSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 10000
         * @param {boolean} [excludePast] whether past shows should be included in the response. This parameter is incompatible with passing &#x60;sortBy&#x60; unless specific Firestore indices are created to support compound queries
         * @param {boolean} [iosOnlyShows] whether to only include shows with an associated eventIapConfig value
         * @param {Array<ShowIncludes>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listShows(cobrand, venueId, artistId, sortBy, sortOrder, startAfter, limit, excludePast, iosOnlyShows, include, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).listShows(cobrand, venueId, artistId, sortBy, sortOrder, startAfter, limit, excludePast, iosOnlyShows, include, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} [siteId]
         * @param {string} [slug]
         * @param {string} [surveyIdentifier]
         * @param {SortOrder} [sortOrder]
         * @param {number} [limit] Maximum value: 5000
         * @param {string} [startAfter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSurveyReponses(siteId, slug, surveyIdentifier, sortOrder, limit, startAfter, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).listSurveyReponses(siteId, slug, surveyIdentifier, sortOrder, limit, startAfter, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {CsatSurveySortBy} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSurveys(sortBy, sortOrder, startAfter, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).listSurveys(sortBy, sortOrder, startAfter, limit, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {VenueSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {boolean} [isFeatured]
         * @param {string} [cobrand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listVenues(sortBy, sortOrder, startAfter, limit, isFeatured, cobrand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).listVenues(sortBy, sortOrder, startAfter, limit, isFeatured, cobrand, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {ManagerChangeShowChatStateRequestDTO} managerChangeShowChatStateRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managerChangeShowChatState(id, managerChangeShowChatStateRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).managerChangeShowChatState(id, managerChangeShowChatStateRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {ManagerChangeShowStateRequestDTO} managerChangeShowStateRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managerChangeShowState(id, managerChangeShowStateRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).managerChangeShowState(id, managerChangeShowStateRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} showId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managerGetShow(showId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).managerGetShow(showId, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} [artistId]
         * @param {string} [cobrand]
         * @param {Array<ShowState>} [state]
         * @param {Array<ShowType>} [type]
         * @param {string} [venueId]
         * @param {string} [beforeDate]
         * @param {string} [afterDate]
         * @param {ShowSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 1000
         * @param {Array<ShowIncludes>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managerListManagedShows(artistId, cobrand, state, type, venueId, beforeDate, afterDate, sortBy, sortOrder, startAfter, limit, include, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).managerListManagedShows(artistId, cobrand, state, type, venueId, beforeDate, afterDate, sortBy, sortOrder, startAfter, limit, include, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {ShowSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {string} [shopifyProductTag]
         * @param {string} [shopifyMerchTag]
         * @param {number} [limit] Maximum value: 1000
         * @param {boolean} [excludePast] whether past shows should be included in the response. This parameter is incompatible with passing &#x60;sortBy&#x60; unless specific Firestore indices are created to support compound queries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managerListShows(sortBy, sortOrder, startAfter, shopifyProductTag, shopifyMerchTag, limit, excludePast, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).managerListShows(sortBy, sortOrder, startAfter, shopifyProductTag, shopifyMerchTag, limit, excludePast, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {MigrateApiKeyRequestDTO} migrateApiKeyRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrateApiKey(migrateApiKeyRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).migrateApiKey(migrateApiKeyRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {ProcessMintingUseCaseRequestDTO} processMintingUseCaseRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mintNft(processMintingUseCaseRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).mintNft(processMintingUseCaseRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        myProfile(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).myProfile(options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {UpdateCustomerRequestDTO} updateCustomerRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgUpdateCustomer(updateCustomerRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).orgUpdateCustomer(updateCustomerRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {PartnerCreateSingleTicketRequestDTO} partnerCreateSingleTicketRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerCreateSingleTicket(partnerCreateSingleTicketRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).partnerCreateSingleTicket(partnerCreateSingleTicketRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {PartnerCreateTicketRequestDTO} partnerCreateTicketRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerCreateTickets(partnerCreateTicketRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).partnerCreateTickets(partnerCreateTicketRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} showId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerGetShow(showId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).partnerGetShow(showId, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {PartnerRevokeTicketRequestDTO} partnerRevokeTicketRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerRevokeTickets(partnerRevokeTicketRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).partnerRevokeTickets(partnerRevokeTicketRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} type
         * @param {PresenterAuthCallbackRequestDTO} presenterAuthCallbackRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        presenterAuthCallback(type, presenterAuthCallbackRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).presenterAuthCallback(type, presenterAuthCallbackRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {PresenterCreateTicketRequestDTO} presenterCreateTicketRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        presenterCreateTickets(presenterCreateTicketRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).presenterCreateTickets(presenterCreateTicketRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} showId
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 10000
         * @param {boolean} [excludePast]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        presenterListShowTicketStats(showId, startAfter, limit, excludePast, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).presenterListShowTicketStats(showId, startAfter, limit, excludePast, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {PresenterReassignTicketRequestDTO} presenterReassignTicketRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        presenterReassignTicket(presenterReassignTicketRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).presenterReassignTicket(presenterReassignTicketRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        presenterStitchConnection(type, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).presenterStitchConnection(type, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {SNSNotificationType} xAmzSnsMessageType
         * @param {string} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receiveMintingTopicNotification(xAmzSnsMessageType, body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).receiveMintingTopicNotification(xAmzSnsMessageType, body, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         * Invitations
         * @param {PresenterOrganizationRemoveMemberDTO} presenterOrganizationRemoveMemberDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeOrgMember(presenterOrganizationRemoveMemberDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).removeOrgMember(presenterOrganizationRemoveMemberDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {AdminReplayNotificationRequestDTO} adminReplayNotificationRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replayNotifications(id, adminReplayNotificationRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).replayNotifications(id, adminReplayNotificationRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} eventId
         * @param {SendNotificationParams} sendNotificationParams
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEventOpenNotification(eventId, sendNotificationParams, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).sendEventOpenNotification(eventId, sendNotificationParams, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {ReadyCheckNotificationParams} readyCheckNotificationParams
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendReadyCheckNotification(readyCheckNotificationParams, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).sendReadyCheckNotification(readyCheckNotificationParams, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {StartPreRecordPreviewRequestDTO} startPreRecordPreviewRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startPreRecordPreview(startPreRecordPreviewRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).startPreRecordPreview(startPreRecordPreviewRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} subdomain
         * @param {CobrandSurveyRequestDTO} cobrandSurveyRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeSurveyResponse(subdomain, cobrandSurveyRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).storeSurveyResponse(subdomain, cobrandSurveyRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} stripeSignature
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stripeSubscriptions(stripeSignature, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).stripeSubscriptions(stripeSignature, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {PushSubscriptionResponseDTO} pushSubscriptionResponseDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscriptionToTopic(pushSubscriptionResponseDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).subscriptionToTopic(pushSubscriptionResponseDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} subdomain
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        surveyResponseConfirmation(subdomain, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).surveyResponseConfirmation(subdomain, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} subdomain
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        surveyResponseExists(subdomain, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).surveyResponseExists(subdomain, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {EmailRequestDTO} emailRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testSendEmail(emailRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).testSendEmail(emailRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} vipExperienceId
         * @param {UpdateJoinUrlRequest} updateJoinUrlRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleJoinState(vipExperienceId, updateJoinUrlRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).toggleJoinState(vipExperienceId, updateJoinUrlRequest, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} userId
         * @param {PresenterOrganizationRoleDTO} presenterOrganizationRoleDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unassignMemberRoles(userId, presenterOrganizationRoleDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).unassignMemberRoles(userId, presenterOrganizationRoleDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {PushSubscriptionResponseDTO} pushSubscriptionResponseDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsubscriptionFromTopic(pushSubscriptionResponseDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).unsubscriptionFromTopic(pushSubscriptionResponseDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} vipExperienceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateArtistJoinUrl(vipExperienceId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).updateArtistJoinUrl(vipExperienceId, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} customerId
         * @param {UpdateCustomerRequestDTO} updateCustomerRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomer(customerId, updateCustomerRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).updateCustomer(customerId, updateCustomerRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {UpdateMyProfileRequestDTO} updateMyProfileRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyProfile(updateMyProfileRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).updateMyProfile(updateMyProfileRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {AdminUpdateNftTokenTransactionRequestDTO} adminUpdateNftTokenTransactionRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNftTokenTransaction(id, adminUpdateNftTokenTransactionRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).updateNftTokenTransaction(id, adminUpdateNftTokenTransactionRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} participantId
         * @param {VIPExperienceParticipantUpdate} vIPExperienceParticipantUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateParticipant(participantId, vIPExperienceParticipantUpdate, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).updateParticipant(participantId, vIPExperienceParticipantUpdate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} paymentMethodId
         * @param {UpdatePaymentMethodRequestDTO} updatePaymentMethodRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePaymentMethods(paymentMethodId, updatePaymentMethodRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).updatePaymentMethods(paymentMethodId, updatePaymentMethodRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} productId
         * @param {AdminUpdateProductRequestDTO} adminUpdateProductRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProduct(productId, adminUpdateProductRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).updateProduct(productId, adminUpdateProductRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} subscriptionId
         * @param {UpdateSubscriptionRequestDTO} updateSubscriptionRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscription(subscriptionId, updateSubscriptionRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).updateSubscription(subscriptionId, updateSubscriptionRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {UpdateTopicSubscriptionUseCaseRequestDTO} updateTopicSubscriptionUseCaseRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscriptionToTopic(updateTopicSubscriptionUseCaseRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).updateSubscriptionToTopic(updateTopicSubscriptionUseCaseRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} participantId
         * @param {VIPExperienceParticipantStatusUpdates} vIPExperienceParticipantStatusUpdates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVIPExperienceParticipantStatus(participantId, vIPExperienceParticipantStatusUpdates, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).updateVIPExperienceParticipantStatus(participantId, vIPExperienceParticipantStatusUpdates, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {UpgradeSubscriptionRequestDTO} upgradeSubscriptionRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upgradeSubscription(upgradeSubscriptionRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).upgradeSubscription(upgradeSubscriptionRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} productId
         * @param {AdminUploadImageRequestDTO} adminUploadImageRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadImage(productId, adminUploadImageRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).uploadImage(productId, adminUploadImageRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {AdminUploadNftAssetDTO} adminUploadNftAssetDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadNftAsset(adminUploadNftAssetDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).uploadNftAsset(adminUploadNftAssetDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {VIPExperiencePhotoUploadRequest} vIPExperiencePhotoUploadRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadVIPMeetPhoto(vIPExperiencePhotoUploadRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).uploadVIPMeetPhoto(vIPExperiencePhotoUploadRequest, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {boolean} [excludePast]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewMyTickets(startAfter, limit, excludePast, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.DefaultApiAxiosParamCreator(configuration).viewMyTickets(startAfter, limit, excludePast, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
    };
};
/**
 * DefaultApi - factory interface
 * @export
 */
exports.DefaultApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @param {AcceptConsentRequestDTO} acceptConsentRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptConsent(acceptConsentRequestDTO, options) {
            return exports.DefaultApiFp(configuration).acceptConsent(acceptConsentRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptTOS(options) {
            return exports.DefaultApiFp(configuration).acceptTOS(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateCsatSurveyEntryRequestDTO} createCsatSurveyEntryRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSurveyToEvent(createCsatSurveyEntryRequestDTO, options) {
            return exports.DefaultApiFp(configuration).addSurveyToEvent(createCsatSurveyEntryRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<UpdateIAPPriceMapDTOItem>} updateIAPPriceMapDTOItem
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAddIAPPriceMapItem(updateIAPPriceMapDTOItem, options) {
            return exports.DefaultApiFp(configuration).adminAddIAPPriceMapItem(updateIAPPriceMapDTOItem, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminApprovePreRecord(id, options) {
            return exports.DefaultApiFp(configuration).adminApprovePreRecord(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {InlineObject1} inlineObject1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminChangeShowState(id, inlineObject1, options) {
            return exports.DefaultApiFp(configuration).adminChangeShowState(id, inlineObject1, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AdminCreateArtistRequestDTO} adminCreateArtistRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateArtist(adminCreateArtistRequestDTO, options) {
            return exports.DefaultApiFp(configuration).adminCreateArtist(adminCreateArtistRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AdminCreateCobrandRequestDTO} adminCreateCobrandRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateCobrand(adminCreateCobrandRequestDTO, options) {
            return exports.DefaultApiFp(configuration).adminCreateCobrand(adminCreateCobrandRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ICreateEventSetBody} iCreateEventSetBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateEventSet(iCreateEventSetBody, options) {
            return exports.DefaultApiFp(configuration).adminCreateEventSet(iCreateEventSetBody, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AdminCreateEventStreamDetailsRequestDTO} adminCreateEventStreamDetailsRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateEventStreamDetails(adminCreateEventStreamDetailsRequestDTO, options) {
            return exports.DefaultApiFp(configuration).adminCreateEventStreamDetails(adminCreateEventStreamDetailsRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateIAPConfigRequestDTO} createIAPConfigRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateIAPConfig(createIAPConfigRequestDTO, options) {
            return exports.DefaultApiFp(configuration).adminCreateIAPConfig(createIAPConfigRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AdminCreateNftTokenRequestDTO} adminCreateNftTokenRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateNftToken(adminCreateNftTokenRequestDTO, options) {
            return exports.DefaultApiFp(configuration).adminCreateNftToken(adminCreateNftTokenRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AdminCreateOrganizationRequestDTO} adminCreateOrganizationRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateOrganization(adminCreateOrganizationRequestDTO, options) {
            return exports.DefaultApiFp(configuration).adminCreateOrganization(adminCreateOrganizationRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AdminCreateShowRequestDTO} adminCreateShowRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateShow(adminCreateShowRequestDTO, options) {
            return exports.DefaultApiFp(configuration).adminCreateShow(adminCreateShowRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AdminCreateVenueRequestDTO} adminCreateVenueRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateVenue(adminCreateVenueRequestDTO, options) {
            return exports.DefaultApiFp(configuration).adminCreateVenue(adminCreateVenueRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateVideoAssetDTO} createVideoAssetDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateVideoAsset(createVideoAssetDTO, options) {
            return exports.DefaultApiFp(configuration).adminCreateVideoAsset(createVideoAssetDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateVideoAssetUploadUrl(options) {
            return exports.DefaultApiFp(configuration).adminCreateVideoAssetUploadUrl(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteArtist(id, options) {
            return exports.DefaultApiFp(configuration).adminDeleteArtist(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteCobrand(id, options) {
            return exports.DefaultApiFp(configuration).adminDeleteCobrand(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteEventStreamDetails(id, options) {
            return exports.DefaultApiFp(configuration).adminDeleteEventStreamDetails(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteIAPConfig(id, options) {
            return exports.DefaultApiFp(configuration).adminDeleteIAPConfig(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteNftToken(id, options) {
            return exports.DefaultApiFp(configuration).adminDeleteNftToken(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteOrganization(id, options) {
            return exports.DefaultApiFp(configuration).adminDeleteOrganization(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AdminDeleteShopifyStoreRequestDTO} adminDeleteShopifyStoreRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteShopifyStore(adminDeleteShopifyStoreRequestDTO, options) {
            return exports.DefaultApiFp(configuration).adminDeleteShopifyStore(adminDeleteShopifyStoreRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteShow(id, options) {
            return exports.DefaultApiFp(configuration).adminDeleteShow(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} venueId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteVenue(venueId, options) {
            return exports.DefaultApiFp(configuration).adminDeleteVenue(venueId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteVideoAsset(id, options) {
            return exports.DefaultApiFp(configuration).adminDeleteVideoAsset(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {AdminEditShowRequestDTO} adminEditShowRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEditShow(id, adminEditShowRequestDTO, options) {
            return exports.DefaultApiFp(configuration).adminEditShow(id, adminEditShowRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {IAddEventsBody} iAddEventsBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventSetAddEvents(id, iAddEventsBody, options) {
            return exports.DefaultApiFp(configuration).adminEventSetAddEvents(id, iAddEventsBody, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {IRemoveEventsBody} iRemoveEventsBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventSetRemoveEvents(id, iRemoveEventsBody, options) {
            return exports.DefaultApiFp(configuration).adminEventSetRemoveEvents(id, iRemoveEventsBody, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetEventSet(id, options) {
            return exports.DefaultApiFp(configuration).adminGetEventSet(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetEventStreamDetails(id, options) {
            return exports.DefaultApiFp(configuration).adminGetEventStreamDetails(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetIAPConfig(id, options) {
            return exports.DefaultApiFp(configuration).adminGetIAPConfig(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetIAPPriceMap(options) {
            return exports.DefaultApiFp(configuration).adminGetIAPPriceMap(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetOrganization(id, options) {
            return exports.DefaultApiFp(configuration).adminGetOrganization(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetShow(id, options) {
            return exports.DefaultApiFp(configuration).adminGetShow(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the stream details to the passed show for the currently authenticated user.  - includes ephemeral signed URLs for the both the public and admin replay tool endpoints    (the admin one simply allows viewing a replay with any trim values)
         * @param {string} showId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetShowStreamDetails(showId, options) {
            return exports.DefaultApiFp(configuration).adminGetShowStreamDetails(showId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListAppleInAppPurchaseProduct(options) {
            return exports.DefaultApiFp(configuration).adminListAppleInAppPurchaseProduct(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {EventSetSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListEventSets(sortBy, sortOrder, startAfter, limit, options) {
            return exports.DefaultApiFp(configuration).adminListEventSets(sortBy, sortOrder, startAfter, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [id]
         * @param {string} [eventId]
         * @param {EventIAPSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListIAPConfig(id, eventId, sortBy, sortOrder, startAfter, limit, options) {
            return exports.DefaultApiFp(configuration).adminListIAPConfig(id, eventId, sortBy, sortOrder, startAfter, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {OrganizationSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {string} [name]
         * @param {string} [displayName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListOrganizations(sortBy, sortOrder, startAfter, limit, name, displayName, options) {
            return exports.DefaultApiFp(configuration).adminListOrganizations(sortBy, sortOrder, startAfter, limit, name, displayName, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [cobrand]
         * @param {string} [venueId]
         * @param {string} [artistId]
         * @param {string} [organizationId]
         * @param {Array<ShowType>} [type]
         * @param {string} [shopifyProductTag]
         * @param {string} [shopifyMerchTag]
         * @param {string} [muxId]
         * @param {boolean} [autoSchedule]
         * @param {Array<ShowState>} [state]
         * @param {string} [beforeDate]
         * @param {ShowSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 10000
         * @param {boolean} [excludePast] whether past shows should be included in the response. This parameter is incompatible with passing &#x60;sortBy&#x60; unless specific Firestore indices are created to support compound queries
         * @param {Array<AdminShowIncludes>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListShows(cobrand, venueId, artistId, organizationId, type, shopifyProductTag, shopifyMerchTag, muxId, autoSchedule, state, beforeDate, sortBy, sortOrder, startAfter, limit, excludePast, include, options) {
            return exports.DefaultApiFp(configuration).adminListShows(cobrand, venueId, artistId, organizationId, type, shopifyProductTag, shopifyMerchTag, muxId, autoSchedule, state, beforeDate, sortBy, sortOrder, startAfter, limit, excludePast, include, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [managerId]
         * @param {string} [email]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 10000
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListShowsByManager(managerId, email, startAfter, limit, options) {
            return exports.DefaultApiFp(configuration).adminListShowsByManager(managerId, email, startAfter, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {string} [eventId]
         * @param {string} [artistId]
         * @param {string} [venueId]
         * @param {string} [organizationId]
         * @param {string} [search]
         * @param {string} [tags]
         * @param {boolean} [videoAssetIsPublic]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListVideoAssets(startAfter, limit, eventId, artistId, venueId, organizationId, search, tags, videoAssetIsPublic, options) {
            return exports.DefaultApiFp(configuration).adminListVideoAssets(startAfter, limit, eventId, artistId, venueId, organizationId, search, tags, videoAssetIsPublic, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {InlineObject} inlineObject
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRemoveIAPPriceMapItem(inlineObject, options) {
            return exports.DefaultApiFp(configuration).adminRemoveIAPPriceMapItem(inlineObject, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {number} [minDays]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSpotifyRefresh(id, minDays, options) {
            return exports.DefaultApiFp(configuration).adminSpotifyRefresh(id, minDays, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {AdminUpdateArtistRequestDTO} adminUpdateArtistRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateArtist(id, adminUpdateArtistRequestDTO, options) {
            return exports.DefaultApiFp(configuration).adminUpdateArtist(id, adminUpdateArtistRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {AdminUpdateCobrandRequestDTO} adminUpdateCobrandRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateCobrand(id, adminUpdateCobrandRequestDTO, options) {
            return exports.DefaultApiFp(configuration).adminUpdateCobrand(id, adminUpdateCobrandRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {IUpdateEventStreamDetailsUseCase} iUpdateEventStreamDetailsUseCase
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateEventStreamDetails(id, iUpdateEventStreamDetailsUseCase, options) {
            return exports.DefaultApiFp(configuration).adminUpdateEventStreamDetails(id, iUpdateEventStreamDetailsUseCase, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdateIAPConfigRequestDTO} updateIAPConfigRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateIAPConfig(id, updateIAPConfigRequestDTO, options) {
            return exports.DefaultApiFp(configuration).adminUpdateIAPConfig(id, updateIAPConfigRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {AdminUpdateNftTokenRequestDTO} adminUpdateNftTokenRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateNftToken(id, adminUpdateNftTokenRequestDTO, options) {
            return exports.DefaultApiFp(configuration).adminUpdateNftToken(id, adminUpdateNftTokenRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {AdminUpdateOrganizationRequestDTO} adminUpdateOrganizationRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateOrganization(id, adminUpdateOrganizationRequestDTO, options) {
            return exports.DefaultApiFp(configuration).adminUpdateOrganization(id, adminUpdateOrganizationRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AdminUpdateShopifyStoreRequestDTO} adminUpdateShopifyStoreRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateShopifyStore(adminUpdateShopifyStoreRequestDTO, options) {
            return exports.DefaultApiFp(configuration).adminUpdateShopifyStore(adminUpdateShopifyStoreRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} venueId
         * @param {AdminUpdateVenueRequestDTO} adminUpdateVenueRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateVenue(venueId, adminUpdateVenueRequestDTO, options) {
            return exports.DefaultApiFp(configuration).adminUpdateVenue(venueId, adminUpdateVenueRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UpdateVideoAssetRequest} updateVideoAssetRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateVideoAsset(updateVideoAssetRequest, options) {
            return exports.DefaultApiFp(configuration).adminUpdateVideoAsset(updateVideoAssetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} userId
         * @param {PresenterOrganizationRoleDTO} presenterOrganizationRoleDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignMemberRoles(userId, presenterOrganizationRoleDTO, options) {
            return exports.DefaultApiFp(configuration).assignMemberRoles(userId, presenterOrganizationRoleDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AssociateFileDefinitionRequestDTO} associateFileDefinitionRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        associateFileDefinition(associateFileDefinitionRequestDTO, options) {
            return exports.DefaultApiFp(configuration).associateFileDefinition(associateFileDefinitionRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} paymentMethodId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachPaymentMethodToCustomer(paymentMethodId, options) {
            return exports.DefaultApiFp(configuration).attachPaymentMethodToCustomer(paymentMethodId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [venueId]
         * @param {string} [artistId]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bandsintownListShows(venueId, artistId, startAfter, limit, options) {
            return exports.DefaultApiFp(configuration).bandsintownListShows(venueId, artistId, startAfter, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} topic
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkForUserSubscriptionByTopic(topic, options) {
            return exports.DefaultApiFp(configuration).checkForUserSubscriptionByTopic(topic, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkForUserSurveyResponseByEventId(eventId, options) {
            return exports.DefaultApiFp(configuration).checkForUserSurveyResponseByEventId(eventId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} eventId
         * @param {VIPExperienceCheckInRequest} vIPExperienceCheckInRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkInToVIPExperience(eventId, vIPExperienceCheckInRequest, options) {
            return exports.DefaultApiFp(configuration).checkInToVIPExperience(eventId, vIPExperienceCheckInRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ClaimByCodeRequestDTO} claimByCodeRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claimByCode(claimByCodeRequestDTO, options) {
            return exports.DefaultApiFp(configuration).claimByCode(claimByCodeRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} externalShowId
         * @param {string} externalCredential
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claimExternalTicket(externalShowId, externalCredential, options) {
            return exports.DefaultApiFp(configuration).claimExternalTicket(externalShowId, externalCredential, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claimMyTickets(options) {
            return exports.DefaultApiFp(configuration).claimMyTickets(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {CompleteAppleIAPOrderRequestDTO} completeAppleIAPOrderRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeAppleIAPOrder(id, completeAppleIAPOrderRequestDTO, options) {
            return exports.DefaultApiFp(configuration).completeAppleIAPOrder(id, completeAppleIAPOrderRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CompleteMultipartUploadRequestDTO} completeMultipartUploadRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completePreRecordUpload(completeMultipartUploadRequestDTO, options) {
            return exports.DefaultApiFp(configuration).completePreRecordUpload(completeMultipartUploadRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateAppleIAPOrderRequestDTO} createAppleIAPOrderRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAppleIAPOrder(createAppleIAPOrderRequestDTO, options) {
            return exports.DefaultApiFp(configuration).createAppleIAPOrder(createAppleIAPOrderRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {GeneralSurveyResponseDTO} generalSurveyResponseDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGeneralSurveyResponse(generalSurveyResponseDTO, options) {
            return exports.DefaultApiFp(configuration).createGeneralSurveyResponse(generalSurveyResponseDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AdminCreateNftTokenTransactionRequestDTO} adminCreateNftTokenTransactionRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNftTokenTransaction(adminCreateNftTokenTransactionRequestDTO, options) {
            return exports.DefaultApiFp(configuration).createNftTokenTransaction(adminCreateNftTokenTransactionRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateMultipartUploadRequestDTO} createMultipartUploadRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPreRecordUpload(createMultipartUploadRequestDTO, options) {
            return exports.DefaultApiFp(configuration).createPreRecordUpload(createMultipartUploadRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AdminUpdateProductRequestDTO} adminUpdateProductRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProductForShow(adminUpdateProductRequestDTO, options) {
            return exports.DefaultApiFp(configuration).createProductForShow(adminUpdateProductRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateSubscriptionRequestDTO} createSubscriptionRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubscription(createSubscriptionRequestDTO, options) {
            return exports.DefaultApiFp(configuration).createSubscription(createSubscriptionRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateCsatSurveyRequestDTO} createCsatSurveyRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSurvey(createCsatSurveyRequestDTO, options) {
            return exports.DefaultApiFp(configuration).createSurvey(createCsatSurveyRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CsatSurveyResponseDTO} csatSurveyResponseDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSurveyResponse(csatSurveyResponseDTO, options) {
            return exports.DefaultApiFp(configuration).createSurveyResponse(csatSurveyResponseDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} showId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVIPExperience(showId, options) {
            return exports.DefaultApiFp(configuration).createVIPExperience(showId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DeleteApiKeyRequestDTO} deleteApiKeyRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteApiKey(deleteApiKeyRequestDTO, options) {
            return exports.DefaultApiFp(configuration).deleteApiKey(deleteApiKeyRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} paymentMethodId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePaymentMethod(paymentMethodId, options) {
            return exports.DefaultApiFp(configuration).deletePaymentMethod(paymentMethodId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} assetId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableMasterAccessForAsset(assetId, options) {
            return exports.DefaultApiFp(configuration).enableMasterAccessForAsset(assetId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ExternalAuthRequestDTO} externalAuthRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalLogin(externalAuthRequestDTO, options) {
            return exports.DefaultApiFp(configuration).externalLogin(externalAuthRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} surveyIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalSurveyResponsesBySurveyId(surveyIdentifier, options) {
            return exports.DefaultApiFp(configuration).generalSurveyResponsesBySurveyId(surveyIdentifier, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {GenerateApiKeyRequestDTO} generateApiKeyRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateApiKey(generateApiKeyRequestDTO, options) {
            return exports.DefaultApiFp(configuration).generateApiKey(generateApiKeyRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {GenerateCustomTokenRequestDTO} generateCustomTokenRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCustomToken(generateCustomTokenRequestDTO, options) {
            return exports.DefaultApiFp(configuration).generateCustomToken(generateCustomTokenRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {VIPExperienceCallTokenRequestParams} vIPExperienceCallTokenRequestParams
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateVIPExperienceCallToken(vIPExperienceCallTokenRequestParams, options) {
            return exports.DefaultApiFp(configuration).generateVIPExperienceCallToken(vIPExperienceCallTokenRequestParams, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} topic
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSubscriptionsByTopic(topic, options) {
            return exports.DefaultApiFp(configuration).getAllSubscriptionsByTopic(topic, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsersSubscriptions(options) {
            return exports.DefaultApiFp(configuration).getAllUsersSubscriptions(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppleIAPOrder(id, options) {
            return exports.DefaultApiFp(configuration).getAppleIAPOrder(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} artistId
         * @param {boolean} [includeUpcomingEventsCount]
         * @param {boolean} [includePastEventsCount]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArtist(artistId, includeUpcomingEventsCount, includePastEventsCount, options) {
            return exports.DefaultApiFp(configuration).getArtist(artistId, includeUpcomingEventsCount, includePastEventsCount, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {NftAssetContentTypeRequest} nftAssetContentTypeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetContentType(nftAssetContentTypeRequest, options) {
            return exports.DefaultApiFp(configuration).getAssetContentType(nftAssetContentTypeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} showId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatRoom(showId, options) {
            return exports.DefaultApiFp(configuration).getChatRoom(showId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} chatRoomId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatRoomById(chatRoomId, options) {
            return exports.DefaultApiFp(configuration).getChatRoomById(chatRoomId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatToken(options) {
            return exports.DefaultApiFp(configuration).getChatToken(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} showId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatTranscriptsLink(showId, options) {
            return exports.DefaultApiFp(configuration).getChatTranscriptsLink(showId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} subdomain
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCobrand(subdomain, options) {
            return exports.DefaultApiFp(configuration).getCobrand(subdomain, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentOrganization(options) {
            return exports.DefaultApiFp(configuration).getCurrentOrganization(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomer(options) {
            return exports.DefaultApiFp(configuration).getCustomer(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the stream details to the passed show for the currently authenticated user, given one of the following 1. The show is ticketed and the user has a ticket for the show (@todo check entitlement type) 2. The show is unticketed 3. The user is an admin 4. The user is a show manager  Includes an ephemeral signed URL for the public replay tool endpoint   (only the trimmed version of the replay is accessible)
         * @param {string} showId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventStreamDetails(showId, options) {
            return exports.DefaultApiFp(configuration).getEventStreamDetails(showId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} searchQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFanNavigatorPrices(searchQuery, options) {
            return exports.DefaultApiFp(configuration).getFanNavigatorPrices(searchQuery, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntegrations(options) {
            return exports.DefaultApiFp(configuration).getIntegrations(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} channelId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestPinnedStreamChatMessages(channelId, options) {
            return exports.DefaultApiFp(configuration).getLatestPinnedStreamChatMessages(channelId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMailchimpAudiences(options) {
            return exports.DefaultApiFp(configuration).getMailchimpAudiences(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} livestreamId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMuxAssetsForLivestream(livestreamId, options) {
            return exports.DefaultApiFp(configuration).getMuxAssetsForLivestream(livestreamId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNftToken(id, options) {
            return exports.DefaultApiFp(configuration).getNftToken(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentInformation(options) {
            return exports.DefaultApiFp(configuration).getPaymentInformation(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentMethods(options) {
            return exports.DefaultApiFp(configuration).getPaymentMethods(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} uploadDate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreSignedUrl(uploadDate, options) {
            return exports.DefaultApiFp(configuration).getPreSignedUrl(uploadDate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} productId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductPriceInformation(productId, options) {
            return exports.DefaultApiFp(configuration).getProductPriceInformation(productId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} surveyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResponsesBySurveyId(surveyId, options) {
            return exports.DefaultApiFp(configuration).getResponsesBySurveyId(surveyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} storeUrl
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShopifyStore(storeUrl, options) {
            return exports.DefaultApiFp(configuration).getShopifyStore(storeUrl, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} showId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShow(showId, options) {
            return exports.DefaultApiFp(configuration).getShow(showId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the stream details to the passed show for the currently authenticated user, given one of the following 1. The show is ticketed and the user has a ticket for the show (@todo check entitlement type) 2. The show is unticketed 3. The user is an admin 4. The user is a show manager  Includes an ephemeral signed URL for the public replay tool endpoint   (only the trimmed version of the replay is accessible)
         * @param {string} showId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShowStreamDetails(showId, options) {
            return exports.DefaultApiFp(configuration).getShowStreamDetails(showId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} channelId
         * @param {number} [limit] Maximum value: 100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStreamChatMessages(channelId, limit, options) {
            return exports.DefaultApiFp(configuration).getStreamChatMessages(channelId, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} showId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscribedUserChatrooms(showId, options) {
            return exports.DefaultApiFp(configuration).getSubscribedUserChatrooms(showId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionInformation(options) {
            return exports.DefaultApiFp(configuration).getSubscriptionInformation(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} surveyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurvey(surveyId, options) {
            return exports.DefaultApiFp(configuration).getSurvey(surveyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTOSAcceptance(options) {
            return exports.DefaultApiFp(configuration).getTOSAcceptance(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVIPExperience(eventId, options) {
            return exports.DefaultApiFp(configuration).getVIPExperience(eventId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVIPExperienceAllowJoiningInfo(eventId, options) {
            return exports.DefaultApiFp(configuration).getVIPExperienceAllowJoiningInfo(eventId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVIPExperienceParticipants(eventId, options) {
            return exports.DefaultApiFp(configuration).getVIPExperienceParticipants(eventId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} venueId
         * @param {boolean} [includeUpcomingEventsCount]
         * @param {boolean} [includePastEventsCount]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVenue(venueId, includeUpcomingEventsCount, includePastEventsCount, options) {
            return exports.DefaultApiFp(configuration).getVenue(venueId, includeUpcomingEventsCount, includePastEventsCount, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        health(options) {
            return exports.DefaultApiFp(configuration).health(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {IVotedAuthRequestDTO} iVotedAuthRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        iVotedLogin(iVotedAuthRequestDTO, options) {
            return exports.DefaultApiFp(configuration).iVotedLogin(iVotedAuthRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates Mandolin users and associates the provided ivoted externalID with that user for the purposes of allowing authentication. The returned response echoes the input, and will either include a jwt in the `token` field, or an `error` object with details on why that particular operation failed. The order of users in the response is not guaranteed to match the input order.  Authentication is handled via the `X-Api-Key` header. Its value should be set to `apiKey:secret`, where \"apiKey\" is the API key and \"secret\" is the secret value associated with that key.
         * @param {IVotedCreateUserRequestDTO} iVotedCreateUserRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        iVotedUsersCreate(iVotedCreateUserRequestDTO, options) {
            return exports.DefaultApiFp(configuration).iVotedUsersCreate(iVotedCreateUserRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PresenterOrganizationInviteMemberDTO} presenterOrganizationInviteMemberDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteOrgMember(presenterOrganizationInviteMemberDTO, options) {
            return exports.DefaultApiFp(configuration).inviteOrgMember(presenterOrganizationInviteMemberDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [venueId]
         * @param {string} [artistId]
         * @param {ShowSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jamBaseListShows(venueId, artistId, sortBy, sortOrder, startAfter, limit, options) {
            return exports.DefaultApiFp(configuration).jamBaseListShows(venueId, artistId, sortBy, sortOrder, startAfter, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {JoinChannelRequestDTO} joinChannelRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinChannel(joinChannelRequestDTO, options) {
            return exports.DefaultApiFp(configuration).joinChannel(joinChannelRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} t
         * @param {string} name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinVIPExperienceAsArtist(t, name, options) {
            return exports.DefaultApiFp(configuration).joinVIPExperienceAsArtist(t, name, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ArtistSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {boolean} [isFeatured]
         * @param {string} [cobrand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listArtists(sortBy, sortOrder, startAfter, limit, isFeatured, cobrand, options) {
            return exports.DefaultApiFp(configuration).listArtists(sortBy, sortOrder, startAfter, limit, isFeatured, cobrand, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} showId
         * @param {TicketSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {number} [limit] Maximum value: 5000
         * @param {Array<TicketIncludes>} [include]
         * @param {TicketStatus} [status]
         * @param {string} [startAfter]
         * @param {Array<string>} [ticketIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAudience(showId, sortBy, sortOrder, limit, include, status, startAfter, ticketIds, options) {
            return exports.DefaultApiFp(configuration).listAudience(showId, sortBy, sortOrder, limit, include, status, startAfter, ticketIds, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CobrandSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCobrands(sortBy, sortOrder, startAfter, limit, options) {
            return exports.DefaultApiFp(configuration).listCobrands(sortBy, sortOrder, startAfter, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMemberRoles(userId, options) {
            return exports.DefaultApiFp(configuration).listMemberRoles(userId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMembers(options) {
            return exports.DefaultApiFp(configuration).listMembers(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMyApiKeys(startAfter, limit, options) {
            return exports.DefaultApiFp(configuration).listMyApiKeys(startAfter, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [cobrand]
         * @param {string} [venueId]
         * @param {string} [artistId]
         * @param {ShowSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 200
         * @param {boolean} [excludePast]
         * @param {Array<ShowIncludes>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMyShows(cobrand, venueId, artistId, sortBy, sortOrder, startAfter, limit, excludePast, include, options) {
            return exports.DefaultApiFp(configuration).listMyShows(cobrand, venueId, artistId, sortBy, sortOrder, startAfter, limit, excludePast, include, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {NftTokenSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNftToken(sortBy, sortOrder, startAfter, limit, options) {
            return exports.DefaultApiFp(configuration).listNftToken(sortBy, sortOrder, startAfter, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {NftTokenTransactionSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {boolean} [includeMinted]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNftTokenTransaction(sortBy, sortOrder, startAfter, limit, includeMinted, options) {
            return exports.DefaultApiFp(configuration).listNftTokenTransaction(sortBy, sortOrder, startAfter, limit, includeMinted, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} tag
         * @param {ProductSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProductsByTag(tag, sortBy, sortOrder, options) {
            return exports.DefaultApiFp(configuration).listProductsByTag(tag, sortBy, sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [limit] Maximum value: 100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listShopifyStores(limit, options) {
            return exports.DefaultApiFp(configuration).listShopifyStores(limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [cobrand]
         * @param {string} [venueId]
         * @param {string} [artistId]
         * @param {ShowSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 10000
         * @param {boolean} [excludePast] whether past shows should be included in the response. This parameter is incompatible with passing &#x60;sortBy&#x60; unless specific Firestore indices are created to support compound queries
         * @param {boolean} [iosOnlyShows] whether to only include shows with an associated eventIapConfig value
         * @param {Array<ShowIncludes>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listShows(cobrand, venueId, artistId, sortBy, sortOrder, startAfter, limit, excludePast, iosOnlyShows, include, options) {
            return exports.DefaultApiFp(configuration).listShows(cobrand, venueId, artistId, sortBy, sortOrder, startAfter, limit, excludePast, iosOnlyShows, include, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [siteId]
         * @param {string} [slug]
         * @param {string} [surveyIdentifier]
         * @param {SortOrder} [sortOrder]
         * @param {number} [limit] Maximum value: 5000
         * @param {string} [startAfter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSurveyReponses(siteId, slug, surveyIdentifier, sortOrder, limit, startAfter, options) {
            return exports.DefaultApiFp(configuration).listSurveyReponses(siteId, slug, surveyIdentifier, sortOrder, limit, startAfter, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CsatSurveySortBy} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSurveys(sortBy, sortOrder, startAfter, limit, options) {
            return exports.DefaultApiFp(configuration).listSurveys(sortBy, sortOrder, startAfter, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {VenueSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {boolean} [isFeatured]
         * @param {string} [cobrand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listVenues(sortBy, sortOrder, startAfter, limit, isFeatured, cobrand, options) {
            return exports.DefaultApiFp(configuration).listVenues(sortBy, sortOrder, startAfter, limit, isFeatured, cobrand, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {ManagerChangeShowChatStateRequestDTO} managerChangeShowChatStateRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managerChangeShowChatState(id, managerChangeShowChatStateRequestDTO, options) {
            return exports.DefaultApiFp(configuration).managerChangeShowChatState(id, managerChangeShowChatStateRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {ManagerChangeShowStateRequestDTO} managerChangeShowStateRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managerChangeShowState(id, managerChangeShowStateRequestDTO, options) {
            return exports.DefaultApiFp(configuration).managerChangeShowState(id, managerChangeShowStateRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} showId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managerGetShow(showId, options) {
            return exports.DefaultApiFp(configuration).managerGetShow(showId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [artistId]
         * @param {string} [cobrand]
         * @param {Array<ShowState>} [state]
         * @param {Array<ShowType>} [type]
         * @param {string} [venueId]
         * @param {string} [beforeDate]
         * @param {string} [afterDate]
         * @param {ShowSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 1000
         * @param {Array<ShowIncludes>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managerListManagedShows(artistId, cobrand, state, type, venueId, beforeDate, afterDate, sortBy, sortOrder, startAfter, limit, include, options) {
            return exports.DefaultApiFp(configuration).managerListManagedShows(artistId, cobrand, state, type, venueId, beforeDate, afterDate, sortBy, sortOrder, startAfter, limit, include, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ShowSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {string} [shopifyProductTag]
         * @param {string} [shopifyMerchTag]
         * @param {number} [limit] Maximum value: 1000
         * @param {boolean} [excludePast] whether past shows should be included in the response. This parameter is incompatible with passing &#x60;sortBy&#x60; unless specific Firestore indices are created to support compound queries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managerListShows(sortBy, sortOrder, startAfter, shopifyProductTag, shopifyMerchTag, limit, excludePast, options) {
            return exports.DefaultApiFp(configuration).managerListShows(sortBy, sortOrder, startAfter, shopifyProductTag, shopifyMerchTag, limit, excludePast, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {MigrateApiKeyRequestDTO} migrateApiKeyRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrateApiKey(migrateApiKeyRequestDTO, options) {
            return exports.DefaultApiFp(configuration).migrateApiKey(migrateApiKeyRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ProcessMintingUseCaseRequestDTO} processMintingUseCaseRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mintNft(processMintingUseCaseRequestDTO, options) {
            return exports.DefaultApiFp(configuration).mintNft(processMintingUseCaseRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        myProfile(options) {
            return exports.DefaultApiFp(configuration).myProfile(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UpdateCustomerRequestDTO} updateCustomerRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgUpdateCustomer(updateCustomerRequestDTO, options) {
            return exports.DefaultApiFp(configuration).orgUpdateCustomer(updateCustomerRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PartnerCreateSingleTicketRequestDTO} partnerCreateSingleTicketRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerCreateSingleTicket(partnerCreateSingleTicketRequestDTO, options) {
            return exports.DefaultApiFp(configuration).partnerCreateSingleTicket(partnerCreateSingleTicketRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PartnerCreateTicketRequestDTO} partnerCreateTicketRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerCreateTickets(partnerCreateTicketRequestDTO, options) {
            return exports.DefaultApiFp(configuration).partnerCreateTickets(partnerCreateTicketRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} showId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerGetShow(showId, options) {
            return exports.DefaultApiFp(configuration).partnerGetShow(showId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PartnerRevokeTicketRequestDTO} partnerRevokeTicketRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerRevokeTickets(partnerRevokeTicketRequestDTO, options) {
            return exports.DefaultApiFp(configuration).partnerRevokeTickets(partnerRevokeTicketRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} type
         * @param {PresenterAuthCallbackRequestDTO} presenterAuthCallbackRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        presenterAuthCallback(type, presenterAuthCallbackRequestDTO, options) {
            return exports.DefaultApiFp(configuration).presenterAuthCallback(type, presenterAuthCallbackRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PresenterCreateTicketRequestDTO} presenterCreateTicketRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        presenterCreateTickets(presenterCreateTicketRequestDTO, options) {
            return exports.DefaultApiFp(configuration).presenterCreateTickets(presenterCreateTicketRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} showId
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 10000
         * @param {boolean} [excludePast]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        presenterListShowTicketStats(showId, startAfter, limit, excludePast, options) {
            return exports.DefaultApiFp(configuration).presenterListShowTicketStats(showId, startAfter, limit, excludePast, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PresenterReassignTicketRequestDTO} presenterReassignTicketRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        presenterReassignTicket(presenterReassignTicketRequestDTO, options) {
            return exports.DefaultApiFp(configuration).presenterReassignTicket(presenterReassignTicketRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        presenterStitchConnection(type, options) {
            return exports.DefaultApiFp(configuration).presenterStitchConnection(type, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SNSNotificationType} xAmzSnsMessageType
         * @param {string} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receiveMintingTopicNotification(xAmzSnsMessageType, body, options) {
            return exports.DefaultApiFp(configuration).receiveMintingTopicNotification(xAmzSnsMessageType, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Invitations
         * @param {PresenterOrganizationRemoveMemberDTO} presenterOrganizationRemoveMemberDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeOrgMember(presenterOrganizationRemoveMemberDTO, options) {
            return exports.DefaultApiFp(configuration).removeOrgMember(presenterOrganizationRemoveMemberDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {AdminReplayNotificationRequestDTO} adminReplayNotificationRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replayNotifications(id, adminReplayNotificationRequestDTO, options) {
            return exports.DefaultApiFp(configuration).replayNotifications(id, adminReplayNotificationRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} eventId
         * @param {SendNotificationParams} sendNotificationParams
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEventOpenNotification(eventId, sendNotificationParams, options) {
            return exports.DefaultApiFp(configuration).sendEventOpenNotification(eventId, sendNotificationParams, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ReadyCheckNotificationParams} readyCheckNotificationParams
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendReadyCheckNotification(readyCheckNotificationParams, options) {
            return exports.DefaultApiFp(configuration).sendReadyCheckNotification(readyCheckNotificationParams, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {StartPreRecordPreviewRequestDTO} startPreRecordPreviewRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startPreRecordPreview(startPreRecordPreviewRequestDTO, options) {
            return exports.DefaultApiFp(configuration).startPreRecordPreview(startPreRecordPreviewRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} subdomain
         * @param {CobrandSurveyRequestDTO} cobrandSurveyRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeSurveyResponse(subdomain, cobrandSurveyRequestDTO, options) {
            return exports.DefaultApiFp(configuration).storeSurveyResponse(subdomain, cobrandSurveyRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} stripeSignature
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stripeSubscriptions(stripeSignature, options) {
            return exports.DefaultApiFp(configuration).stripeSubscriptions(stripeSignature, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PushSubscriptionResponseDTO} pushSubscriptionResponseDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscriptionToTopic(pushSubscriptionResponseDTO, options) {
            return exports.DefaultApiFp(configuration).subscriptionToTopic(pushSubscriptionResponseDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} subdomain
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        surveyResponseConfirmation(subdomain, options) {
            return exports.DefaultApiFp(configuration).surveyResponseConfirmation(subdomain, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} subdomain
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        surveyResponseExists(subdomain, options) {
            return exports.DefaultApiFp(configuration).surveyResponseExists(subdomain, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {EmailRequestDTO} emailRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testSendEmail(emailRequestDTO, options) {
            return exports.DefaultApiFp(configuration).testSendEmail(emailRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} vipExperienceId
         * @param {UpdateJoinUrlRequest} updateJoinUrlRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleJoinState(vipExperienceId, updateJoinUrlRequest, options) {
            return exports.DefaultApiFp(configuration).toggleJoinState(vipExperienceId, updateJoinUrlRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} userId
         * @param {PresenterOrganizationRoleDTO} presenterOrganizationRoleDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unassignMemberRoles(userId, presenterOrganizationRoleDTO, options) {
            return exports.DefaultApiFp(configuration).unassignMemberRoles(userId, presenterOrganizationRoleDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PushSubscriptionResponseDTO} pushSubscriptionResponseDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsubscriptionFromTopic(pushSubscriptionResponseDTO, options) {
            return exports.DefaultApiFp(configuration).unsubscriptionFromTopic(pushSubscriptionResponseDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} vipExperienceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateArtistJoinUrl(vipExperienceId, options) {
            return exports.DefaultApiFp(configuration).updateArtistJoinUrl(vipExperienceId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} customerId
         * @param {UpdateCustomerRequestDTO} updateCustomerRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomer(customerId, updateCustomerRequestDTO, options) {
            return exports.DefaultApiFp(configuration).updateCustomer(customerId, updateCustomerRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UpdateMyProfileRequestDTO} updateMyProfileRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyProfile(updateMyProfileRequestDTO, options) {
            return exports.DefaultApiFp(configuration).updateMyProfile(updateMyProfileRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {AdminUpdateNftTokenTransactionRequestDTO} adminUpdateNftTokenTransactionRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNftTokenTransaction(id, adminUpdateNftTokenTransactionRequestDTO, options) {
            return exports.DefaultApiFp(configuration).updateNftTokenTransaction(id, adminUpdateNftTokenTransactionRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} participantId
         * @param {VIPExperienceParticipantUpdate} vIPExperienceParticipantUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateParticipant(participantId, vIPExperienceParticipantUpdate, options) {
            return exports.DefaultApiFp(configuration).updateParticipant(participantId, vIPExperienceParticipantUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} paymentMethodId
         * @param {UpdatePaymentMethodRequestDTO} updatePaymentMethodRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePaymentMethods(paymentMethodId, updatePaymentMethodRequestDTO, options) {
            return exports.DefaultApiFp(configuration).updatePaymentMethods(paymentMethodId, updatePaymentMethodRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} productId
         * @param {AdminUpdateProductRequestDTO} adminUpdateProductRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProduct(productId, adminUpdateProductRequestDTO, options) {
            return exports.DefaultApiFp(configuration).updateProduct(productId, adminUpdateProductRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} subscriptionId
         * @param {UpdateSubscriptionRequestDTO} updateSubscriptionRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscription(subscriptionId, updateSubscriptionRequestDTO, options) {
            return exports.DefaultApiFp(configuration).updateSubscription(subscriptionId, updateSubscriptionRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UpdateTopicSubscriptionUseCaseRequestDTO} updateTopicSubscriptionUseCaseRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscriptionToTopic(updateTopicSubscriptionUseCaseRequestDTO, options) {
            return exports.DefaultApiFp(configuration).updateSubscriptionToTopic(updateTopicSubscriptionUseCaseRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} participantId
         * @param {VIPExperienceParticipantStatusUpdates} vIPExperienceParticipantStatusUpdates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVIPExperienceParticipantStatus(participantId, vIPExperienceParticipantStatusUpdates, options) {
            return exports.DefaultApiFp(configuration).updateVIPExperienceParticipantStatus(participantId, vIPExperienceParticipantStatusUpdates, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UpgradeSubscriptionRequestDTO} upgradeSubscriptionRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upgradeSubscription(upgradeSubscriptionRequestDTO, options) {
            return exports.DefaultApiFp(configuration).upgradeSubscription(upgradeSubscriptionRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} productId
         * @param {AdminUploadImageRequestDTO} adminUploadImageRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadImage(productId, adminUploadImageRequestDTO, options) {
            return exports.DefaultApiFp(configuration).uploadImage(productId, adminUploadImageRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AdminUploadNftAssetDTO} adminUploadNftAssetDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadNftAsset(adminUploadNftAssetDTO, options) {
            return exports.DefaultApiFp(configuration).uploadNftAsset(adminUploadNftAssetDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {VIPExperiencePhotoUploadRequest} vIPExperiencePhotoUploadRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadVIPMeetPhoto(vIPExperiencePhotoUploadRequest, options) {
            return exports.DefaultApiFp(configuration).uploadVIPMeetPhoto(vIPExperiencePhotoUploadRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {boolean} [excludePast]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewMyTickets(startAfter, limit, excludePast, options) {
            return exports.DefaultApiFp(configuration).viewMyTickets(startAfter, limit, excludePast, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
class DefaultApi extends base_1.BaseAPI {
    /**
     *
     * @param {DefaultApiAcceptConsentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    acceptConsent(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).acceptConsent(requestParameters.acceptConsentRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    acceptTOS(options) {
        return exports.DefaultApiFp(this.configuration).acceptTOS(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiAddSurveyToEventRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    addSurveyToEvent(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).addSurveyToEvent(requestParameters.createCsatSurveyEntryRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiAdminAddIAPPriceMapItemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminAddIAPPriceMapItem(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).adminAddIAPPriceMapItem(requestParameters.updateIAPPriceMapDTOItem, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiAdminApprovePreRecordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminApprovePreRecord(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).adminApprovePreRecord(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiAdminChangeShowStateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminChangeShowState(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).adminChangeShowState(requestParameters.id, requestParameters.inlineObject1, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiAdminCreateArtistRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminCreateArtist(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).adminCreateArtist(requestParameters.adminCreateArtistRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiAdminCreateCobrandRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminCreateCobrand(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).adminCreateCobrand(requestParameters.adminCreateCobrandRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiAdminCreateEventSetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminCreateEventSet(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).adminCreateEventSet(requestParameters.iCreateEventSetBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiAdminCreateEventStreamDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminCreateEventStreamDetails(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).adminCreateEventStreamDetails(requestParameters.adminCreateEventStreamDetailsRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiAdminCreateIAPConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminCreateIAPConfig(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).adminCreateIAPConfig(requestParameters.createIAPConfigRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiAdminCreateNftTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminCreateNftToken(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).adminCreateNftToken(requestParameters.adminCreateNftTokenRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiAdminCreateOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminCreateOrganization(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).adminCreateOrganization(requestParameters.adminCreateOrganizationRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiAdminCreateShowRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminCreateShow(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).adminCreateShow(requestParameters.adminCreateShowRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiAdminCreateVenueRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminCreateVenue(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).adminCreateVenue(requestParameters.adminCreateVenueRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiAdminCreateVideoAssetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminCreateVideoAsset(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).adminCreateVideoAsset(requestParameters.createVideoAssetDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminCreateVideoAssetUploadUrl(options) {
        return exports.DefaultApiFp(this.configuration).adminCreateVideoAssetUploadUrl(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiAdminDeleteArtistRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminDeleteArtist(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).adminDeleteArtist(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiAdminDeleteCobrandRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminDeleteCobrand(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).adminDeleteCobrand(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiAdminDeleteEventStreamDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminDeleteEventStreamDetails(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).adminDeleteEventStreamDetails(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiAdminDeleteIAPConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminDeleteIAPConfig(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).adminDeleteIAPConfig(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiAdminDeleteNftTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminDeleteNftToken(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).adminDeleteNftToken(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiAdminDeleteOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminDeleteOrganization(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).adminDeleteOrganization(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiAdminDeleteShopifyStoreRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminDeleteShopifyStore(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).adminDeleteShopifyStore(requestParameters.adminDeleteShopifyStoreRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiAdminDeleteShowRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminDeleteShow(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).adminDeleteShow(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiAdminDeleteVenueRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminDeleteVenue(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).adminDeleteVenue(requestParameters.venueId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiAdminDeleteVideoAssetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminDeleteVideoAsset(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).adminDeleteVideoAsset(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiAdminEditShowRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminEditShow(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).adminEditShow(requestParameters.id, requestParameters.adminEditShowRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiAdminEventSetAddEventsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminEventSetAddEvents(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).adminEventSetAddEvents(requestParameters.id, requestParameters.iAddEventsBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiAdminEventSetRemoveEventsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminEventSetRemoveEvents(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).adminEventSetRemoveEvents(requestParameters.id, requestParameters.iRemoveEventsBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiAdminGetEventSetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminGetEventSet(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).adminGetEventSet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiAdminGetEventStreamDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminGetEventStreamDetails(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).adminGetEventStreamDetails(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiAdminGetIAPConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminGetIAPConfig(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).adminGetIAPConfig(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminGetIAPPriceMap(options) {
        return exports.DefaultApiFp(this.configuration).adminGetIAPPriceMap(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiAdminGetOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminGetOrganization(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).adminGetOrganization(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiAdminGetShowRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminGetShow(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).adminGetShow(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns the stream details to the passed show for the currently authenticated user.  - includes ephemeral signed URLs for the both the public and admin replay tool endpoints    (the admin one simply allows viewing a replay with any trim values)
     * @param {DefaultApiAdminGetShowStreamDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminGetShowStreamDetails(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).adminGetShowStreamDetails(requestParameters.showId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminListAppleInAppPurchaseProduct(options) {
        return exports.DefaultApiFp(this.configuration).adminListAppleInAppPurchaseProduct(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiAdminListEventSetsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminListEventSets(requestParameters = {}, options) {
        return exports.DefaultApiFp(this.configuration).adminListEventSets(requestParameters.sortBy, requestParameters.sortOrder, requestParameters.startAfter, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiAdminListIAPConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminListIAPConfig(requestParameters = {}, options) {
        return exports.DefaultApiFp(this.configuration).adminListIAPConfig(requestParameters.id, requestParameters.eventId, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.startAfter, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiAdminListOrganizationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminListOrganizations(requestParameters = {}, options) {
        return exports.DefaultApiFp(this.configuration).adminListOrganizations(requestParameters.sortBy, requestParameters.sortOrder, requestParameters.startAfter, requestParameters.limit, requestParameters.name, requestParameters.displayName, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiAdminListShowsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminListShows(requestParameters = {}, options) {
        return exports.DefaultApiFp(this.configuration).adminListShows(requestParameters.cobrand, requestParameters.venueId, requestParameters.artistId, requestParameters.organizationId, requestParameters.type, requestParameters.shopifyProductTag, requestParameters.shopifyMerchTag, requestParameters.muxId, requestParameters.autoSchedule, requestParameters.state, requestParameters.beforeDate, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.startAfter, requestParameters.limit, requestParameters.excludePast, requestParameters.include, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiAdminListShowsByManagerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminListShowsByManager(requestParameters = {}, options) {
        return exports.DefaultApiFp(this.configuration).adminListShowsByManager(requestParameters.managerId, requestParameters.email, requestParameters.startAfter, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiAdminListVideoAssetsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminListVideoAssets(requestParameters = {}, options) {
        return exports.DefaultApiFp(this.configuration).adminListVideoAssets(requestParameters.startAfter, requestParameters.limit, requestParameters.eventId, requestParameters.artistId, requestParameters.venueId, requestParameters.organizationId, requestParameters.search, requestParameters.tags, requestParameters.videoAssetIsPublic, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiAdminRemoveIAPPriceMapItemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminRemoveIAPPriceMapItem(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).adminRemoveIAPPriceMapItem(requestParameters.inlineObject, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiAdminSpotifyRefreshRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminSpotifyRefresh(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).adminSpotifyRefresh(requestParameters.id, requestParameters.minDays, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiAdminUpdateArtistRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminUpdateArtist(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).adminUpdateArtist(requestParameters.id, requestParameters.adminUpdateArtistRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiAdminUpdateCobrandRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminUpdateCobrand(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).adminUpdateCobrand(requestParameters.id, requestParameters.adminUpdateCobrandRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiAdminUpdateEventStreamDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminUpdateEventStreamDetails(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).adminUpdateEventStreamDetails(requestParameters.id, requestParameters.iUpdateEventStreamDetailsUseCase, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiAdminUpdateIAPConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminUpdateIAPConfig(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).adminUpdateIAPConfig(requestParameters.id, requestParameters.updateIAPConfigRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiAdminUpdateNftTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminUpdateNftToken(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).adminUpdateNftToken(requestParameters.id, requestParameters.adminUpdateNftTokenRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiAdminUpdateOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminUpdateOrganization(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).adminUpdateOrganization(requestParameters.id, requestParameters.adminUpdateOrganizationRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiAdminUpdateShopifyStoreRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminUpdateShopifyStore(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).adminUpdateShopifyStore(requestParameters.adminUpdateShopifyStoreRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiAdminUpdateVenueRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminUpdateVenue(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).adminUpdateVenue(requestParameters.venueId, requestParameters.adminUpdateVenueRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiAdminUpdateVideoAssetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminUpdateVideoAsset(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).adminUpdateVideoAsset(requestParameters.updateVideoAssetRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiAssignMemberRolesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    assignMemberRoles(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).assignMemberRoles(requestParameters.userId, requestParameters.presenterOrganizationRoleDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiAssociateFileDefinitionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    associateFileDefinition(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).associateFileDefinition(requestParameters.associateFileDefinitionRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiAttachPaymentMethodToCustomerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    attachPaymentMethodToCustomer(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).attachPaymentMethodToCustomer(requestParameters.paymentMethodId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiBandsintownListShowsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    bandsintownListShows(requestParameters = {}, options) {
        return exports.DefaultApiFp(this.configuration).bandsintownListShows(requestParameters.venueId, requestParameters.artistId, requestParameters.startAfter, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiCheckForUserSubscriptionByTopicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    checkForUserSubscriptionByTopic(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).checkForUserSubscriptionByTopic(requestParameters.topic, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiCheckForUserSurveyResponseByEventIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    checkForUserSurveyResponseByEventId(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).checkForUserSurveyResponseByEventId(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiCheckInToVIPExperienceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    checkInToVIPExperience(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).checkInToVIPExperience(requestParameters.eventId, requestParameters.vIPExperienceCheckInRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiClaimByCodeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    claimByCode(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).claimByCode(requestParameters.claimByCodeRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiClaimExternalTicketRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    claimExternalTicket(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).claimExternalTicket(requestParameters.externalShowId, requestParameters.externalCredential, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    claimMyTickets(options) {
        return exports.DefaultApiFp(this.configuration).claimMyTickets(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiCompleteAppleIAPOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    completeAppleIAPOrder(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).completeAppleIAPOrder(requestParameters.id, requestParameters.completeAppleIAPOrderRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiCompletePreRecordUploadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    completePreRecordUpload(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).completePreRecordUpload(requestParameters.completeMultipartUploadRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiCreateAppleIAPOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    createAppleIAPOrder(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).createAppleIAPOrder(requestParameters.createAppleIAPOrderRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiCreateGeneralSurveyResponseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    createGeneralSurveyResponse(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).createGeneralSurveyResponse(requestParameters.generalSurveyResponseDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiCreateNftTokenTransactionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    createNftTokenTransaction(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).createNftTokenTransaction(requestParameters.adminCreateNftTokenTransactionRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiCreatePreRecordUploadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    createPreRecordUpload(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).createPreRecordUpload(requestParameters.createMultipartUploadRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiCreateProductForShowRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    createProductForShow(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).createProductForShow(requestParameters.adminUpdateProductRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiCreateSubscriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    createSubscription(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).createSubscription(requestParameters.createSubscriptionRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiCreateSurveyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    createSurvey(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).createSurvey(requestParameters.createCsatSurveyRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiCreateSurveyResponseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    createSurveyResponse(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).createSurveyResponse(requestParameters.csatSurveyResponseDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiCreateVIPExperienceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    createVIPExperience(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).createVIPExperience(requestParameters.showId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiDeleteApiKeyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    deleteApiKey(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).deleteApiKey(requestParameters.deleteApiKeyRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiDeletePaymentMethodRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    deletePaymentMethod(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).deletePaymentMethod(requestParameters.paymentMethodId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiEnableMasterAccessForAssetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    enableMasterAccessForAsset(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).enableMasterAccessForAsset(requestParameters.assetId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiExternalLoginRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    externalLogin(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).externalLogin(requestParameters.externalAuthRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiGeneralSurveyResponsesBySurveyIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    generalSurveyResponsesBySurveyId(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).generalSurveyResponsesBySurveyId(requestParameters.surveyIdentifier, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiGenerateApiKeyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    generateApiKey(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).generateApiKey(requestParameters.generateApiKeyRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiGenerateCustomTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    generateCustomToken(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).generateCustomToken(requestParameters.generateCustomTokenRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiGenerateVIPExperienceCallTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    generateVIPExperienceCallToken(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).generateVIPExperienceCallToken(requestParameters.vIPExperienceCallTokenRequestParams, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiGetAllSubscriptionsByTopicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getAllSubscriptionsByTopic(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).getAllSubscriptionsByTopic(requestParameters.topic, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getAllUsersSubscriptions(options) {
        return exports.DefaultApiFp(this.configuration).getAllUsersSubscriptions(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiGetAppleIAPOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getAppleIAPOrder(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).getAppleIAPOrder(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiGetArtistRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getArtist(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).getArtist(requestParameters.artistId, requestParameters.includeUpcomingEventsCount, requestParameters.includePastEventsCount, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiGetAssetContentTypeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getAssetContentType(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).getAssetContentType(requestParameters.nftAssetContentTypeRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiGetChatRoomRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getChatRoom(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).getChatRoom(requestParameters.showId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiGetChatRoomByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getChatRoomById(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).getChatRoomById(requestParameters.chatRoomId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getChatToken(options) {
        return exports.DefaultApiFp(this.configuration).getChatToken(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiGetChatTranscriptsLinkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getChatTranscriptsLink(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).getChatTranscriptsLink(requestParameters.showId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiGetCobrandRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getCobrand(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).getCobrand(requestParameters.subdomain, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getCurrentOrganization(options) {
        return exports.DefaultApiFp(this.configuration).getCurrentOrganization(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getCustomer(options) {
        return exports.DefaultApiFp(this.configuration).getCustomer(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns the stream details to the passed show for the currently authenticated user, given one of the following 1. The show is ticketed and the user has a ticket for the show (@todo check entitlement type) 2. The show is unticketed 3. The user is an admin 4. The user is a show manager  Includes an ephemeral signed URL for the public replay tool endpoint   (only the trimmed version of the replay is accessible)
     * @param {DefaultApiGetEventStreamDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getEventStreamDetails(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).getEventStreamDetails(requestParameters.showId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiGetFanNavigatorPricesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getFanNavigatorPrices(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).getFanNavigatorPrices(requestParameters.searchQuery, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getIntegrations(options) {
        return exports.DefaultApiFp(this.configuration).getIntegrations(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiGetLatestPinnedStreamChatMessagesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getLatestPinnedStreamChatMessages(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).getLatestPinnedStreamChatMessages(requestParameters.channelId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getMailchimpAudiences(options) {
        return exports.DefaultApiFp(this.configuration).getMailchimpAudiences(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiGetMuxAssetsForLivestreamRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getMuxAssetsForLivestream(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).getMuxAssetsForLivestream(requestParameters.livestreamId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiGetNftTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getNftToken(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).getNftToken(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getPaymentInformation(options) {
        return exports.DefaultApiFp(this.configuration).getPaymentInformation(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getPaymentMethods(options) {
        return exports.DefaultApiFp(this.configuration).getPaymentMethods(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiGetPreSignedUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getPreSignedUrl(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).getPreSignedUrl(requestParameters.uploadDate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiGetProductPriceInformationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getProductPriceInformation(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).getProductPriceInformation(requestParameters.productId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiGetResponsesBySurveyIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getResponsesBySurveyId(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).getResponsesBySurveyId(requestParameters.surveyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiGetShopifyStoreRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getShopifyStore(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).getShopifyStore(requestParameters.storeUrl, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiGetShowRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getShow(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).getShow(requestParameters.showId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns the stream details to the passed show for the currently authenticated user, given one of the following 1. The show is ticketed and the user has a ticket for the show (@todo check entitlement type) 2. The show is unticketed 3. The user is an admin 4. The user is a show manager  Includes an ephemeral signed URL for the public replay tool endpoint   (only the trimmed version of the replay is accessible)
     * @param {DefaultApiGetShowStreamDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getShowStreamDetails(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).getShowStreamDetails(requestParameters.showId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiGetStreamChatMessagesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getStreamChatMessages(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).getStreamChatMessages(requestParameters.channelId, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiGetSubscribedUserChatroomsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getSubscribedUserChatrooms(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).getSubscribedUserChatrooms(requestParameters.showId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getSubscriptionInformation(options) {
        return exports.DefaultApiFp(this.configuration).getSubscriptionInformation(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiGetSurveyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getSurvey(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).getSurvey(requestParameters.surveyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getTOSAcceptance(options) {
        return exports.DefaultApiFp(this.configuration).getTOSAcceptance(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiGetVIPExperienceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getVIPExperience(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).getVIPExperience(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiGetVIPExperienceAllowJoiningInfoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getVIPExperienceAllowJoiningInfo(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).getVIPExperienceAllowJoiningInfo(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiGetVIPExperienceParticipantsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getVIPExperienceParticipants(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).getVIPExperienceParticipants(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiGetVenueRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getVenue(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).getVenue(requestParameters.venueId, requestParameters.includeUpcomingEventsCount, requestParameters.includePastEventsCount, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    health(options) {
        return exports.DefaultApiFp(this.configuration).health(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiIVotedLoginRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    iVotedLogin(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).iVotedLogin(requestParameters.iVotedAuthRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Creates Mandolin users and associates the provided ivoted externalID with that user for the purposes of allowing authentication. The returned response echoes the input, and will either include a jwt in the `token` field, or an `error` object with details on why that particular operation failed. The order of users in the response is not guaranteed to match the input order.  Authentication is handled via the `X-Api-Key` header. Its value should be set to `apiKey:secret`, where \"apiKey\" is the API key and \"secret\" is the secret value associated with that key.
     * @param {DefaultApiIVotedUsersCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    iVotedUsersCreate(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).iVotedUsersCreate(requestParameters.iVotedCreateUserRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiInviteOrgMemberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    inviteOrgMember(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).inviteOrgMember(requestParameters.presenterOrganizationInviteMemberDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiJamBaseListShowsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    jamBaseListShows(requestParameters = {}, options) {
        return exports.DefaultApiFp(this.configuration).jamBaseListShows(requestParameters.venueId, requestParameters.artistId, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.startAfter, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiJoinChannelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    joinChannel(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).joinChannel(requestParameters.joinChannelRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiJoinVIPExperienceAsArtistRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    joinVIPExperienceAsArtist(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).joinVIPExperienceAsArtist(requestParameters.t, requestParameters.name, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiListArtistsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    listArtists(requestParameters = {}, options) {
        return exports.DefaultApiFp(this.configuration).listArtists(requestParameters.sortBy, requestParameters.sortOrder, requestParameters.startAfter, requestParameters.limit, requestParameters.isFeatured, requestParameters.cobrand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiListAudienceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    listAudience(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).listAudience(requestParameters.showId, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.limit, requestParameters.include, requestParameters.status, requestParameters.startAfter, requestParameters.ticketIds, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiListCobrandsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    listCobrands(requestParameters = {}, options) {
        return exports.DefaultApiFp(this.configuration).listCobrands(requestParameters.sortBy, requestParameters.sortOrder, requestParameters.startAfter, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiListMemberRolesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    listMemberRoles(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).listMemberRoles(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    listMembers(options) {
        return exports.DefaultApiFp(this.configuration).listMembers(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiListMyApiKeysRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    listMyApiKeys(requestParameters = {}, options) {
        return exports.DefaultApiFp(this.configuration).listMyApiKeys(requestParameters.startAfter, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiListMyShowsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    listMyShows(requestParameters = {}, options) {
        return exports.DefaultApiFp(this.configuration).listMyShows(requestParameters.cobrand, requestParameters.venueId, requestParameters.artistId, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.startAfter, requestParameters.limit, requestParameters.excludePast, requestParameters.include, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiListNftTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    listNftToken(requestParameters = {}, options) {
        return exports.DefaultApiFp(this.configuration).listNftToken(requestParameters.sortBy, requestParameters.sortOrder, requestParameters.startAfter, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiListNftTokenTransactionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    listNftTokenTransaction(requestParameters = {}, options) {
        return exports.DefaultApiFp(this.configuration).listNftTokenTransaction(requestParameters.sortBy, requestParameters.sortOrder, requestParameters.startAfter, requestParameters.limit, requestParameters.includeMinted, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiListProductsByTagRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    listProductsByTag(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).listProductsByTag(requestParameters.tag, requestParameters.sortBy, requestParameters.sortOrder, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiListShopifyStoresRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    listShopifyStores(requestParameters = {}, options) {
        return exports.DefaultApiFp(this.configuration).listShopifyStores(requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiListShowsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    listShows(requestParameters = {}, options) {
        return exports.DefaultApiFp(this.configuration).listShows(requestParameters.cobrand, requestParameters.venueId, requestParameters.artistId, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.startAfter, requestParameters.limit, requestParameters.excludePast, requestParameters.iosOnlyShows, requestParameters.include, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiListSurveyReponsesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    listSurveyReponses(requestParameters = {}, options) {
        return exports.DefaultApiFp(this.configuration).listSurveyReponses(requestParameters.siteId, requestParameters.slug, requestParameters.surveyIdentifier, requestParameters.sortOrder, requestParameters.limit, requestParameters.startAfter, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiListSurveysRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    listSurveys(requestParameters = {}, options) {
        return exports.DefaultApiFp(this.configuration).listSurveys(requestParameters.sortBy, requestParameters.sortOrder, requestParameters.startAfter, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiListVenuesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    listVenues(requestParameters = {}, options) {
        return exports.DefaultApiFp(this.configuration).listVenues(requestParameters.sortBy, requestParameters.sortOrder, requestParameters.startAfter, requestParameters.limit, requestParameters.isFeatured, requestParameters.cobrand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiManagerChangeShowChatStateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    managerChangeShowChatState(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).managerChangeShowChatState(requestParameters.id, requestParameters.managerChangeShowChatStateRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiManagerChangeShowStateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    managerChangeShowState(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).managerChangeShowState(requestParameters.id, requestParameters.managerChangeShowStateRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiManagerGetShowRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    managerGetShow(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).managerGetShow(requestParameters.showId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiManagerListManagedShowsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    managerListManagedShows(requestParameters = {}, options) {
        return exports.DefaultApiFp(this.configuration).managerListManagedShows(requestParameters.artistId, requestParameters.cobrand, requestParameters.state, requestParameters.type, requestParameters.venueId, requestParameters.beforeDate, requestParameters.afterDate, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.startAfter, requestParameters.limit, requestParameters.include, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiManagerListShowsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    managerListShows(requestParameters = {}, options) {
        return exports.DefaultApiFp(this.configuration).managerListShows(requestParameters.sortBy, requestParameters.sortOrder, requestParameters.startAfter, requestParameters.shopifyProductTag, requestParameters.shopifyMerchTag, requestParameters.limit, requestParameters.excludePast, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiMigrateApiKeyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    migrateApiKey(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).migrateApiKey(requestParameters.migrateApiKeyRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiMintNftRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    mintNft(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).mintNft(requestParameters.processMintingUseCaseRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    myProfile(options) {
        return exports.DefaultApiFp(this.configuration).myProfile(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiOrgUpdateCustomerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    orgUpdateCustomer(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).orgUpdateCustomer(requestParameters.updateCustomerRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiPartnerCreateSingleTicketRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    partnerCreateSingleTicket(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).partnerCreateSingleTicket(requestParameters.partnerCreateSingleTicketRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiPartnerCreateTicketsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    partnerCreateTickets(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).partnerCreateTickets(requestParameters.partnerCreateTicketRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiPartnerGetShowRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    partnerGetShow(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).partnerGetShow(requestParameters.showId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiPartnerRevokeTicketsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    partnerRevokeTickets(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).partnerRevokeTickets(requestParameters.partnerRevokeTicketRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiPresenterAuthCallbackRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    presenterAuthCallback(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).presenterAuthCallback(requestParameters.type, requestParameters.presenterAuthCallbackRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiPresenterCreateTicketsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    presenterCreateTickets(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).presenterCreateTickets(requestParameters.presenterCreateTicketRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiPresenterListShowTicketStatsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    presenterListShowTicketStats(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).presenterListShowTicketStats(requestParameters.showId, requestParameters.startAfter, requestParameters.limit, requestParameters.excludePast, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiPresenterReassignTicketRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    presenterReassignTicket(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).presenterReassignTicket(requestParameters.presenterReassignTicketRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiPresenterStitchConnectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    presenterStitchConnection(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).presenterStitchConnection(requestParameters.type, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiReceiveMintingTopicNotificationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    receiveMintingTopicNotification(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).receiveMintingTopicNotification(requestParameters.xAmzSnsMessageType, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Invitations
     * @param {DefaultApiRemoveOrgMemberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    removeOrgMember(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).removeOrgMember(requestParameters.presenterOrganizationRemoveMemberDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiReplayNotificationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    replayNotifications(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).replayNotifications(requestParameters.id, requestParameters.adminReplayNotificationRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiSendEventOpenNotificationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    sendEventOpenNotification(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).sendEventOpenNotification(requestParameters.eventId, requestParameters.sendNotificationParams, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiSendReadyCheckNotificationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    sendReadyCheckNotification(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).sendReadyCheckNotification(requestParameters.readyCheckNotificationParams, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiStartPreRecordPreviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    startPreRecordPreview(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).startPreRecordPreview(requestParameters.startPreRecordPreviewRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiStoreSurveyResponseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    storeSurveyResponse(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).storeSurveyResponse(requestParameters.subdomain, requestParameters.cobrandSurveyRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiStripeSubscriptionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    stripeSubscriptions(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).stripeSubscriptions(requestParameters.stripeSignature, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiSubscriptionToTopicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    subscriptionToTopic(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).subscriptionToTopic(requestParameters.pushSubscriptionResponseDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiSurveyResponseConfirmationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    surveyResponseConfirmation(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).surveyResponseConfirmation(requestParameters.subdomain, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiSurveyResponseExistsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    surveyResponseExists(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).surveyResponseExists(requestParameters.subdomain, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiTestSendEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    testSendEmail(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).testSendEmail(requestParameters.emailRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiToggleJoinStateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    toggleJoinState(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).toggleJoinState(requestParameters.vipExperienceId, requestParameters.updateJoinUrlRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiUnassignMemberRolesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    unassignMemberRoles(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).unassignMemberRoles(requestParameters.userId, requestParameters.presenterOrganizationRoleDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiUnsubscriptionFromTopicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    unsubscriptionFromTopic(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).unsubscriptionFromTopic(requestParameters.pushSubscriptionResponseDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiUpdateArtistJoinUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    updateArtistJoinUrl(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).updateArtistJoinUrl(requestParameters.vipExperienceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiUpdateCustomerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    updateCustomer(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).updateCustomer(requestParameters.customerId, requestParameters.updateCustomerRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiUpdateMyProfileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    updateMyProfile(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).updateMyProfile(requestParameters.updateMyProfileRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiUpdateNftTokenTransactionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    updateNftTokenTransaction(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).updateNftTokenTransaction(requestParameters.id, requestParameters.adminUpdateNftTokenTransactionRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiUpdateParticipantRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    updateParticipant(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).updateParticipant(requestParameters.participantId, requestParameters.vIPExperienceParticipantUpdate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiUpdatePaymentMethodsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    updatePaymentMethods(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).updatePaymentMethods(requestParameters.paymentMethodId, requestParameters.updatePaymentMethodRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiUpdateProductRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    updateProduct(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).updateProduct(requestParameters.productId, requestParameters.adminUpdateProductRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiUpdateSubscriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    updateSubscription(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).updateSubscription(requestParameters.subscriptionId, requestParameters.updateSubscriptionRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiUpdateSubscriptionToTopicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    updateSubscriptionToTopic(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).updateSubscriptionToTopic(requestParameters.updateTopicSubscriptionUseCaseRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiUpdateVIPExperienceParticipantStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    updateVIPExperienceParticipantStatus(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).updateVIPExperienceParticipantStatus(requestParameters.participantId, requestParameters.vIPExperienceParticipantStatusUpdates, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiUpgradeSubscriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    upgradeSubscription(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).upgradeSubscription(requestParameters.upgradeSubscriptionRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiUploadImageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    uploadImage(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).uploadImage(requestParameters.productId, requestParameters.adminUploadImageRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiUploadNftAssetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    uploadNftAsset(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).uploadNftAsset(requestParameters.adminUploadNftAssetDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiUploadVIPMeetPhotoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    uploadVIPMeetPhoto(requestParameters, options) {
        return exports.DefaultApiFp(this.configuration).uploadVIPMeetPhoto(requestParameters.vIPExperiencePhotoUploadRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiViewMyTicketsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    viewMyTickets(requestParameters = {}, options) {
        return exports.DefaultApiFp(this.configuration).viewMyTickets(requestParameters.startAfter, requestParameters.limit, requestParameters.excludePast, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.DefaultApi = DefaultApi;
